import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpRequest, HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Subject, BehaviorSubject } from 'rxjs';
import { convertDependency } from '@azavista/advanced-search';

// Report
var EmailCampaignDeliveryStatus = /*#__PURE__*/function (EmailCampaignDeliveryStatus) {
  EmailCampaignDeliveryStatus["sent"] = "sent";
  EmailCampaignDeliveryStatus["opened"] = "opened";
  EmailCampaignDeliveryStatus["bounced"] = "bounced";
  EmailCampaignDeliveryStatus["unsubscribed"] = "unsubscribed";
  EmailCampaignDeliveryStatus["link_clicked"] = "link_clicked";
  return EmailCampaignDeliveryStatus;
}(EmailCampaignDeliveryStatus || {});
var FieldOperator = /*#__PURE__*/function (FieldOperator) {
  FieldOperator["equal"] = "eq";
  FieldOperator["notEqual"] = "not_eq";
  FieldOperator["like"] = "like";
  FieldOperator["notLike"] = "not_like";
  FieldOperator["in"] = "in";
  FieldOperator["notIn"] = "not_in";
  FieldOperator["lessThan"] = "lt";
  FieldOperator["lessThanOrEqual"] = "lte";
  FieldOperator["greaterThan"] = "gt";
  FieldOperator["greaterThanOrEqual"] = "gte";
  FieldOperator["empty"] = "empty";
  FieldOperator["notEmpty"] = "not_empty";
  FieldOperator["after"] = "after";
  FieldOperator["before"] = "before";
  return FieldOperator;
}(FieldOperator || {});
var EntityIdType = /*#__PURE__*/function (EntityIdType) {
  EntityIdType["internal"] = "internal";
  EntityIdType["external"] = "external";
  return EntityIdType;
}(EntityIdType || {});
;
var SocialPlatform = /*#__PURE__*/function (SocialPlatform) {
  SocialPlatform["Facebook"] = "Facebook";
  SocialPlatform["Linkedin"] = "Linkedin";
  SocialPlatform["Pinterest"] = "Pinterest";
  SocialPlatform["Twitter"] = "Twitter";
  SocialPlatform["Whatsapp"] = "Whatsapp";
  return SocialPlatform;
}(SocialPlatform || {});
var ProductModuleType = /*#__PURE__*/function (ProductModuleType) {
  ProductModuleType["global"] = "global";
  ProductModuleType["event"] = "event";
  return ProductModuleType;
}(ProductModuleType || {});
var IntegrationExternalCrmVersion = /*#__PURE__*/function (IntegrationExternalCrmVersion) {
  IntegrationExternalCrmVersion["v1_0"] = "1.0";
  IntegrationExternalCrmVersion["v2_0"] = "2.0";
  return IntegrationExternalCrmVersion;
}(IntegrationExternalCrmVersion || {});
var IExternalFieldMappingAzavistaEntity = /*#__PURE__*/function (IExternalFieldMappingAzavistaEntity) {
  IExternalFieldMappingAzavistaEntity["participant"] = "participant";
  IExternalFieldMappingAzavistaEntity["contact"] = "contact";
  IExternalFieldMappingAzavistaEntity["organization"] = "organization";
  IExternalFieldMappingAzavistaEntity["event"] = "event";
  return IExternalFieldMappingAzavistaEntity;
}(IExternalFieldMappingAzavistaEntity || {});
var IExternalFieldMappingFieldType = /*#__PURE__*/function (IExternalFieldMappingFieldType) {
  IExternalFieldMappingFieldType["text"] = "text";
  IExternalFieldMappingFieldType["email"] = "email";
  IExternalFieldMappingFieldType["string"] = "string";
  IExternalFieldMappingFieldType["url"] = "url";
  IExternalFieldMappingFieldType["number"] = "number";
  IExternalFieldMappingFieldType["boolean"] = "boolean";
  IExternalFieldMappingFieldType["integer"] = "integer";
  IExternalFieldMappingFieldType["select"] = "select";
  IExternalFieldMappingFieldType["multiSelect"] = "multi-select";
  IExternalFieldMappingFieldType["lookup"] = "lookup";
  IExternalFieldMappingFieldType["date"] = "date";
  IExternalFieldMappingFieldType["datetime"] = "datetime";
  IExternalFieldMappingFieldType["time"] = "time";
  IExternalFieldMappingFieldType["travelDate"] = "travel-date";
  IExternalFieldMappingFieldType["any"] = "any";
  return IExternalFieldMappingFieldType;
}(IExternalFieldMappingFieldType || {});
var ISap001IntegrationMappingExternalEntityType = /*#__PURE__*/function (ISap001IntegrationMappingExternalEntityType) {
  ISap001IntegrationMappingExternalEntityType["orderItem"] = "OrderItem";
  return ISap001IntegrationMappingExternalEntityType;
}(ISap001IntegrationMappingExternalEntityType || {});
var MessageBirdApiType = /*#__PURE__*/function (MessageBirdApiType) {
  MessageBirdApiType["messageBird"] = "messagebird";
  MessageBirdApiType["bird"] = "bird";
  return MessageBirdApiType;
}(MessageBirdApiType || {});
var IngenicoIntegrationAuthorizationMode = /*#__PURE__*/function (IngenicoIntegrationAuthorizationMode) {
  IngenicoIntegrationAuthorizationMode["finalAuthorization"] = "final_authorization";
  IngenicoIntegrationAuthorizationMode["preAuthorization"] = "pre_authorization";
  IngenicoIntegrationAuthorizationMode["sale"] = "sale";
  return IngenicoIntegrationAuthorizationMode;
}(IngenicoIntegrationAuthorizationMode || {});
var PayOneIntegrationAuthorizationMode = /*#__PURE__*/function (PayOneIntegrationAuthorizationMode) {
  PayOneIntegrationAuthorizationMode["finalAuthorization"] = "final_authorization";
  PayOneIntegrationAuthorizationMode["preAuthorization"] = "pre_authorization";
  PayOneIntegrationAuthorizationMode["sale"] = "sale";
  return PayOneIntegrationAuthorizationMode;
}(PayOneIntegrationAuthorizationMode || {});
var WebhookAuthType = /*#__PURE__*/function (WebhookAuthType) {
  WebhookAuthType["None"] = "none";
  WebhookAuthType["Basic"] = "basic";
  WebhookAuthType["OAuth"] = "oauth-client-credentials";
  return WebhookAuthType;
}(WebhookAuthType || {});
var ActivityParticipantStatus = /*#__PURE__*/function (ActivityParticipantStatus) {
  ActivityParticipantStatus["new"] = "new";
  ActivityParticipantStatus["waitingList"] = "waiting-list";
  ActivityParticipantStatus["paymentInProgress"] = "payment-in-progress";
  ActivityParticipantStatus["registered"] = "registered";
  ActivityParticipantStatus["registrationInProgress"] = "registration-in-progress";
  ActivityParticipantStatus["arrived"] = "arrived";
  ActivityParticipantStatus["approvalPending"] = "approval-pending";
  ActivityParticipantStatus["noShow"] = "no-show";
  return ActivityParticipantStatus;
}(ActivityParticipantStatus || {});
var WaitUntilFieldStepFieldType = /*#__PURE__*/function (WaitUntilFieldStepFieldType) {
  WaitUntilFieldStepFieldType["eventField"] = "EventField";
  WaitUntilFieldStepFieldType["participantField"] = "ParticipantField";
  return WaitUntilFieldStepFieldType;
}(WaitUntilFieldStepFieldType || {});
class AzavistaApiError {}
var IAccountingIntegrationLogStatus = /*#__PURE__*/function (IAccountingIntegrationLogStatus) {
  IAccountingIntegrationLogStatus["ok"] = "ok";
  IAccountingIntegrationLogStatus["error"] = "error";
  IAccountingIntegrationLogStatus["rescheduled"] = "rescheduled";
  IAccountingIntegrationLogStatus["inProgress"] = "inprogress";
  return IAccountingIntegrationLogStatus;
}(IAccountingIntegrationLogStatus || {});
var ParticipantAuditUserType = /*#__PURE__*/function (ParticipantAuditUserType) {
  ParticipantAuditUserType["user"] = "user";
  ParticipantAuditUserType["participant"] = "participant";
  ParticipantAuditUserType["workflow"] = "workflow";
  return ParticipantAuditUserType;
}(ParticipantAuditUserType || {});
var PageSubtype = /*#__PURE__*/function (PageSubtype) {
  PageSubtype["normal"] = "Normal";
  PageSubtype["eventApp"] = "EventApp";
  PageSubtype["designP\u0430ge"] = "DesignPage";
  PageSubtype["eventListing"] = "EventListing";
  PageSubtype["requestListing"] = "RequestListing";
  PageSubtype["orderListing"] = "OrderListing";
  PageSubtype["company"] = "Company";
  PageSubtype["subscription"] = "Subscription";
  PageSubtype["passwordReset"] = "PasswordReset";
  PageSubtype["emailReset"] = "EmailReset";
  PageSubtype["login"] = "Login";
  PageSubtype["header"] = "Header";
  PageSubtype["footer"] = "Footer";
  PageSubtype["participantPasswordReset"] = "ParticipantPasswordReset";
  PageSubtype["participantAccountCreation"] = "ParticipantAccountCreation";
  PageSubtype["participantConfirmationCode"] = "ParticipantConfirmationCode";
  PageSubtype["participantLoginLink"] = "ParticipantLoginLink";
  return PageSubtype;
}(PageSubtype || {});
const PagePageTypeSubtypes = {
  normal: PageSubtype.normal,
  eventApp: PageSubtype.eventApp,
  designPage: PageSubtype.designPаge
};
const ProfilePageTypeSubtypes = {
  eventlisting: PageSubtype.eventListing,
  requestlisting: PageSubtype.requestListing,
  orderlisting: PageSubtype.orderListing,
  company: PageSubtype.company,
  subscription: PageSubtype.subscription,
  passwordreset: PageSubtype.passwordReset,
  emailreset: PageSubtype.emailReset,
  login: PageSubtype.login
};
const EmailTemplatePageSubtypes = {
  normal: PageSubtype.normal
};
const SystemPageSubtypes = {
  [PageSubtype.participantAccountCreation]: PageSubtype.participantAccountCreation,
  [PageSubtype.participantConfirmationCode]: PageSubtype.participantConfirmationCode,
  [PageSubtype.participantPasswordReset]: PageSubtype.participantPasswordReset,
  [PageSubtype.participantLoginLink]: PageSubtype.participantLoginLink
};
const ThemePageTypeSubtypes = {
  header: PageSubtype.header,
  footer: PageSubtype.footer
};
const PageTypesWithSubtypes = {
  page: {
    type: "Page" /* PageType.page */,
    subtypes: PagePageTypeSubtypes
  },
  profile: {
    type: "Profile" /* PageType.profile */,
    subtypes: ProfilePageTypeSubtypes
  },
  emailtemplate: {
    type: "Emailtemplate" /* PageType.emailTemplate */,
    subtypes: EmailTemplatePageSubtypes
  },
  theme: {
    type: "Theme" /* PageType.theme */,
    subtypes: ThemePageTypeSubtypes
  },
  ["System" /* PageType.system */]: {
    type: "System" /* PageType.system */,
    subtypes: SystemPageSubtypes
  }
};
// Project
var IProjectStatus = /*#__PURE__*/function (IProjectStatus) {
  IProjectStatus["notStarted"] = "NotStarted";
  IProjectStatus["inProgress"] = "InProgress";
  IProjectStatus["completed"] = "Completed";
  IProjectStatus["cancelled"] = "Cancelled";
  return IProjectStatus;
}(IProjectStatus || {});
var ProjectType = /*#__PURE__*/function (ProjectType) {
  ProjectType["project"] = "Project";
  ProjectType["template"] = "Template";
  return ProjectType;
}(ProjectType || {});
// Project -- Tasks
var IProjectTaskStatus = /*#__PURE__*/function (IProjectTaskStatus) {
  IProjectTaskStatus["notStarted"] = "NotStarted";
  IProjectTaskStatus["inProgress"] = "InProgress";
  IProjectTaskStatus["completed"] = "Completed";
  IProjectTaskStatus["cancelled"] = "Cancelled";
  return IProjectTaskStatus;
}(IProjectTaskStatus || {});
var IProjectTaskPriority = /*#__PURE__*/function (IProjectTaskPriority) {
  IProjectTaskPriority["low"] = "Low";
  IProjectTaskPriority["moderate"] = "Moderate";
  IProjectTaskPriority["high"] = "High";
  IProjectTaskPriority["urgent"] = "Urgent";
  return IProjectTaskPriority;
}(IProjectTaskPriority || {});
var EmailCampaignAudienceModuleType = /*#__PURE__*/function (EmailCampaignAudienceModuleType) {
  EmailCampaignAudienceModuleType["activity"] = "Activity";
  return EmailCampaignAudienceModuleType;
}(EmailCampaignAudienceModuleType || {});
class AzavistaApiUtilsServiceBase {
  constructor() {
    this.authResponseStorageKey = 'azavista.apiService.authResponse';
    this.allowedAccessTokenLifePercentage = 95;
    this.paths = {
      token: 'oauth/token',
      users: {
        getSingle: 'user',
        password: 'user/password',
        resetPassword: 'user/password/reset_link/public',
        userResetPassword: 'user/{userId}/password/reset_link',
        scopes: 'user/{userID}/scopes',
        teams: 'user/{userID}/teams',
        search: 'user/search',
        export: 'user/export'
      },
      messages: {
        searchMessages: 'messaging_gateway/{recipientType}/{recipientID}/messages/search'
      },
      role: 'role',
      searchRoles: 'role/search',
      roleTeams: 'role/{roleID}/teams',
      team: 'team',
      teamAdmins: 'team/{teamID}/admins',
      unassignAdminsFromTeam: 'team/{teamID}/admins/remove',
      teamSearch: 'team/search',
      teamList: 'team/list',
      teamDelete: 'team/{teamID}/moveto/{toTeamID}',
      teamMembers: 'team/{teamID}/users',
      unassignMembersFromTeam: 'team/{teamID}/users/remove',
      teamRoles: 'team/{teamID}/roles',
      unassignRolesFromTeam: 'team/{teamID}/roles/remove',
      teamApiClients: 'team/{teamID}/clients',
      apiClient: 'client',
      apiClientTeams: 'client/{clientID}/teams',
      customer: {
        get: 'customer',
        getSeats: 'customer/seats',
        addSeats: 'customer/seats/add'
      },
      scope: 'scope',
      serverStatus: 'server/status',
      providerSaml: 'provider/saml',
      providerSamlMetadata: 'provider/saml/metadata',
      providerDelete: 'provider/{domain}',
      eventPaymentProvider: 'event/{eventID}/payment_provider',
      crm: {
        contact: {
          search: 'contact/search',
          get: 'contact/{contactID}',
          create: 'contact',
          delete: 'contact/{contactID}',
          bulkDelete: 'contact/delete',
          update: 'contact/{contactID}',
          eventsForContact: 'contact/{contactID}/events/search',
          fieldsSearch: 'contact/field/search',
          fieldCreate: 'contact/field',
          fieldUpdate: 'contact/field/{fieldID}',
          fieldGet: 'contact/field/{fieldID}',
          bulkFieldSet: 'contact/bulk_set/{fieldID}?field_mode={fieldMode}',
          export: 'contact/export',
          getSentEmails: 'contact/{contactID}/email',
          addToEvent: 'contact/add_to_event/{eventID}',
          sendMessage: 'messaging_gateway/contact/send_message',
          getEmailCampaignSubscriptions: 'contact/{contactID}/email_campaign/subscription',
          setEmailCampaignSubscriptions: 'contact/{contactID}/email_campaign/subscription'
        },
        contactEmailCampaigns: {
          create: 'contact/email_campaign',
          search: 'contact/email_campaign/search'
        },
        contactEmailTemplates: {
          create: 'contact/emailtemplate',
          search: 'contact/emailtemplate/search'
        },
        organization: {
          search: 'organization/search',
          get: 'organization/{organizationID}',
          create: 'organization',
          delete: 'organization/{organizationID}',
          update: 'organization/{organizationID}',
          fieldsSearch: 'organization/field/search',
          fieldCreate: 'organization/field',
          fieldUpdate: 'organization/field/{fieldID}',
          fieldDelete: 'organization/field/{fieldID}',
          bulkFieldSet: 'organization/bulk_set/{fieldID}?field_mode={fieldMode}',
          fieldGet: 'organization/field/{fieldID}'
        }
      },
      event: {
        search: 'event/search',
        getMany: 'event',
        get: 'event/{eventID}',
        create: 'event',
        import: 'event/import',
        update: 'event/{eventID}',
        delete: 'event/{eventID}',
        export: 'event/{eventID}/export',
        deleteMany: 'event/delete',
        getFields: 'event/{eventID}/field',
        searchFields: 'event/{eventID}/field/search',
        createField: 'event/{eventID}/field',
        updateField: 'event/{eventID}/field/{fieldID}',
        getField: 'event/{eventID}/field/{fieldID}',
        copy: 'event/{eventID}/copy',
        cancel: 'event/{eventID}/cancel',
        orderBulkUpdate: 'event/{eventID}/order/bulk_update',
        getIcon: 'w/event/{eventID}/icon',
        setIcon: 'event/{eventID}/icon',
        archived: {
          searchArchived: 'event/archived/search',
          searchEventWithArchivedParticipants: 'event/archived_participants/search',
          unarchive: 'event/unarchive',
          participant: {
            search: '/event/{eventID}/participant/archived/search',
            restore: 'event/{eventID}/participant/restore'
          }
        }
      },
      eventBadges: {
        create: 'event/{eventID}/badge',
        get: 'badge/{badgeID}',
        update: 'badge/{badgeID}',
        search: 'event/{eventID}/badge/search',
        delete: 'badge/{badgeID}'
      },
      eventBadgeFonts: {
        create: 'event/{eventID}/font',
        get: 'event/{eventID}/font',
        delete: 'font/{fontID}',
        getFile: 'font/{fontID}'
      },
      eventProject: {
        get: 'event/{eventID}/project'
      },
      eventTask: {
        search: 'event/{eventID}/task/search'
      },
      eventSeries: {
        search: 'series/search',
        create: 'series',
        get: 'series/{seriesID}',
        update: 'series/{seriesID}',
        delete: 'series/{seriesID}',
        publish: 'series/{seriesID}/publish',
        reset: 'series/{seriesID}/reset',
        searchEvents: 'series/{seriesID}/event/search',
        searchEventsInEventSeries: 'event/{eventID}/series/search_events',
        createSequence: 'series/{seriesID}/sequence',
        addTeams: 'series/{seriesID}/team',
        removeTeams: 'series/{seriesID}/team/remove',
        updateSequenceEvent: 'series/{seriesID}/event/{eventID}',
        updateSequence: 'series/{seriesID}/sequence/{sequenceID}'
      },
      eventTeams: {
        addTeamsToEvent: 'event/{eventID}/team',
        removeTeamsFromEvent: 'event/{eventID}/team/remove',
        sendMessage: 'messaging_gateway/event/{eventID}/team/send_message'
      },
      eventParticipants: {
        getTokens: 'participant/{participantID}/impersonation',
        get: 'participant/{participantID}',
        search: 'event/{eventID}/participant/search',
        create: 'event/{eventID}/participant',
        delete: 'participant/{participantID}',
        bulkArchive: 'event/{eventID}/participant/archive',
        update: 'participant/{participantID}',
        bulkFieldSet: 'event/{eventID}/participant/bulk_set/{field}',
        exportParticipants: 'event/{eventId}/participant/export',
        bulkStageUpdate: 'event/{eventID}/participant/stage/{stageID}',
        updateStage: 'participant/{participantID}/stage',
        addTeams: 'participant/{participantID}/team',
        removeTeams: 'participant/{participantID}/team/remove',
        getSentEmails: 'participant/{participantID}/email',
        addToEvent: 'event/{sourceEventID}/participant/add_to_event/{targetEventID}',
        bulkSetTeams: 'event/{eventID}/participant/bulk_set_teams',
        searchAudits: 'participant/{participantID}/audit/search',
        sendMessage: 'messaging_gateway/event/{eventID}/participant/send_message',
        getActivities: 'participant/{participantID}/activity',
        mergeWithDocument: 'event/{eventID}/participant/document',
        mergeWithDocumentGenerateCertificate: 'event/{eventID}/participant/generate-certificate'
      },
      eventSettings: {
        get: '/event/{eventID}/onsite/settings',
        update: '/event/{eventID}/onsite/settings'
      },
      eventProduct: {
        search: `/event/{eventID}/product/search`,
        create: `/event/{eventID}/product`
      },
      globalEventFields: {
        getOne: 'event/field/{id}',
        get: 'event/field',
        search: 'event/field/search',
        update: 'event/field/{fieldID}',
        create: 'event/field',
        bulkFieldSet: 'event/bulk_set/{fieldID}'
      },
      eventParticipantFields: {
        search: 'event/{eventID}/participant/field/search',
        create: 'event/{eventID}/participant/field',
        update: 'participant/field/{fieldID}',
        delete: 'participant/field/{fieldID}',
        get: 'participant/field/{fieldID}',
        bulkUpdate: 'event/{eventID}/participant/field/bulk_update'
      },
      builder: {
        themes: {
          get: 'theme/{themeID}',
          create: 'theme',
          update: 'theme/{themeID}',
          search: 'theme/search',
          delete: 'theme/{themeID}',
          teamsAdd: 'theme/{themeID}/team',
          teamsRemove: 'theme/{themeID}/team/remove'
        },
        dependencies: {
          get: 'event/{eventID}/dependency',
          search: 'event/{eventID}/dependency/search',
          getOne: 'dependency/{dependencyID}',
          create: 'event/{eventID}/dependency',
          update: 'dependency/{dependencyID}',
          delete: 'dependency/{dependencyID}'
        },
        pages: {
          create: 'page',
          search: 'page/search',
          bulkUpdateTheme: 'page/theme',
          bulkUpdateHeaderPage: 'page/header',
          bulkUpdateFooterPage: 'page/footer',
          get: 'page/{pageID}',
          getRaw: 'page/{pageID}/raw',
          // search: 'page/search',
          update: 'page/{pageID}',
          delete: 'page/{pageID}',
          publish: 'page/{pageID}/version/{versionID}/publish',
          unpublish: 'page/{pageID}/unpublish',
          getMenu: 'event/{eventID}/page/menu',
          createMenu: 'event/{eventID}/page/menu',
          getLinkToken: 'page/{pageID}/linktoken'
        },
        pageVersioning: {
          getRevision: 'page/{pageID}/revision',
          createVersion: 'page/{pageID}/version',
          getAllVersions: 'page/{pageID}/version',
          getVersion: 'page/{pageID}/version/{versionID}',
          syncVersion: 'page/{pageID}/content'
        }
      },
      eventEngagementApp: {
        polls: {
          search: 'event/{eventID}/poll/search',
          getResults: 'poll/{pollID}/result'
        },
        questions: {
          search: 'event/{eventID}/question/search'
        },
        newsfeeds: {
          search: 'event/{eventID}/newsfeed/search',
          getComments: 'newsfeed/{newsfeedID}/comment'
        },
        settings: {
          get: 'event/{eventId}/engagement/settings',
          save: 'event/{eventId}/engagement/settings'
        },
        activitySettings: {
          get: 'activity/{activityId}/engagement/settings',
          save: 'activity/{activityId}/engagement/settings'
        }
      },
      document: {
        file: {
          upload: 'file'
        },
        asset: {
          themeAsset: 'theme/{themeID}/asset',
          get: '/asset/{assetID}',
          getMany: 'event/{eventID}/asset',
          downloadMany: 'event/{eventID}/asset/download',
          contactsGetMany: 'contact/asset',
          contactsCreate: 'contact/asset/',
          contactsSearch: 'contact/asset/search',
          contactsDownload: 'contact/asset/download',
          eventCreate: 'event/{eventID}/asset',
          eventSearch: 'event/{eventID}/asset/search',
          eventListDownload: '/event/asset/download',
          eventBulkUpload: 'event/{eventID}/asset/bulk_upload',
          contactBulkUpload: 'contact/asset/bulk_upload'
        },
        customer: {
          uploadFavIcon: 'customer/favicon'
        },
        uploadParticipantDocument: 'participant/{participantID}/document',
        uploadContactDocument: 'contact/{contactID}/document',
        uploadOrganizationDocument: 'organization/{organizationID}/document',
        uploadEventDocument: 'event/{eventID}/document',
        uploadUserDocument: 'user/{userID}/document',
        updateDocument: 'document/{documentID}',
        deleteDocument: 'document/{documentID}',
        // getFile: 'document/{documentID}/file',
        getFile: 'document/{documentID}/file?token={token}',
        getDownloadToken: 'document/{documentID}/token'
      },
      settings: {
        global: {
          get: 'setting/{entityType}/{settingType}',
          save: 'setting/{entityType}/{settingType}',
          delete: 'setting/{entityType}/{settingType}',
          saveItem: 'setting/{entityType}/create/{settingType}',
          updateItem: 'setting/{entityType}/{settingType}/{settingID}',
          deleteItem: 'setting/{entityType}/{settingType}/{settingID}'
        },
        parent: {
          get: 'setting/{parentType}/{parentEntityId}/{entityType}/{settingType}',
          save: 'setting/{parentType}/{parentEntityId}/{entityType}/{settingType}',
          delete: 'setting/{parentType}/{parentEntityId}/{entityType}/{settingType}',
          saveItem: 'setting/{parentType}/{parentEntityId}/{entityType}/create/{settingType}',
          updateItem: 'setting/{parentType}/{parentEntityId}/{entityType}/{settingType}/{settingID}',
          deleteItem: 'setting/{parentType}/{parentEntityId}/{entityType}/{settingType}/{settingID}'
        },
        event: {
          get: 'event/{eventID}/settings',
          update: 'event/{eventID}/settings'
        },
        engagementApp: {
          setVirtualMeeingIntegrationForEvent: 'event/{eventId}/engagement/virtual_meeting_integration',
          getVirtualMeeingIntegrationForEvent: 'event/{eventId}/engagement/virtual_meeting_integration',
          setVirtualMeeingIntegrationForActivity: 'activity/{activityId}/engagement/virtual_meeting_integration',
          getVirtualMeeingIntegrationForActivity: 'activity/{activityId}/engagement/virtual_meeting_integration'
        },
        views: {
          global: {
            create: 'setting/detail/{entityType}/view',
            get: 'setting/detail/{entityType}/view',
            update: 'setting/detail/{entityType}/view/{viewId}',
            delete: 'setting/detail/{entityType}/view/{viewId}'
          },
          parent: {
            create: 'setting/detail/{parentType}/{parentEntityId}/{entityType}/view',
            get: 'setting/detail/{parentType}/{parentEntityId}/{entityType}/view',
            update: 'setting/detail/{parentType}/{parentEntityId}/{entityType}/view/{viewId}',
            delete: 'setting/detail/{parentType}/{parentEntityId}/{entityType}/view/{viewId}'
          }
        }
      },
      stages: {
        stage: {
          getMany: '{parentType}/{parentID}/stage',
          create: '{parentType}/{parentID}/stage',
          reorder: '{parentType}/{parentID}/stage/display_order',
          get: 'stage/{stageID}',
          update: 'stage/{stageID}',
          delete: 'stage/{stageID}',
          stageForms: 'stage/{stageID}/forms',
          stageProcess: 'stage/{stageID}/process',
          stageActor: 'stage/{stageID}/actor',
          stageThankYouPage: 'stage/{stageID}/thank_you_page',
          stageCancellationForm: 'stage/{stageID}/cancellation_form',
          getEventCounters: 'event/get_counters'
        },
        process: {
          getMany: '{parentType}/{parentID}/process',
          getGlobalMany: '{globalType}/process',
          getEventBookingMany: 'event/{parentID}/booking/process',
          createEventBooking: 'event/{parentID}/booking/process',
          getEventParticipantMany: 'event/{parentID}/participant/process',
          createEventParticipant: 'event/{parentID}/participant/process',
          searchEventParticipantProcesses: 'event/{parentID}/participant/process/search',
          getLocalEventMany: 'event/{parentID}/event/process',
          createLocalEvent: 'event/{parentID}/event/process',
          create: '{parentType}/{parentID}/process',
          createGlobal: '{globalType}/process',
          get: 'process/{processID}',
          update: 'process/{processID}',
          delete: 'process/{processID}',
          processSteps: 'process/{processID}/steps',
          processTrigger: 'process/{processID}/trigger'
        },
        processControl: {
          interrupt: 'process/{processID}/interrupt',
          pause: 'process/{processID}/pause',
          resume: 'process/{processID}/resume'
        }
      },
      eventActivities: {
        get: 'activity/{activityID}',
        search: 'event/{eventID}/activity/search',
        create: 'event/{eventID}/activity',
        delete: 'activity/{activityID}',
        bulkDelete: 'event/{eventID}/activity/delete',
        update: 'activity/{activityID}',
        bulkUpdate: '/event/{eventID}/activity/bulk_update',
        export: 'event/{eventID}/activity/export',
        exportParticipants: 'event/{eventID}/activity/participants/export',
        exportActivityParticipants: 'activity/{activityID}/participant/export',
        checkin: 'activity/{activityID}/checkin',
        getSettings: 'activity/{activityID}/settings',
        updateSettings: 'activity/{activityID}/settings',
        globalSettings: 'event/{eventID}/activity/settings',
        registeredParticipants: {
          get: 'activity/{activityID}/participant',
          remove: 'activity/{activityID}/participant/remove',
          search: 'activity/{activityID}/participant/search',
          updateActivityParticipant: 'activity/{activityID}/participant/{activityParticipantID}',
          bulkUpadeStatus: 'activity/{activityID}/participant/status'
        },
        bulkAddParticipantsToActivities: 'event/{eventID}/activity/bulk_add_participant',
        sendMessage: 'messaging_gateway/activity/{activityID}/activity_participant/send_message',
        speakers: {
          get: 'activity/{activityID}/speaker',
          create: 'activity/{activityID}/speaker',
          delete: 'activity/{activityID}/speaker/remove'
        },
        moderators: {
          get: 'activity/{activityID}/moderator',
          create: 'activity/{activityID}/moderator',
          delete: 'activity/{activityID}/moderator/remove'
        },
        groups: {
          create: 'event/{eventID}/activity_group',
          get: 'activity_group/{activityGroupID}',
          update: 'activity_group/{activityGroupID}',
          delete: 'activity_group/{activityGroupID}',
          search: 'event/{eventID}/activity_group/search'
        },
        conditions: {
          create: 'event/{eventID}/activity_condition',
          get: 'activity_condition/{activityConditionID}',
          update: 'activity_condition/{activityConditionID}',
          delete: 'activity_condition/{activityConditionID}',
          search: 'event/{eventID}/activity_condition/search',
          updateActivitiesCondition: 'event/{eventID}/activity/condition',
          updateActivitiesGroup: 'event/{eventID}/activity/group'
        }
      },
      eventApp: {
        create: 'event_app',
        update: 'event_app/{eventAppID}',
        search: 'event_app/search',
        delete: 'event_app/{eventAppID}',
        get: 'event_app/{eventAppID}',
        assignEvents: 'event_app/{eventAppID}/event',
        unassignEvents: 'event_app/{eventAppID}/event/remove',
        getProfileIds: 'event/{eventID}/event_app/profile',
        setProfileIds: 'event/{eventID}/event_app/profile',
        getProfile: 'event/{eventID}/event_app/profile/{profileID}',
        saveProfile: 'event/{eventID}/event_app/profile/{profileID}',
        getEventStandAloneApp: `/event/{eventID}/event_app`,
        createEventStandAloneApp: `/event/{eventID}/event_app`,
        getStandAloneApp: `/event_app/{eventAppID}`,
        updateStandAloneApp: `/event_app/{eventAppID}`,
        deleteStandAloneApp: `/event_app/{eventAppID}`,
        searchEventEventApp: 'event/{eventID}/event_app/search',
        addTeams: 'event_app/{eventAppID}/team',
        removeTeams: 'event_app/{eventAppID}/team/remove'
      },
      emailMarketing: {
        emailTemplates: {
          get: 'emailtemplate/{emailTemplateID}',
          update: 'emailtemplate/{emailTemplateID}',
          delete: 'emailtemplate/{emailTemplateID}',
          publish: 'emailtemplate/{emailTemplateID}/version/{versionID}/publish',
          unpublish: 'emailtemplate/{emailTemplateID}/unpublish'
        },
        eventEmailTemplates: {
          //     create: 'event/{eventID}/emailtemplate',
          //     search: 'event/{eventID}/emailtemplate/search',
          searchGlobal: 'event/emailtemplate/search',
          createGlobal: 'event/emailtemplate'
        },
        emailTemplatesVersioning: {
          getAllVersions: 'emailtemplate/{emailTemplateID}/version',
          getVersion: 'emailtemplate/{emailTemplateID}/version/{versionID}',
          createVersion: 'emailtemplate/{emailTemplateID}/version',
          syncVersion: 'emailtemplate/{emailTemplateID}/content'
        },
        campaigns: {
          get: 'email_campaign/{emailCampaignID}',
          delete: 'email_campaign/{emailCampaignID}',
          update: 'email_campaign/{emailCampaignID}',
          createSchedule: 'email_campaign/{emailCampaignID}/schedule',
          getSchedules: 'email_campaign/{emailCampaignID}/schedule',
          updateSchedule: 'email_campaign_schedule/{emailCampaignScheduleID}',
          deleteSchedule: 'email_campaign_schedule/{emailCampaignScheduleID}',
          getAudience: 'email_campaign/{emailCampaignID}/audience',
          searchAudience: 'email_campaign/{emailCampaignID}/audience/search',
          sendToTeams: 'email_campaign/{emailCampaignID}/teamemail',
          bulkUpdateHeader: 'email_campaign/emailtemplate/header',
          bulkUpdateFooter: 'email_campaign/emailtemplate/footer',
          bulkUpdateTheme: 'email_campaign/emailtemplate/theme',
          bulkUpdate: 'contact/email_campaign/bulk_update'
        },
        eventCampaigns: {
          search: 'event/{eventID}/email_campaign/search',
          create: 'event/{eventID}/email_campaign',
          sendTestEmail: 'email_campaign/{emailCampaignID}/test_email',
          bulkUpdate: 'event/{eventID}/email_campaign/bulk_update'
        }
      },
      system_email: {
        getList: 'system_email',
        create: 'system_email',
        get: 'system_email/{systemEmailID}',
        update: 'system_email/{systemEmailID}',
        delete: 'system_email/{systemEmailID}'
      },
      report: {
        byTypeAndWidgetId: 'report/{reportType}/run/{widgetId}'
      },
      jobs: {
        get: 'job/{jobID}',
        getErrors: 'job/{jobID}/errors',
        getMany: 'job',
        search: 'job/search',
        cancel: 'job/{jobID}/cancel',
        delete: 'job/{jobID}'
      },
      import: {
        uploadEventParticipants: 'event/{eventID}/participant/import',
        uploadConacts: 'contact/import',
        uploadOrganizations: 'organization/import',
        get: 'import/{importID}',
        importFieldsMapping: 'import/{importID}/field_mapping',
        save: 'import/{importID}',
        getValueMappings: 'import/{importID}/select_field_value_mapping',
        updateValueMappings: 'import/{importID}/select_field_value_mapping',
        getDuplications: 'import/{importID}/duplicate',
        resolveDuplication: 'import/{importID}/deduplication/{key}',
        saveDuplicates: 'import/{importID}/deduplication',
        getErrorRows: 'import/{importID}/error_row',
        updateRow: 'import/{importID}/row/{rowID}',
        applyCorrections: 'import/{importID}/manual_error_correction',
        autoMapOrganizations: 'import/{importID}/auto_map_organizations'
      },
      copyCluster: {
        get: 'copy_cluster',
        event: {
          get: 'copy_cluster/{copyClusterID}/event',
          post: 'copy_cluster/{copyClusterID}/event'
        },
        theme: {
          get: 'copy_cluster/{copyClusterID}/theme',
          post: 'copy_cluster/{copyClusterID}/theme'
        }
      },
      integrations: {
        get: 'integration/{integrationID}',
        getAll: 'integration',
        create: 'integration',
        update: 'integration/{integrationID}',
        delete: 'integration/{integrationID}',
        search: 'integration/search',
        list: 'integration/list',
        getSettings: 'integration/{integrationID}/settings',
        putSettings: 'integration/{integrationID}/settings',
        getWebhookLogs: 'integration/{integrationID}/webhook_log',
        getWebhookCallRequests: 'webhook_log_event/{callID}/request',
        searchExternalCRMLogs: 'external_crm/{integrationID}/log/search',
        clearExternalCRMLogs: 'external_crm/{integrationID}/log/clear',
        getExternalCRMLog: 'external_crm/{integrationID}/log/{logID}',
        searchAccountingLogs: 'accounting/{integrationID}/log/search',
        searchObjectMapping: 'external_crm/{integrationID}/object_mapping/search',
        deleteObjectMapping: 'external_crm/{integrationID}/object_mapping/{objectmappingID}',
        resendAccountingOrder: 'accounting/{integrationID}/order/{orderID}/resend',
        searchMessagingGatewayLogs: 'messaging_gateway/{integrationID}/search',
        addTeams: 'integration/{integrationID}/team',
        removeTeams: 'integration/{integrationID}/team/remove'
      },
      eventWorkflows: {
        getAll: '{parentType}/{parentID}/workflow',
        create: '{parentType}/{parentID}/workflow',
        get: 'workflow/{workflowID}',
        update: 'workflow/{workflowID}',
        delete: 'workflow/{workflowID}',
        reorder: '{parentType}/{parentID}/workflow/display_order',
        widgets: {
          getEventWaitinglistData: '{parentType}/{parentID}/workflow/widget/event_waiting_list'
        },
        scanStages: 'event/{eventID}/workflow/scan_stages',
        qrCodeScan: 'event/{parentID}/workflow/qrcode'
      },
      eventWorkflowBuilder: {
        draft: {
          publish: `/event/{eventId}/workflow_builder/draft/publish`,
          revert: `/event/{eventId}/workflow_builder/draft/revert`
        }
      },
      marketingUrl: {
        getAll: 'marketing_url/{entityType}/{entityID}',
        create: 'marketing_url/{entityType}/{entityID}',
        update: 'marketing_url/{marketingUrlId}',
        delete: 'marketing_url/{marketingUrlId}'
      },
      // TODO: It looks like this one is a replacement for the above
      url: {
        create: 'event/{eventID}/marketing_url',
        search: 'event/{eventID}/marketing_url/search',
        get: 'marketing_url/{marketingUrlId}',
        update: 'marketing_url/{marketingUrlId}',
        delete: '/marketing_url/{marketingUrlId}'
      },
      urlIngress: {
        get: 'ingress'
      },
      project: {
        search: 'project/search',
        get: 'project/{projectId}',
        update: 'project/{projectId}',
        copy: 'project/{projectId}/copy',
        delete: 'project/{projectId}',
        create: 'project',
        team: {
          add: 'project/{projectId}/team/add',
          remove: 'project/{projectId}/team/remove'
        },
        event: {
          add: 'project/{projectId}/event/add',
          remove: 'project/{projectId}/event/remove'
        },
        category: {
          search: 'project/category/search',
          update: 'project/category/{categoryId}',
          delete: 'project/category/{categoryId}',
          create: 'project/category'
        },
        task: {
          list: 'project/{projectId}/task',
          create: 'project/{projectId}/task',
          search: 'project/{projectId}/task/search',
          bulkDelete: 'project/{projectId}/task/archive',
          bulkUpdateStatus: 'project/{projectId}/task/bulk_set/status',
          get: 'task/{taskId}',
          update: 'task/{taskId}',
          delete: 'task/{taskId}',
          unassignTeam: 'task/{taskId}/team/unassign',
          assignTeam: 'task/{taskId}/team/assign',
          unassignUser: 'task/{taskId}/user/unassign',
          assignUser: 'task/{taskId}/user/assign'
        }
      },
      products: {
        getAll: 'product',
        create: 'product',
        get: 'product/{productID}',
        update: 'product/{productID}',
        delete: 'product/{productID}',
        search: 'product/search'
      },
      product_groups: {
        getAll: 'product_group',
        create: 'product_group',
        get: 'product_group/{groupID}',
        update: 'product_group/{groupID}',
        delete: 'product_group/{groupID}',
        search: 'product_group/search'
      },
      taxes: {
        getAll: 'tax',
        create: 'tax',
        get: 'tax/{taxID}',
        update: 'tax/{taxID}',
        delete: 'tax/{taxID}',
        search: 'tax/search'
      },
      cancellation_terms: {
        getAll: 'cancellation_terms',
        create: 'cancellation_terms',
        get: 'cancellation_terms/{cancellationTermID}',
        update: 'cancellation_terms/{cancellationTermID}',
        delete: 'cancellation_terms/{cancellationTermID}',
        search: 'cancellation_terms/search'
      },
      product_group_relations: {
        setProducts: 'product_group/{groupID}/product',
        removeProducts: 'product_group/{groupID}/product/remove',
        setEntities: 'product_group/{groupID}/{entityType}',
        removeEntities: 'product_group/{groupID}/{entityType}/remove',
        searchEntities: 'product_group/{groupID}/{entityType}/search',
        getByEntity: '{entityType}/{entityId}/product_group',
        getSettingsByEntity: '{entityType}/{entityId}/product_group/{groupID}/settings',
        saveSettingsByEntity: '{entityType}/{entityId}/product_group/{groupID}/settings',
        getProductsForEntity: '{entityType}/{entityId}/product'
      },
      orders: {
        search: 'order/search',
        get: 'order/{orderID}',
        update: 'order/{orderID}',
        // refund: 'order/{orderID}/refund',
        fullRefund: 'order/{orderID}/full_refund',
        searchForEvent: 'event/{eventID}/order/search',
        getForEvent: 'event/{eventID}/order/{orderID}',
        // refundForEvent: 'event/{eventID}/order/{orderID}/refund'
        fullRefundforEvent: 'event/{eventID}/order/{orderID}/full_refund',
        export: 'event/{eventID}/order/export',
        bulkUpdate: 'order/bulk_update',
        bulkSetTag: 'order/bulk_set/tag',
        addParticipantTransaction: 'participant/{participantID}/transaction/add'
      },
      discount: {
        search: 'discount/search',
        create: 'discount',
        delete: 'discount/{discountID}',
        get: 'discount/{discountID}',
        update: 'discount/{discountID}'
      },
      profilePages: {
        get: 'profile_page/{id}',
        getMany: 'profile_page',
        create: 'profile_page',
        update: 'profile_page/{id}',
        delete: 'profile_page/{id}',
        getSettings: 'profile_page/{id}/settings',
        updateSettings: 'profile_page/{id}/settings'
      },
      locations: {
        search: 'location/search',
        create: 'location',
        getMany: 'location',
        get: 'location/{locationID}',
        update: 'location/{locationID}',
        delete: 'location/{locationID}'
      },
      locationTeams: {
        put: 'location/{locationID}/team',
        assign: 'location/{locationID}/team',
        unassign: 'location/{locationID}/team/remove'
      },
      rooms: {
        getMany: 'location/{locationID}/room',
        create: 'location/{locationID}/room',
        get: 'room/{roomID}',
        update: 'room/{roomID}',
        delete: 'room/{roomID}',
        search: 'location/{locationID}/room/search'
      },
      amenities: {
        getMany: 'location/{locationID}/amenity',
        create: 'location/{locationID}/amenity',
        get: 'amenity/{amenityID}',
        update: 'amenity/{amenityID}',
        delete: 'amenity/{amenityID}',
        search: 'location/{locationID}/amenity/search'
      },
      flooPlans: {
        getMany: 'location/{locationID}/floor_plan',
        create: 'location/{locationID}/floor_plan',
        get: 'floor_plan/{floorPlanID}',
        update: 'floor_plan/{floorPlanID}',
        delete: 'floor_plan/{floorPlanID}',
        getToken: 'floor_plan/{floorPlanID}/token',
        getFile: 'floor_plan/{floorPlanID}/file',
        getFileWithToken: 'floor_plan/{floorPlanID}/file?token={token}',
        putFile: 'floor_plan/{floorPlanID}'
      },
      eventRoomsSettings: {
        getMany: 'event/{eventID}/room_settings',
        get: 'room_settings/{roomID}',
        create: 'event/{eventID}/room_settings',
        update: 'room_settings/{roomID}',
        delete: 'room_settings/{roomID}',
        search: 'event/{eventID}/room_settings/search'
      },
      eventRoomBookings: {
        getMany: 'event/{eventID}/booking',
        create: 'event/{eventID}/booking',
        get: 'booking/{bookingID}',
        update: 'booking/{bookingID}',
        setStatus: 'booking/{bookingID}/status',
        bulkSetStatus: 'event/{eventID}/booking/bulk_set_status',
        delete: 'booking/{bookingID}',
        search: 'event/{eventID}/booking/search'
      },
      globalReports: {
        search: 'report/search',
        create: 'report',
        get: 'report/{reportId}',
        update: 'report/{reportId}',
        delete: 'report/{reportId}',
        bulkDelete: 'report/delete',
        addTeams: 'report/{reportId}/team',
        removeTeams: 'report/{reportId}/team/remove'
      },
      globalReportVersions: {
        search: 'report/{reportId}/version/search',
        create: 'report/{reportId}/version',
        get: 'version/{versionId}',
        delete: 'version/{versionId}',
        exportSpreadsheet: 'version/{versionId}/spreadsheet/',
        updateName: 'version/{versionId}'
      },
      eventReports: {
        search: 'event/{eventId}/report/search',
        create: 'event/{eventId}/report',
        bulkDelete: 'event/{eventId}/report/delete'
      },
      extenralCrm: {
        getModules: 'external_crm/{integrationID}/{crmSyncObject}/modules',
        getFields: 'external_crm/{integrationID}/{crmSyncObject}/field',
        getFieldMappings: 'external_crm/{integrationID}/{crmSyncObject}/field_mapping',
        updateFieldMappings: 'external_crm/{integrationID}/{crmSyncObject}/field_mapping'
      },
      emailCampaignTypes: {
        create: 'email_campaign_type',
        delete: 'email_campaign_type/{emailCampaignTypeID}',
        search: 'email_campaign_type/search',
        update: 'email_campaign_type/{emailCampaignTypeID}'
      },
      utmParameters: {
        create: 'utm_parameter',
        delete: 'utm_parameter/{utmParameterId}',
        search: 'utm_parameter/search',
        update: 'utm_parameter/{utmParameterId}'
      }
      // pages: {
      //     create: 'page',
      //     search: 'page/search',
      //     bulkUpdateTheme: 'page/theme',
      //     bulkUpdateHeaderPage: 'page/header',
      //     bulkUpdateFooterPage: 'page/footer'
      // }
    };
  }
  getStartEndSearchParams(fromDate, toDate) {
    const searchObj = {
      and: [{
        start: {
          after: fromDate
        }
      }, {
        end: {
          before: toDate
        }
      }]
    };
    return searchObj;
  }
  getSearchParticipantAuditsPayload(req) {
    const result = {
      participant_audit_filter: {}
    };
    this.setAdvancedQueryProps(result, result.participant_audit_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getBulkUpdateEventPartcipantFieldsFilterPayload(req) {
    const result = {
      field_filter: {}
    };
    this.setAdvancedQueryProps(result, result.field_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getSearchEmailCampaignTypesPayload(req) {
    const result = {
      email_campaign_type_filter: {}
    };
    this.setAdvancedQueryProps(result, result.email_campaign_type_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getSearchUtmParametersPayload(req) {
    const result = {
      utm_parameter_filter: {}
    };
    this.setAdvancedQueryProps(result, result.utm_parameter_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getSearchAssetsPayload(req) {
    const result = {
      asset_filter: {}
    };
    this.setAdvancedQueryProps(result, result.asset_filter, req, text => [{
      'metadata.name': this.getLikeObject(text)
    }]);
    return result;
  }
  getSearchEmailTemplatesPayload(req) {
    const result = {
      emailtemplate_filter: {}
    };
    this.setAdvancedQueryProps(result, result.emailtemplate_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // getSearchEventPagesPayload(req: ISearchEventPagesRequest): ISearchEventPagesPayload {
  //     const result: ISearchEventPagesPayload = { page_filter: {} };
  //     this.setAdvancedQueryProps(result, result.page_filter, req, text => this.getNameLikeFilter(text));
  //     return result;
  // }
  getSearchThemesPayload(req) {
    const result = {
      theme_filter: {}
    };
    this.setAdvancedQueryProps(result, result.theme_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getSearchEventFieldsPayload(req) {
    const result = {
      field_filter: {}
    };
    this.setAdvancedQueryProps(result, result.field_filter, req, text => this.getNameAndLabelLikeFilter(text));
    return result;
  }
  getSearchEventParticipantFieldsPayload(req) {
    const result = {
      field_filter: {}
    };
    this.setAdvancedQueryProps(result, result.field_filter, req, text => this.getNameAndLabelLikeFilter(text));
    return result;
  }
  getBulkSetEventParticipantFieldFilterPayload(req) {
    const result = {
      participant_filter: {}
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getBulkUpdateEventParticipantsStagesFilterPayload(req) {
    const result = {
      participant_filter: {}
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getSearchEmailCampaignsPayload(req) {
    const result = {
      email_campaign_filter: {}
    };
    this.setAdvancedQueryProps(result, result.email_campaign_filter, req, text => {
      const likeObject = this.getLikeObject(text);
      const emailCampaignFieldFilterObjects = [{
        name: likeObject
      }, {
        subject: likeObject
      }];
      return emailCampaignFieldFilterObjects;
    });
    return result;
  }
  getSearchEmailCampaignAudiencePayload(req) {
    const result = {
      audience_member_filter: {}
    };
    this.setAdvancedQueryProps(result, result.audience_member_filter, req, text => {
      const likeObject = this.getLikeObject(text);
      const emailCampaignAudienceFieldFilterObjects = [{
        to_email: likeObject
      }];
      return emailCampaignAudienceFieldFilterObjects;
    });
    return result;
  }
  getMergeEventParticipantsWithDocumentPayload(req) {
    const result = {
      participant_filter: {},
      date_format: req.date_format,
      datetime_format: req.datetime_format,
      document_id: req.document_id,
      language: req.language,
      time_format: req.time_format
    };
    if (req.type) {
      result.type = req.type;
    }
    if (req.labels_per_page) {
      result.labels_per_page = req.labels_per_page;
    }
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getMergeEventParticipantsWithDocumentGenerateCertificatePayload(req) {
    const result = {
      participant_filter: {},
      document_id: req.document_id,
      document_field: req.document_field,
      document_name: req.document_name
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getSearchEventParticipantsPayload(req) {
    const result = {
      participant_filter: {}
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    if (req.stageIds && req.stageIds.length > 0) {
      if (result.participant_filter.and && Array.isArray(result.participant_filter.and)) {
        result.participant_filter.and.push({
          stage_id: {
            in: req.stageIds
          }
        });
      } else {
        result.participant_filter.and = [{
          stage_id: {
            in: req.stageIds
          }
        }];
      }
    }
    return result;
  }
  getSearchEventParticipantsByFieldsPayload(req, fieldNames) {
    const result = {
      participant_filter: {}
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getLikeFilter(fieldNames, text));
    if (req.stageIds && req.stageIds.length > 0) {
      if (result.participant_filter.and && Array.isArray(result.participant_filter.and)) {
        result.participant_filter.and.push({
          stage_id: {
            in: req.stageIds
          }
        });
      } else {
        result.participant_filter.and = [{
          stage_id: {
            in: req.stageIds
          }
        }];
      }
    }
    return result;
  }
  getSearchJobsPayload(req) {
    const result = {
      job_filter: {}
    };
    this.setAdvancedQueryProps(result, result.job_filter, req, text => [{
      label: this.getLikeObject(text)
    }]);
    return result;
  }
  getSearchOrdersPayload(req) {
    const result = {
      order_filter: {}
    };
    this.setAdvancedQueryProps(result, result.order_filter, req, text => this.getOrderOrSearchArray(text));
    return result;
  }
  getOrderOrSearchArray(text) {
    const likeObject = this.getLikeObject(text);
    return [{
      first_name: likeObject
    }, {
      last_name: likeObject
    }, {
      email: likeObject
    }, {
      contact_first_name: likeObject
    }, {
      contact_last_name: likeObject
    }, {
      contact_email: likeObject
    }, {
      buyer_first_name: likeObject
    }, {
      buyer_last_name: likeObject
    }, {
      buyer_email: likeObject
    }];
  }
  getExportOrdersPayload(req, exportParameters) {
    const result = {
      order_filter: {},
      date_format: exportParameters.dateFormat,
      datetime_format: exportParameters.dateTimeFormat,
      export: exportParameters.exportType,
      language: exportParameters.language,
      time_format: exportParameters.timeFormat,
      closed: exportParameters.closed
    };
    this.setAdvancedQueryProps(result, result.order_filter, req, text => this.getOrderOrSearchArray(text));
    return result;
  }
  getSearchDiscountsPayload(req) {
    const result = {
      discount_filter: {}
    };
    this.setAdvancedQueryProps(result, result.discount_filter, req, text => {
      const likeObject = this.getLikeObject(text);
      return [{
        discount_code: likeObject
      }];
    });
    return result;
  }
  getSearchEventsPayload(req) {
    const result = {
      event_filter: {}
    };
    this.setAdvancedQueryProps(result, result.event_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getSearchEventSeriesPayload(req) {
    const result = {
      series_filter: {}
    };
    this.setAdvancedQueryProps(result, result.series_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getSearchOrganizationsPayload(req) {
    const result = {
      organization_filter: {}
    };
    this.setAdvancedQueryProps(result, result.organization_filter, req, text => [{
      name: this.getLikeObject(text)
    }, {
      email: this.getLikeObject(text)
    }]);
    return result;
  }
  getSearchContactsPayload(req) {
    const result = {
      contact_filter: {}
    };
    this.setAdvancedQueryProps(result, result.contact_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getBulkSetContactFieldFilterPayload(req) {
    const result = {
      contact_filter: {}
    };
    this.setAdvancedQueryProps(result, result.contact_filter, req, text => this.getFirstLastEmailFilter(text));
    return pick$1(result, ['contact_filter']);
  }
  getBulkSetEventParticipantsTeamsPayload(req) {
    const result = {
      participant_filter: {},
      assign_teams: req.assign_teams,
      unassign_teams: req.unassign_teams
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req.participant_filter, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getBulkEventParticipantsArchivePayload(req) {
    const result = {
      participant_filter: {}
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getBulkEventActivitiesArchivePayload(req) {
    const result = {
      activity_filter: {}
    };
    this.setAdvancedQueryProps(result, result.activity_filter, req, text => this.getActivitiesSearchTextFilter(text));
    return result;
  }
  getBulkEventActivitiesUpdatePayload(req, update) {
    const result = {
      activity_filter: {},
      update
    };
    this.setAdvancedQueryProps(result, result.activity_filter, req, text => this.getActivitiesSearchTextFilter(text));
    return result;
  }
  getExportEventActivitiesParticipantsPayload(req) {
    const result = {
      activity_filter: {},
      fields: req.fields
    };
    this.setAdvancedQueryProps(result, result.activity_filter, req.activity_filter, text => this.getActivitiesSearchTextFilter(text));
    return result;
  }
  getExportEventActivityParticipantsPayload(req) {
    const result = {
      activity_participant_filter: {},
      fields: req.fields
    };
    this.setAdvancedQueryProps(result, result.activity_participant_filter, req.activity_participant_filter, text => this.getActivitiesSearchTextFilter(text));
    return result;
  }
  getExportEventActivitiesPayload(req) {
    const result = {
      activity_filter: {}
    };
    this.setAdvancedQueryProps(result, result.activity_filter, req, text => this.getActivitiesSearchTextFilter(text));
    return result;
  }
  getBulkSetOrganizationFieldFilterPayload(req) {
    const result = {
      organization_filter: {}
    };
    this.setAdvancedQueryProps(result, result.organization_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getSearchFieldsPayload(req) {
    const result = {
      field_filter: {}
    };
    this.setAdvancedQueryProps(result, result.field_filter, req, text => this.getNameAndLabelLikeFilter(text));
    return result;
  }
  getSearchTeamsPayload(req) {
    const result = {
      team_filter: {}
    };
    if (Object.keys(req).includes('hasGenericTeam')) {
      result.role_filter = {
        has_generic_team: req.hasGenericTeam
      };
    }
    this.setAdvancedQueryProps(result, result.team_filter, req, text => this.getNameLikeFilter(text));
    if (req.userId) {
      result.user_filter = {
        id: +req.userId
      };
    }
    return result;
  }
  getSearchUsersPayload(req) {
    const result = {
      user_filter: {}
    };
    this.setAdvancedQueryProps(result, result.user_filter, req, text => this.getFirstLastEmailFilter(text));
    let teamIds = [req.teamId, ...(req.teamIds ?? [])].filter(teamId => teamId != null);
    if (teamIds.length > 0) {
      result.team_filter = {
        id: {
          in: teamIds
        }
      };
    }
    if (req.isTeamAdmin === true || req.isTeamAdmin === false) {
      result.is_team_admin = req.isTeamAdmin;
    }
    return result;
  }
  getSearchRecipientTypeMessagesPayload(req) {
    const result = {
      message_filter: {}
    };
    this.setAdvancedQueryProps(result, result.message_filter, req, text => [this.getLikeObjects(text, ['body', 'status', 'error'])]);
    return result;
  }
  setAdvancedQueryProps(result, filterObject, req, orFn) {
    if (!req) {
      return;
    }
    this.setSortField(result, req.sortFieldName, req.sortDirection);
    if (req.advancedQuery) {
      Object.assign(filterObject, req.advancedQuery);
    }
    if (req.quickSearchText) {
      filterObject.or = req.advancedQuery && req.advancedQuery.or || [];
      if (orFn) {
        const quickSearchTextFilters = orFn(req.quickSearchText);
        filterObject.or.push(...quickSearchTextFilters);
      }
      if (req.quickSearchTextFieldNames?.length > 0) {
        const filterObjectOrMap = filterObject.or?.reduce((map, item) => {
          Object.keys(item).forEach(key => map[key] = item);
          return map;
        }, {});
        const likeObject = this.getLikeObject(req.quickSearchText);
        req.quickSearchTextFieldNames.forEach(fieldName => {
          if (!filterObjectOrMap[fieldName]) {
            filterObject.or.push({
              [fieldName]: likeObject
            });
          }
        });
      }
      // The "or" array should not be empty
      if (!filterObject.or?.length) {
        delete filterObject.or;
      }
    }
  }
  getNameLikeFilter(searchText) {
    return [{
      name: this.getLikeObject(searchText)
    }];
  }
  getActivitiesSearchTextFilter(searchText) {
    const likeObject = this.getLikeObject(searchText);
    return [{
      name: likeObject
    }, {
      room: likeObject
    }];
  }
  getNameAndLabelLikeFilter(searchText) {
    const likeObject = this.getLikeObject(searchText);
    return [{
      name: likeObject
    }, {
      label: likeObject
    }];
  }
  getDescriptionLikeFilter(searchText) {
    return [{
      description: this.getLikeObject(searchText)
    }];
  }
  getLikeObjects(searchText, propertyNames) {
    const result = {};
    propertyNames.forEach(x => result[x] = this.getLikeObject(searchText));
    return result;
  }
  getLikeObject(searchText) {
    return {
      like: searchText
    };
  }
  getEqObject(searchText) {
    return {
      eq: searchText
    };
  }
  getFirstLastEmailFilter(searchText) {
    const likeObject = this.getLikeObject(searchText);
    const contactFieldFilterObjects = [{
      first_name: likeObject
    }, {
      last_name: likeObject
    }, {
      email: likeObject
    }];
    return contactFieldFilterObjects;
  }
  getLikeFilter(fieldNames, searchText) {
    const likeObject = this.getLikeObject(searchText);
    const fieldFilterObjects = [];
    for (const fieldName of fieldNames) {
      fieldFilterObjects.push({
        [fieldName]: likeObject
      });
    }
    return fieldFilterObjects;
  }
  setSortField(obj, fieldName, sortDirection) {
    if (fieldName && sortDirection) {
      obj.sort_field = {
        field_name: fieldName,
        direction: sortDirection
      };
    }
  }
  removeSortField(sortField) {
    delete sortField.sort_field;
  }
  deleteIdCreatedAtUpdatedAt(entity) {
    delete entity.id;
    this.deleteCreatdAtUpdatedAt(entity);
  }
  deleteCreatdAtUpdatedAt(entity) {
    delete entity.created_at;
    delete entity.updated_at;
  }
  sanitizeEventSerieForUpdate(eventSerie) {
    return {
      name: eventSerie.name,
      category: eventSerie.category,
      subcategory: eventSerie.subcategory
    };
  }
  sanitizeEventWorkflowForCreate(workflow) {
    const sanitized = {
      ...workflow
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return sanitized;
  }
  sanitizeIdCreatedAtUpdatedAt(obj) {
    const sanitized = {
      ...obj
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return sanitized;
  }
  sanitizeEventWorkflowForUpdate(workflow) {
    const sanitized = {
      ...workflow
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    delete sanitized.type;
    return sanitized;
  }
  sanitizeEmailTemplateForCreate(emailTemplate) {
    const sanitized = {
      name: emailTemplate.name,
      theme_id: emailTemplate.theme_id,
      grapes_json: emailTemplate.grapes_json
    };
    return sanitized;
  }
  sanitizePublishEmailTemplateRequest(req) {
    const sanitizedPublishEventEmailTemplateRequest = {
      ...req
    };
    delete sanitizedPublishEventEmailTemplateRequest.emailTemplateId;
    delete sanitizedPublishEventEmailTemplateRequest.versionId;
    return sanitizedPublishEventEmailTemplateRequest;
  }
  sanitizePublishEventPageRequest(req) {
    const sanitizedPublishEventPageRequest = {
      ...req
    };
    delete sanitizedPublishEventPageRequest.pageId;
    delete sanitizedPublishEventPageRequest.versionId;
    return sanitizedPublishEventPageRequest;
  }
  sanitizeDependency(dependency) {
    const sanitizedDependency = {
      ...dependency
    };
    this.deleteIdCreatedAtUpdatedAt(sanitizedDependency);
    return sanitizedDependency;
  }
  sanitizeRequestTheme(requestTheme) {
    const sanitizedRequestTheme = {
      ...requestTheme
    };
    this.deleteIdCreatedAtUpdatedAt(sanitizedRequestTheme);
    return sanitizedRequestTheme;
  }
  sanitizeEventParticipant(participant) {
    const sanitizedParticipant = this.removeExternalId({
      ...participant
    });
    this.deleteIdCreatedAtUpdatedAt(sanitizedParticipant);
    delete sanitizedParticipant.crm_contact_id;
    delete sanitizedParticipant.stage_id;
    return sanitizedParticipant;
  }
  sanitizeEvent(event) {
    const sanitizedEvent = this.removeExternalId({
      ...event
    });
    this.deleteIdCreatedAtUpdatedAt(sanitizedEvent);
    this.removeTeamIds(sanitizedEvent);
    delete sanitizedEvent.type;
    return sanitizedEvent;
  }
  sanitizeContact(contact) {
    const sanitizedContact = this.removeExternalId({
      ...contact
    });
    this.removeTeamIds(sanitizedContact);
    this.deleteIdCreatedAtUpdatedAt(sanitizedContact);
    return sanitizedContact;
  }
  sanitizeOrganization(organization) {
    const sanitizedOrganization = this.removeExternalId({
      ...organization
    });
    this.removeTeamIds(sanitizedOrganization);
    this.deleteIdCreatedAtUpdatedAt(sanitizedOrganization);
    return sanitizedOrganization;
  }
  removeExternalId(entity) {
    delete entity.external_id;
    return entity;
  }
  removeTeamIds(entity) {
    delete entity.team_ids;
    return entity;
  }
  removeExternalIds(organizations) {
    for (let i = 0; i < organizations.length; i++) {
      organizations[i] = this.removeExternalId(organizations[i]);
    }
    return organizations;
  }
  // TODO: Needs reference to IField
  sanitizeField(field) {
    const sanitizedField = {
      ...field
    };
    this.removeTeamIds(sanitizedField);
    this.deleteIdCreatedAtUpdatedAt(sanitizedField);
    delete sanitizedField.builtin;
    delete sanitizedField.crm_field_id;
    return sanitizedField;
  }
  sanitizeFieldOnEventUpdate(field) {
    if (field.builtin) {
      const sanitizedField = {
        category: field.category,
        label: field.label,
        visible_for_planners: field.visible_for_planners
      };
      return sanitizedField;
    }
    return this.sanitizeField(field);
  }
  sanitizeApiClient(client) {
    const result = {
      name: client.name,
      superadmin: client.superadmin
    };
    return result;
  }
  sanitizeTeam(team) {
    const result = {
      address: team.address,
      city: team.city,
      contact_email: team.contact_email,
      country: team.country,
      name: team.name,
      postal_code: team.postal_code,
      generic_team: team.generic_team
    };
    return result;
  }
  sanitizeRole(role) {
    const result = {
      name: role.name,
      scopes: role.scopes
    };
    return result;
  }
  sanitizeCustomer(customer) {
    const result = {
      name: customer.name,
      address: customer.address,
      city: customer.city,
      postal_code: customer.postal_code,
      contact_email: customer.contact_email,
      country: customer.country
    };
    return result;
  }
  sanitizeUser(user) {
    const result = {
      account: user.account,
      status: user.status,
      valid_until: user.valid_until,
      department: user.department,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      phone: user.phone,
      superadmin: user.superadmin,
      language: user.language,
      timezone: user.timezone,
      profile_image_id: user.profile_image_id,
      job_title: user.job_title,
      title: user.title,
      date_format: user.date_format,
      datetime_format: user.datetime_format,
      time_format: user.time_format
    };
    return result;
  }
  sanitizeStage(stage) {
    const sanitizeStage = {
      ...stage
    };
    this.deleteIdCreatedAtUpdatedAt(sanitizeStage);
    delete sanitizeStage.default;
    delete sanitizeStage.entities_in_stage;
    return sanitizeStage;
  }
  sanitizeProcess(process) {
    const sanitizeProcess = {
      ...process
    };
    this.deleteIdCreatedAtUpdatedAt(sanitizeProcess);
    return sanitizeProcess;
  }
  sanitizePagedRequest(req) {
    const pagedReq = {};
    if (req.limit !== undefined && req.limit !== null) {
      pagedReq.limit = req.limit;
    }
    if (req.offset !== undefined && req.limit !== null) {
      pagedReq.offset = req.offset;
    }
    return pagedReq;
  }
  sanitizeCopyEventRequest(req) {
    const sanitized = {
      ...req
    };
    sanitized.event = {
      ...req.event
    };
    delete sanitized.event.id;
    return sanitized;
  }
  sanitizeCopyEventV4Request(req) {
    const sanitized = pick$1(this.sanitizeCopyEventRequest(req), ['copy_teams', 'event', 'team_ids']);
    if (sanitized.copy_teams) {
      delete sanitized.team_ids;
      delete sanitized.event.team_id;
    }
    return sanitized;
  }
  sanitizeDiscountForUpdate(discount) {
    const sanitized = {
      discount_code: discount.discount_code,
      status: discount.status,
      value: discount.value
    };
    return sanitized;
  }
  addEventTypeToQueryParams(req, currentQueryParamsObject) {
    if (req.type) {
      currentQueryParamsObject.type = req.type;
    }
    return currentQueryParamsObject;
  }
  getTokenInfo(token) {
    const result = {};
    result.value = token;
    const firstDotIndex = token.indexOf('.');
    const firstPart = token.substring(0, firstDotIndex);
    result.header = JSON.parse(this.base64Decode(firstPart));
    const secondDotIndex = token.indexOf('.', firstDotIndex + 1);
    const secondPart = token.substring(firstDotIndex + 1, secondDotIndex);
    result.payload = JSON.parse(this.base64Decode(secondPart));
    return result;
  }
  base64Decode(value) {
    return atob(value);
  }
  getNow() {
    return Date.now();
  }
  removeInternalAuthenticationResponseFromStorage() {
    window.localStorage.removeItem(this.authResponseStorageKey);
  }
  storeInternalAuthenticationResponse(response) {
    window.localStorage.setItem(this.authResponseStorageKey, JSON.stringify(response));
  }
  getInternalAuthenticationResponseFromStorage() {
    try {
      const storageValue = JSON.parse(window.localStorage.getItem(this.authResponseStorageKey));
      return storageValue;
    } catch (err) {
      return null;
    }
  }
  getTokenUsableNotAfter(tokenRetrievedAtMilliseconds, tokenDurationMilliseconds) {
    return tokenRetrievedAtMilliseconds + tokenDurationMilliseconds;
    // const now = this.getNow();
    // const remainingTime = (tokenRetrievedAtMilliseconds + tokenDurationMilliseconds) - now;
    // const tokenUsablePercentageTime = (remainingTime * this.allowedAccessTokenLifePercentage) / 100;
    // const result = now + tokenUsablePercentageTime;
    // return result;
  }
  getAuthorizationHeaderFromResponse(response) {
    return response.token_type + ' ' + response.access_token;
  }
  getTeamIdsFromUserScopes(userScopes) {
    const teamIds = Object.keys(userScopes).map(x => +x);
    return teamIds;
  }
  /**
   * Replaces placeholders found in the replacement with the URL encoded values.
   * Hash values should not encode to the same or other placeholder
   * @param path path containing placeholders in format {fieldNameInHashObject}
   * @param replacement number / string or hash object containing fields with names refrenced in the path.
   * If the type is string or number, the path must contain single placeholder only
   * @returns path with replaced placeholders
   * @example With string: replacePlaceholders('user/{userID}/teams', '1234') -> 'user/1234/teams'
   * @example With number: replacePlaceholders('user/{userID}/teams', 1234) -> 'user/1234/teams'
   * @example With hash object:
   * replacePlaceholders('event/{eventID}/dependency{dependencyID}', {eventID: '1234', dependencyID: '5678'})
   * -> 'event/1234/dependency/5678'
   */
  replacePlaceholders(path, replacement) {
    if (typeof replacement === 'string' || typeof replacement === 'number') {
      const leftBracePos = path.indexOf('{');
      const rightBracePos = path.indexOf('}', leftBracePos);
      const placeholder = path.substring(leftBracePos, rightBracePos + 1);
      return path.replace(placeholder, '' + encodeURIComponent(replacement));
    }
    const hashKeys = Object.keys(replacement);
    let result = path;
    for (const key of hashKeys) {
      result = result.replace('{' + key + '}', '' + encodeURIComponent(replacement[key]));
    }
    return result;
  }
  /**
   * Encodes an object into x-www-form-urlencoded string
   * @param obj Object to encode
   * @returns String representing x-www-form-urlencoded object. Both object keys and values are encoded
   * @example formUrlEncode({username: 'usr123', password:'pass with spaces'}) -> 'username=use123&password=pass%20with%20spaces'
   */
  formUrlEncode(obj) {
    let result = '';
    const items = [];
    Object.keys(obj).forEach(key => {
      items.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    });
    result = items.join('&');
    return result;
  }
  createError(err) {
    const communicationError = {};
    if (err instanceof ErrorEvent) {
      // Client side or network error
      const errEvent = err;
      communicationError.message = errEvent.message;
    } else {
      // Server responded with error
      communicationError.message = err.message;
      communicationError.body = err.error;
      communicationError.status = err.status;
      communicationError.statusText = err.statusText;
    }
    const apiError = new AzavistaApiError();
    apiError.communicationError = communicationError;
    apiError.thrownError = err;
    return apiError;
  }
  // Pages
  getCreatePageUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.builder.pages.create);
  }
  getSearchPagesUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.builder.pages.search);
  }
  getSearchPagesPayload(req) {
    const result = {
      page_filter: {}
    };
    this.setAdvancedQueryProps(result, result.page_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getBulkUpdatePagesThemeUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.builder.pages.bulkUpdateTheme);
  }
  getBulkUpdatePagesThemePayload(req, themeId) {
    const result = {
      theme_id: themeId,
      page_filter: {}
    };
    this.setAdvancedQueryProps(result, result.page_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getBulkUpdatePagesHeaderPageUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.builder.pages.bulkUpdateHeaderPage);
  }
  getBulkUpdatePagesFooterPageUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.builder.pages.bulkUpdateFooterPage);
  }
  getBulkUpdatePagesHeaderPagePayload(req, headerPageId) {
    const result = {
      header_page_id: headerPageId,
      page_filter: {}
    };
    this.setAdvancedQueryProps(result, result.page_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getBulkUpdatePagesFooterPagePayload(req, footerPageId) {
    const result = {
      footer_page_id: footerPageId,
      page_filter: {}
    };
    this.setAdvancedQueryProps(result, result.page_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // Event badges
  getCreateEventBadgeUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventBadges.create, eventId));
  }
  getSearchEventBadgesUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventBadges.search, eventId));
  }
  getDeleteEventBadgeUrl(badgeId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventBadges.delete, badgeId));
  }
  getGetEventBadgeUrl(badgeId) {
    return this.withBasePrefix(this.paths.eventBadges.get, badgeId);
  }
  getUpdateEventBadgeUrl(badgeId) {
    return this.withBasePrefix(this.paths.eventBadges.update, badgeId);
  }
  getSearchEventBadgesPayload(req) {
    const result = {
      badge_filter: {}
    };
    this.setAdvancedQueryProps(result, result.badge_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // Badge - fonts
  getCreateEventBadgeFontUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventBadgeFonts.create, eventId));
  }
  getEventBadgeFontsUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventBadgeFonts.get, eventId));
  }
  getEventBadgeFontFileUrl(fontId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventBadgeFonts.getFile, fontId));
  }
  getDeleteEventBadgeFontUrl(fontId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventBadgeFonts.delete, fontId));
  }
  // Event - Project Management
  getEventProjectsUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventProject.get, eventId));
  }
  getSearchEventTaskUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventTask.search, eventId));
  }
  // Activity conditions
  getActivitiesConditionUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.conditions.updateActivitiesCondition, eventId));
  }
  getActivityConditionCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.conditions.create, eventId));
  }
  getActivityConditionGetUrl(activityConditionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.conditions.get, activityConditionId));
  }
  getActivityConditionUpdateUrl(activityConditionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.conditions.update, activityConditionId));
  }
  getActivityConditionDeleteUrl(activityConditionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.conditions.delete, activityConditionId));
  }
  getActivityConditionsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.conditions.search, eventId));
  }
  getSearchActivityConditionsPayload(req) {
    const result = {
      activity_condition_filter: {}
    };
    this.setAdvancedQueryProps(result, result.activity_condition_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  sanitizeActivityConditionForUpdate(activityCondition) {
    const sanitized = {
      ...activityCondition
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return sanitized;
  }
  // Activity groups
  getActivitiesGroupUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.conditions.updateActivitiesGroup, eventId));
  }
  getActivityGroupCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.groups.create, eventId));
  }
  getActivityGroupGetUrl(activityGroupId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.groups.get, activityGroupId));
  }
  getActivityGroupUpdateUrl(activityGroupId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.groups.update, activityGroupId));
  }
  getActivityGroupDeleteUrl(activityGroupId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.groups.delete, activityGroupId));
  }
  getActivityGroupsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.groups.search, eventId));
  }
  getSearchActivityGroupsPayload(req) {
    const result = {
      activity_group_filter: {}
    };
    this.setAdvancedQueryProps(result, result.activity_group_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  sanitizeActivityGroupForUpdate(activityGroup) {
    const sanitized = {
      ...activityGroup
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return sanitized;
  }
  // Email campaign types
  getEmailCampaignTypeCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.emailCampaignTypes.create);
  }
  getEmailCampaignTypeUpdateUrl(emailCampaignTypeID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailCampaignTypes.update, emailCampaignTypeID));
  }
  getEmailCampaignTypeDeleteUrl(emailCampaignTypeID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailCampaignTypes.delete, emailCampaignTypeID));
  }
  getEmailCampaignTypeSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.emailCampaignTypes.search);
  }
  getEmailCampaignsBulkFieldSetUrl() {
    return this.prefixWithBaseUrl(this.paths.emailMarketing.campaigns.bulkUpdate);
  }
  getEmailCampaignsBulkHeaderSetUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.emailMarketing.campaigns.bulkUpdateHeader);
  }
  getEmailCampaignsBulkFooterSetUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.emailMarketing.campaigns.bulkUpdateFooter);
  }
  getEmailCampaignsBulkThemeSetUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.emailMarketing.campaigns.bulkUpdateTheme);
  }
  // System Email
  getSystemEmailGetListUrl() {
    return this.prefixWithBaseUrl(this.paths.system_email.getList);
  }
  getSystemEmailCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.system_email.create);
  }
  getSystemEmailGetUrl(systemEmailId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.system_email.get, systemEmailId));
  }
  getSystemEmailUpdateUrl(systemEmailId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.system_email.update, systemEmailId));
  }
  getSystemEmailDeleteUrl(systemEmailId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.system_email.delete, systemEmailId));
  }
  // UTM parameters
  sanitizeUtmParameterForCreate(utmParameter) {
    const sanitized = {
      ...utmParameter
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    delete sanitized.type;
    return sanitized;
  }
  sanitizeUtmParameterForUpdate(utmParameter) {
    const sanitized = {
      ...utmParameter
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    delete sanitized.type;
    return sanitized;
  }
  getUtmParameterCreateUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.utmParameters.create);
  }
  getUtmParametersSearchUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.utmParameters.search);
  }
  getUtmParameterUpdateUrl(utmParameterId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.utmParameters.update, utmParameterId));
  }
  getUtmParameterDeleteUrl(utmParameterId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.utmParameters.delete, utmParameterId));
  }
  // Event rooms
  getEventRoomsSettingsGetManyUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomsSettings.getMany, eventID));
  }
  getEventRoomSettingsGetUrl(roomID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomsSettings.get, roomID));
  }
  getEventRoomsSettingsCreateUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomsSettings.create, eventID));
  }
  getEventRoomSettingsUpdateUrl(roomID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomsSettings.update, roomID));
  }
  getEventRoomSettingsDeleteUrl(roomID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomsSettings.delete, roomID));
  }
  getEventRoomsSettingsSearchUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomsSettings.search, eventID));
  }
  // Event room bookings
  getEventRoomsBookingsGetManyUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomBookings.getMany, eventID));
  }
  getEventRoomBookingsCreateUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomBookings.create, eventID));
  }
  getEventRoomBookingsSearchUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomBookings.search, eventID));
  }
  getEventRoomBookingsBulkSetStatusUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomBookings.bulkSetStatus, eventID));
  }
  getEventRoomBookingsBulkSetStatusPayload(req) {
    const result = {
      booking_filter: {},
      status: req.status
    };
    this.setAdvancedQueryProps(result, result.booking_filter, req.booking_filter, null);
    return result;
  }
  getEventRoomBookingGetUrl(bookingID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomBookings.get, bookingID));
  }
  getEventRoomBookingUpdateUrl(bookingID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomBookings.update, bookingID));
  }
  getEventRoomBookingSetStatusUrl(bookingID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomBookings.setStatus, bookingID));
  }
  getEventRoomBookingDeleteUrl(bookingID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventRoomBookings.delete, bookingID));
  }
  sanitizeEventRoomBooking(booking) {
    const sanitized = {
      ...booking
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    delete sanitized.event_id;
    return sanitized;
  }
  // Reports
  getGlobalReportVersionUpdateNameUrl(versionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReportVersions.updateName, versionId));
  }
  getGlobalReportsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.globalReports.search);
  }
  getGlobalReportCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.globalReports.create);
  }
  getGlobalReportGetUrl(reportId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReports.get, reportId));
  }
  getGlobalReportUpdateUrl(reportId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReports.update, reportId));
  }
  getGlobalReportDeleteUrl(reportId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReports.delete, reportId));
  }
  getGlobalReportBulkDeleteUrl() {
    return this.prefixWithBaseUrl(this.paths.globalReports.bulkDelete);
  }
  getGlobalReportAddTeamsUrl(reportId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReports.addTeams, reportId));
  }
  getGlobalReportRemoveTeamsUrl(reportId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReports.removeTeams, reportId));
  }
  getGlobalReportVersionsSearchUrl(reportId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReportVersions.search, reportId));
  }
  getGlobalReportVersionGetUrl(versionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReportVersions.get, versionId));
  }
  getGlobalReportVersionCreateUrl(reportId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReportVersions.create, reportId));
  }
  getGlobalReportVersionDeleteUrl(versionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReportVersions.delete, versionId));
  }
  getGlobalReportVersionexportSpreadsheetCreateUrl(versionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalReportVersions.exportSpreadsheet, versionId));
  }
  sanitizeGlobalReportForCreate(report) {
    const sanitized = {
      name: report.name,
      description: report.description,
      type: report.type,
      team_ids: report.team_ids
    };
    return sanitized;
  }
  sanitizeGlobalReportForUpdate(report) {
    const sanitized = {
      ...report
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    delete sanitized.type;
    delete sanitized.team_ids;
    delete sanitized.parent;
    delete sanitized.datereport;
    return sanitized;
  }
  getSearchGlobalReportsPayload(req) {
    const result = {
      report_filter: {}
    };
    this.setAdvancedQueryProps(result, result.report_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getSearchGlobalReportVersionsPayload(req) {
    const result = {
      version_filter: {}
    };
    this.setAdvancedQueryProps(result, result.version_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getBulkDeleteReportsPayload(req) {
    const payload = this.getSearchGlobalReportsPayload(req);
    this.removeSortField(payload);
    return payload;
  }
  // Event reports
  getEventReportsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventReports.search, eventId));
  }
  getEventReportCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventReports.create, eventId));
  }
  getEventReportsBulkDeleteUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventReports.bulkDelete, eventId));
  }
  // Floor plans
  getFloorPlansGetUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.getMany, locationID));
  }
  getFloorPlanGetUrl(floorPlanID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.get, floorPlanID));
  }
  getFloorPlanCreateUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.create, locationID));
  }
  getFloorPlanUpdateUrl(floorPlanID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.update, floorPlanID));
  }
  getFloorPlanDeleteUrl(floorPlanID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.delete, floorPlanID));
  }
  getFloorPlanGetTokenUrl(floorPlanID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.getToken, floorPlanID));
  }
  getFloorPlanGetFileUrl(floorPlanID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.getFile, floorPlanID));
  }
  getFloorPlanGetFileUrlWithToken(floorPlanID, token) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.getFileWithToken, {
      floorPlanID,
      token
    }));
  }
  getFloorPlanPutFileUrl(floorPlanID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.flooPlans.putFile, floorPlanID));
  }
  // Locations
  getLocationSetTeamsUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.locationTeams.put, locationID));
  }
  getLocationAssignTeamsUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.locationTeams.assign, locationID));
  }
  getLocationUnassignTeamsUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.locationTeams.unassign, locationID));
  }
  getLocationsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.locations.search);
  }
  getLocationsGetManyUrl() {
    return this.prefixWithBaseUrl(this.paths.locations.getMany);
  }
  getLocationGetUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.locations.get, locationID));
  }
  getLocationCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.locations.create);
  }
  getLocationUpdateUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.locations.update, locationID));
  }
  getLocationDeleteUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.locations.delete, locationID));
  }
  // Rooms
  getRoomsSearchUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.rooms.search, locationID));
  }
  getRoomsGetManyUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.rooms.getMany, locationID));
  }
  getRoomGetUrl(roomID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.rooms.get, roomID));
  }
  getRoomCreateUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.rooms.create, locationID));
  }
  getRoomUpdateUrl(roomID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.rooms.update, roomID));
  }
  getRoomDeleteUrl(roomID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.rooms.delete, roomID));
  }
  // Amenities
  getAmenitiesSearchUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.amenities.search, locationID));
  }
  getAmenitiesGetManyUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.amenities.getMany, locationID));
  }
  getAmenityGetUrl(amenityID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.amenities.get, amenityID));
  }
  getAmenityCreateUrl(locationID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.amenities.create, locationID));
  }
  getAmenityUpdateUrl(amenityID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.amenities.update, amenityID));
  }
  getAmenityDeleteUrl(amenityID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.amenities.delete, amenityID));
  }
  // Profile pages
  getProfilePageGetUrl(profilePageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.profilePages.get, profilePageId));
  }
  getProfilePagesGetManyUrl() {
    return this.prefixWithBaseUrl(this.paths.profilePages.getMany);
  }
  getProfilePageCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.profilePages.create);
  }
  getProfilePageUpdateUrl(profilePageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.profilePages.update, profilePageId));
  }
  getProfilePageDeleteUrl(profilePageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.profilePages.delete, profilePageId));
  }
  getProfilePageSettingsGetUrl(profilePageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.profilePages.getSettings, profilePageId));
  }
  getProfilePageSettingsUpdateUrl(profilePageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.profilePages.updateSettings, profilePageId));
  }
  sanitizeProfilePage(profilePage) {
    const result = {
      default: profilePage.default,
      name: profilePage.name,
      sections: profilePage.sections,
      settings: profilePage.settings
    };
    return result;
  }
  // Event room bookings
  getSearchEventRoomBookingsPayload(req) {
    const result = {
      booking_filter: {}
    };
    this.setAdvancedQueryProps(result, result.booking_filter, req, text => {
      const likeObject = this.getLikeObject(text);
      return [{
        layout_name: likeObject
      }];
    });
    return result;
  }
  // Event room settings
  getSearchEventRoomsSettingsPayload(req) {
    const result = {
      room_settings_filter: {}
    };
    this.setAdvancedQueryProps(result, result.room_settings_filter, req, text => {
      const likeObject = this.getLikeObject(text);
      return [{
        name: likeObject
      }];
    });
    return result;
  }
  // Locations
  getSearchLocationsPayload(req) {
    const result = {
      location_filter: {}
    };
    this.setAdvancedQueryProps(result, result.location_filter, req, text => {
      const likeObject = this.getLikeObject(text);
      return [{
        name: likeObject
      }, {
        address: likeObject
      }, {
        description: likeObject
      }];
    });
    return result;
  }
  sanitizeLocation(location) {
    const result = {
      name: location.name,
      address: location.address,
      description: location.description,
      team_ids: location.team_ids
    };
    return result;
  }
  sanitizeLocationUpdateRequest(req) {
    const result = {
      name: req.name,
      address: req.address,
      description: req.description
    };
    return result;
  }
  // Rooms
  sanitizeRoom(room) {
    const result = {
      name: room.name,
      category: room.category,
      floor: room.floor,
      layouts: room.layouts,
      amenity_ids: room.amenity_ids
    };
    return result;
  }
  getSearchRoomsPayload(req) {
    const result = {
      room_filter: {}
    };
    this.setAdvancedQueryProps(result, result.room_filter, req, text => {
      const likeObject = this.getLikeObject(text);
      return [{
        name: likeObject
      }, {
        category: likeObject
      }, {
        floor: likeObject
      }];
    });
    return result;
  }
  // Amenities
  sanitizeAmenity(amenity) {
    const result = {
      name: amenity.name,
      description: amenity.description
    };
    return result;
  }
  getSearchAmenitiesPayload(req) {
    const result = {
      amenity_filter: {}
    };
    this.setAdvancedQueryProps(result, result.amenity_filter, req, text => {
      const likeObject = this.getLikeObject(text);
      return [{
        name: likeObject
      }, {
        description: likeObject
      }];
    });
    return result;
  }
  // Discount
  getDiscountsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.discount.search);
  }
  getDiscountCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.discount.create);
  }
  getDiscountDeleteUrl(discountId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.discount.delete, discountId));
  }
  getDiscountGetUrl(discountId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.discount.get, discountId));
  }
  getDiscountUpdateUrl(discountId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.discount.update, discountId));
  }
  // Orders
  getOrdersSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.orders.search);
  }
  getEventOrdersSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.searchForEvent, eventId));
  }
  getOrderGetUrl(orderId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.get, orderId));
  }
  getOrderUpdateUrl(orderId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.update, orderId));
  }
  getEventOrderGetUrl(eventId, orderId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.getForEvent, {
      eventID: eventId,
      orderID: orderId
    }));
  }
  getOrderFullRefundUrl(orderId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.fullRefund, orderId));
  }
  getEventOrderFullRefundUrl(eventId, orderId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.fullRefundforEvent, {
      eventID: eventId,
      orderID: orderId
    }));
  }
  getOrderBulkUpdateTagUrl() {
    return this.prefixWithBaseUrl(this.paths.orders.bulkSetTag);
  }
  getOrderBulkUpdateUrl() {
    return this.prefixWithBaseUrl(this.paths.orders.bulkUpdate);
  }
  getAddParticipantTransactionUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.addParticipantTransaction, participantId));
  }
  getEventOrdersExportUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.export, eventId));
  }
  // getOrderRefundUrl(orderId: string): string {
  //     return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.refund, orderId));
  // }
  // getEventOrderRefundUrl(eventId: string, orderId: string): string {
  //     return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.orders.refundForEvent, {
  //         eventID: eventId, orderID: orderId
  //     }));
  // }
  // Event Engagement App
  getEngagementAppSettingsGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.settings.get, eventId));
  }
  getEngagementAppSettingsSaveUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.settings.save, eventId));
  }
  getActivityEngagementAppSettingsGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.activitySettings.get, eventId));
  }
  getActivityEngagementAppSettingsSaveUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.activitySettings.save, eventId));
  }
  getEngagementAppPollsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.polls.search, eventId));
  }
  getSearchEngagementAppPollsPayload(req) {
    const result = {
      poll_filter: {}
    };
    this.setAdvancedQueryProps(result, result.poll_filter, req, text => [{
      question: this.getLikeObject(text)
    }]);
    return result;
  }
  getPollResultsGetUrl(pollId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.polls.getResults, pollId));
  }
  getEngagementAppQuestionsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.questions.search, eventId));
  }
  getSearchEngagementAppQuestionsPayload(req) {
    const result = {
      question_filter: {}
    };
    this.setAdvancedQueryProps(result, result.question_filter, req, text => [{
      question: this.getLikeObject(text)
    }]);
    return result;
  }
  getEngagementAppNewsfeedsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.newsfeeds.search, eventId));
  }
  getSearchEngagementAppNewsfeedsPayload(req) {
    const result = {
      newsfeed_filter: {}
    };
    this.setAdvancedQueryProps(result, result.newsfeed_filter, req, text => [{
      subject: this.getLikeObject(text)
    }]);
    return result;
  }
  getNewsfeedCommentsGetUrl(newsfeedId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventEngagementApp.newsfeeds.getComments, newsfeedId));
  }
  // Import
  getContactsFileUploadUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.import.uploadConacts);
  }
  getEventParticipantsFileUploadUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.uploadEventParticipants, eventId));
  }
  getOrganizationsFileUploadUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.import.uploadOrganizations);
  }
  getImportGetUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.get, importId));
  }
  getFieldsMappingImportUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.importFieldsMapping, importId));
  }
  getImportSaveUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.save, importId));
  }
  getImportFieldValueMappingsGetUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.getValueMappings, importId));
  }
  getImportFieldValueMappingsUpdateUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.updateValueMappings, importId));
  }
  getImportDuplicatesGetUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.getDuplications, importId));
  }
  getImportDuplicationResolveUrl(importId, duplicationKey) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.resolveDuplication, {
      importID: importId,
      key: duplicationKey
    }));
  }
  getImportErrorRowsGetUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.getErrorRows, importId));
  }
  getImportRowUpdateUrl(importId, rowId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.updateRow, {
      importID: importId,
      rowID: rowId
    }));
  }
  getImportCorrectionsApplyUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.applyCorrections, importId));
  }
  getImportDuplicatesSaveUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.saveDuplicates, importId));
  }
  getImportOrganizationsAutoMapUrl(importId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.import.autoMapOrganizations, importId));
  }
  // Event app
  sanitizeEventApp(eventApp) {
    const sanitized = {
      ...eventApp
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return sanitized;
  }
  getEventAppCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.eventApp.create);
  }
  getEventAppUpdateUrl(eventAppId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.update, eventAppId));
  }
  getEventAppsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.eventApp.search);
  }
  getEventAppDeleteUrl(eventAppId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.delete, eventAppId));
  }
  getEventAppGetUrl(eventAppId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.get, eventAppId));
  }
  getAssignEventsToEventAppUrl(eventAppId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.assignEvents, eventAppId));
  }
  getUnassignEventsFromEventAppUrl(eventAppId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.unassignEvents, eventAppId));
  }
  getEventAppProfileIdsGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.getProfileIds, eventId));
  }
  getEventAppProfileIdsSetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.setProfileIds, eventId));
  }
  getEventAppProfileGetUrl(eventId, profileId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.getProfile, {
      eventID: eventId,
      profileID: profileId
    }));
  }
  getEventAppProfileSetUrl(eventId, profileId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.saveProfile, {
      eventID: eventId,
      profileID: profileId
    }));
  }
  getEventAppEventStandaloneUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.getEventStandAloneApp, {
      eventID: eventId
    }));
  }
  createEventAppEventStandaloneUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.createEventStandAloneApp, {
      eventID: eventId
    }));
  }
  getEventAppStandaloneUrl(eventAppID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.getStandAloneApp, {
      eventAppID
    }));
  }
  updateEventAppStandaloneUrl(eventAppID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.updateStandAloneApp, {
      eventAppID
    }));
  }
  deleteEventAppStandaloneUrl(eventAppID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.deleteStandAloneApp, {
      eventAppID
    }));
  }
  getEventAppAddTeamsUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.addTeams, eventId));
  }
  getEventAppRemoveTeamsUrl(eventAppId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.removeTeams, eventAppId));
  }
  getSearchEventAppsPayload(req) {
    const result = {
      event_app_filter: {}
    };
    this.setAdvancedQueryProps(result, result.event_app_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getSearchEventEventAppsUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventApp.searchEventEventApp, eventId));
  }
  getSearchEventEventAppsPayload(req) {
    return this.getSearchEventAppsPayload(req);
  }
  // Email campaigns
  sanitizeEmailCampaign(campaign) {
    const sanitized = {
      ...campaign
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return sanitized;
  }
  getEventEmailCampaignCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.eventCampaigns.create, eventId));
  }
  getEventEmailCampaignsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.eventCampaigns.search, eventId));
  }
  getEventEmailCampaignsBulkFieldSetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.eventCampaigns.bulkUpdate, eventId));
  }
  getTestEmailSendUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.eventCampaigns.sendTestEmail, campaignId));
  }
  getEmailCampaignAudienceGetUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.getAudience, campaignId));
  }
  getEmailCampaignSendToTeamsUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.sendToTeams, campaignId));
  }
  getEmailCampaignAudienceSearchUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.searchAudience, campaignId));
  }
  getEmailCampaignGetUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.get, campaignId));
  }
  getEmailCampaignUpdateUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.update, campaignId));
  }
  getEmailCampaignDeleteUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.delete, campaignId));
  }
  getCreateEmailCampaignSchedulePayload(req) {
    const result = {
      participant_filter: {},
      filter_time: req.filter_time,
      send_time: req.send_time,
      participant_filter_excludes_existing_audience: req.participant_filter_excludes_existing_audience
    };
    if (req.email_field_id) {
      result.email_field_id = req.email_field_id;
    }
    const reqWithModule = req;
    if (reqWithModule.audience_module_type) {
      const resultWithModule = result;
      resultWithModule.audience_module_type = reqWithModule.audience_module_type;
      resultWithModule.audience_module_id = reqWithModule.audience_module_id;
    }
    this.setAdvancedQueryProps(result, result.participant_filter, req.participantsAdvancedSearch, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getEmailCampaignScheduleCreateUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.createSchedule, campaignId));
  }
  getEmailCampaignSchedulesGetUrl(campaignId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.getSchedules, campaignId));
  }
  getEmailCampaignScheduleUpdateUrl(scheduleId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.updateSchedule, scheduleId));
  }
  getEmailCampaignScheduleDeleteUrl(scheduleId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.campaigns.deleteSchedule, scheduleId));
  }
  // Jobs paths
  getJobGetUrl(jobId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.jobs.get, jobId));
  }
  getJobGetErrorsUrl(jobId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.jobs.getErrors, jobId));
  }
  getJobsGetUrl() {
    return this.prefixWithBaseUrl(this.paths.jobs.getMany);
  }
  getJobsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.jobs.search);
  }
  getJobCancelUrl(jobId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.jobs.cancel, jobId));
  }
  getJobDeleteUrl(jobId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.jobs.delete, jobId));
  }
  // Report paths
  getReportUrl(reportType, widgetId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.report.byTypeAndWidgetId, {
      reportType: reportType,
      widgetId: widgetId
    }));
  }
  // Document paths
  getFileUploadUrl() {
    return this.prefixWithBaseUrl(this.paths.document.file.upload);
  }
  getAssetByIdUrl(assetsId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.asset.get, assetsId));
  }
  getAssetsGetManyUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.asset.getMany, eventId));
  }
  getContactsAssetsUrl() {
    return this.prefixWithBaseUrl(this.paths.document.asset.contactsGetMany);
  }
  getEventAssetCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.asset.eventCreate, eventId));
  }
  getContactsAssetCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.document.asset.contactsCreate);
  }
  getContactAssetsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.document.asset.contactsSearch);
  }
  getContactAssetsDownloadUrl() {
    return this.prefixWithBaseUrl(this.paths.document.asset.contactsDownload);
  }
  getEventAssetsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.asset.eventSearch, eventId));
  }
  getEventAssetsBulkDownloadUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.asset.downloadMany, eventId));
  }
  getEventListAssetsBulkDownloadUrl() {
    return this.prefixWithBaseUrl(this.paths.document.asset.eventListDownload);
  }
  getEventAssetsBulkUploadUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.asset.eventBulkUpload, eventId));
  }
  getContactAssetsBulkUploadUrl() {
    return this.prefixWithBaseUrl(this.paths.document.asset.contactBulkUpload);
  }
  getThemeAssetUrl(themeId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.asset.themeAsset, themeId));
  }
  getParticipantDocumentUploadUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.uploadParticipantDocument, participantId));
  }
  getContactDocumentUploadUrl(contactId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.uploadContactDocument, contactId));
  }
  getOrganizationDocumentUploadUrl(organizationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.uploadOrganizationDocument, organizationId));
  }
  getEventDocumentUploadUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.uploadEventDocument, eventId));
  }
  getUserDocumentUploadUrl(userId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.uploadUserDocument, userId));
  }
  getDocumentUpdateUrl(documentId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.updateDocument, documentId));
  }
  getDocumentDeleteUrl(documentId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.deleteDocument, documentId));
  }
  getCustomerFavIconUploadUrl() {
    return this.prefixWithBaseUrl(this.paths.document.customer.uploadFavIcon);
  }
  getDocumentDownloadTokenGetUrl(documentId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.getDownloadToken, documentId));
  }
  // getDocumentFileGetUrl(documentId: string): string {
  //     return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.getFile, documentId));
  // }
  getDocumentFileGetUrl(documentId, token) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.document.getFile, {
      documentID: documentId,
      token: token
    }));
  }
  // Settings paths
  sanitizeGroupedFieldsView(view) {
    const sanitized = {
      ...view
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    // if (sanitized.filter && !sanitized.filter.field_id) {
    //     sanitized.filter = null;
    // }
    delete sanitized.filter;
    if (sanitized.filters) {
      const filters = [];
      for (const filter of sanitized.filters) {
        if (filter.field_name) {
          filters.push(filter);
        }
      }
      sanitized.filters = filters;
    }
    // TODO: We still don't know what this attribute does but the server validation fails if we send it
    delete sanitized.parent;
    return sanitized;
  }
  getGlobalViewCreateUrl(entityType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.views.global.create, entityType));
  }
  getGlobalViewsGetUrl(entityType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.views.global.get, entityType));
  }
  getGlobalViewUpdateUrl(entityType, viewId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.views.global.update, {
      entityType: entityType,
      viewId: viewId
    }));
  }
  getGlobalViewDeleteUrl(entityType, viewId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.views.global.delete, {
      entityType: entityType,
      viewId: viewId
    }));
  }
  getParentViewCreateUrl(parentType, parentEntityId, entityType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.views.parent.create, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType
    }));
  }
  getParentViewsGetUrl(parentType, parentEntityId, entityType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.views.parent.get, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType
    }));
  }
  getParentViewUpdateUrl(parentType, parentEntityId, entityType, viewId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.views.parent.update, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType,
      viewId: viewId
    }));
  }
  getParentViewDeleteUrl(parentType, parentEntityId, entityType, viewId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.views.parent.delete, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType,
      viewId: viewId
    }));
  }
  getVirtualMeetingIntegrationSetForEventUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.engagementApp.setVirtualMeeingIntegrationForEvent, eventId));
  }
  getVirtualMeetingIntegrationGetForEventUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.engagementApp.getVirtualMeeingIntegrationForEvent, eventId));
  }
  getVirtualMeetingIntegrationSetForActivityUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.engagementApp.setVirtualMeeingIntegrationForActivity, activityId));
  }
  getVirtualMeetingIntegrationGetForActivityUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.engagementApp.getVirtualMeeingIntegrationForActivity, activityId));
  }
  getEventSettingsGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.event.get, eventId));
  }
  getEventSettingsUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.event.update, eventId));
  }
  getGlobalSettingGetUrl(entityType, settingType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.global.get, {
      entityType: entityType,
      settingType: settingType
    }));
  }
  getGlobalSettingSaveUrl(entityType, settingType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.global.save, {
      entityType: entityType,
      settingType: settingType
    }));
  }
  getGlobalSettingItemSaveUrl(entityType, settingType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.global.saveItem, {
      entityType: entityType,
      settingType: settingType
    }));
  }
  getGlobalSettingDeleteUrl(entityType, settingType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.global.delete, {
      entityType: entityType,
      settingType: settingType
    }));
  }
  getGlobalSettingItemDeleteUrl(entityType, settingType, settingID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.global.deleteItem, {
      entityType: entityType,
      settingType: settingType,
      settingID: settingID
    }));
  }
  getGlobalSettingItemUpdateUrl(entityType, settingType, settingID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.global.updateItem, {
      entityType: entityType,
      settingType: settingType,
      settingID: settingID
    }));
  }
  getParentSettingGetUrl(parentType, parentEntityId, entityType, settingType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.parent.get, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType,
      settingType: settingType
    }));
  }
  getParentSettingSaveUrl(parentType, parentEntityId, entityType, settingType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.parent.save, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType,
      settingType: settingType
    }));
  }
  getParentSettingSaveItemUrl(parentType, parentEntityId, entityType, settingType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.parent.saveItem, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType,
      settingType: settingType
    }));
  }
  getParentSettingDeleteUrl(parentType, parentEntityId, entityType, settingType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.parent.delete, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType,
      settingType: settingType
    }));
  }
  getParentSettingDeleteItemUrl(parentType, parentEntityId, entityType, settingType, settingID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.parent.deleteItem, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType,
      settingType: settingType,
      settingID: settingID
    }));
  }
  getParentSettingUpdateItemUrl(parentType, parentEntityId, entityType, settingType, settingID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.settings.parent.updateItem, {
      parentType: parentType,
      parentEntityId: parentEntityId,
      entityType: entityType,
      settingType: settingType,
      settingID: settingID
    }));
  }
  // Builder paths
  getThemeGetUrl(themeId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.themes.get, themeId));
  }
  getThemeCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.builder.themes.create);
  }
  getThemeUpdateUrl(themeId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.themes.update, themeId));
  }
  getThemesSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.builder.themes.search);
  }
  getThemeDeleteUrl(themeId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.themes.delete, themeId));
  }
  getAddTeamsFromThemeUrl(themeId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.themes.teamsAdd, themeId));
  }
  getRemoveTeamsFromThemeUrl(themeId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.themes.teamsRemove, themeId));
  }
  getDependenciesGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.dependencies.get, eventId));
  }
  getDependencyGetUrl(dependencyId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.dependencies.getOne, dependencyId));
  }
  getDependencyUpdateUrl(dependencyId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.dependencies.update, dependencyId));
  }
  getDependencyCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.dependencies.create, eventId));
  }
  getDependencyDeleteUrl(dependencyId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.dependencies.delete, dependencyId));
  }
  getDependenciesSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.dependencies.search, eventId));
  }
  getSearchDependenciesPayload(req) {
    const result = {
      dependency_filter: {}
    };
    this.setAdvancedQueryProps(result, result.dependency_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // getSearchPagesUrl(): string {
  //     return this.prefixWithTreeDotOneBaseUrl(this.paths.builder.pages.search);
  // }
  getPageGetUrl(pageId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.builder.pages.get, pageId));
  }
  getPageRawGetUrl(pageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pages.getRaw, pageId));
  }
  getPageUpdateUrl(pageId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.builder.pages.update, pageId));
  }
  getEventPageDeleteUrl(pageId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.builder.pages.delete, pageId));
  }
  getEventPagePublishUrl(pageId, versionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pages.publish, {
      pageID: pageId,
      versionID: versionId
    }));
  }
  getEventPageUnpublishUrl(pageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pages.unpublish, pageId));
  }
  getEventPagesMenuCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pages.createMenu, eventId));
  }
  getPageLinkTokenGetUrl(pageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pages.getLinkToken, pageId));
  }
  getEventPagesMenuGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pages.getMenu, eventId));
  }
  getEventPageGetRevisionsUrl(pageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pageVersioning.getRevision, pageId));
  }
  getEventPageCreateVersionUrl(pageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pageVersioning.createVersion, pageId));
  }
  getEventPageGetAllVersionsUrl(pageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pageVersioning.getAllVersions, pageId));
  }
  getEventPageGetVersionUrl(pageId, versionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pageVersioning.getVersion, {
      pageID: pageId,
      versionID: versionId
    }));
  }
  getEventPageSyncUrl(pageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.builder.pageVersioning.syncVersion, pageId));
  }
  // Event paths
  getEventsBulkDeleteUrl() {
    return this.prefixWithBaseUrl(this.paths.event.deleteMany);
  }
  getEventsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.event.search);
  }
  getEventsSearchArchivedUrl() {
    return this.prefixWithBaseUrl(this.paths.event.archived.searchArchived);
  }
  getEventsUnarchiveUrl() {
    return this.prefixWithBaseUrl(this.paths.event.archived.unarchive);
  }
  getEventsWithArchivedParticipantsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.event.archived.searchEventWithArchivedParticipants);
  }
  getEventArchivedParticipantsSearchUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.archived.participant.search, eventID));
  }
  getEventArchivedParticipantsRestoreUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.archived.participant.restore, eventID));
  }
  getEventsGetUrl() {
    return this.prefixWithBaseUrl(this.paths.event.getMany);
  }
  getEventGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.get, eventId));
  }
  getEventCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.event.create);
  }
  getEventImportUrl() {
    return this.prefixApiUrl(this.paths.event.import, 'baseUrl_4_0');
  }
  getEventUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.update, eventId));
  }
  getEventCopyUrl(eventId, apiVersion = 'baseUrl') {
    return this.prefixApiUrl(this.replacePlaceholders(this.paths.event.copy, eventId), apiVersion);
  }
  getEventCopyV4Url(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.copy, eventId));
  }
  getEventCancelUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.cancel, eventId));
  }
  getEventDeleteUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.delete, eventId));
  }
  getEventExportUrl(eventId) {
    return this.prefixApiUrl(this.replacePlaceholders(this.paths.event.export, eventId), 'baseUrl_4_0');
  }
  getEventOrderBulkUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.orderBulkUpdate, eventId));
  }
  getEventIconGetUrl(eventId) {
    return this.withBasePrefix(this.paths.event.getIcon, eventId);
  }
  getEventIconSetUrl(eventId) {
    return this.withBasePrefix(this.paths.event.setIcon, eventId);
  }
  // Event series
  getEventSeriesSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.eventSeries.search);
  }
  getEventSeriesCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.eventSeries.create);
  }
  getEventSeriesGetUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.get, seriesId));
  }
  getEventSeriesUpdateUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.update, seriesId));
  }
  getEventSeriesDeleteUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.delete, seriesId));
  }
  getEventSeriesEventsSearchUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.searchEvents, seriesId));
  }
  getEventsInEventSeriesSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.searchEventsInEventSeries, eventId));
  }
  getEventSeriesSequenceCreateUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.createSequence, seriesId));
  }
  getEventSeriesTeamsAddUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.addTeams, seriesId));
  }
  getEventSeriesTeamsRemoveUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.removeTeams, seriesId));
  }
  getEventSeriesPublishUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.publish, seriesId));
  }
  getEventSeriesResetUrl(seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.reset, seriesId));
  }
  getSequenceEventUpdateurl(eventId, seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.updateSequenceEvent, {
      seriesID: seriesId,
      eventID: eventId
    }));
  }
  getSeriesSequenceUpdateurl(sequenceId, seriesId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSeries.updateSequence, {
      seriesID: seriesId,
      sequenceID: sequenceId
    }));
  }
  // Event email templates
  // getEventEmailTemplatesSearchUrl(eventId: string): string {
  //     return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.eventEmailTemplates.search, eventId));
  // }
  getGlobalEventEmailTemplatesSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.emailMarketing.eventEmailTemplates.searchGlobal);
  }
  getGlobalEventEmailTemplateCreateurl() {
    return this.prefixWithBaseUrl(this.paths.emailMarketing.eventEmailTemplates.createGlobal);
  }
  // Email templates
  getEmailTemplateGetAllVersionsUrl(emailTemplateId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplatesVersioning.getAllVersions, emailTemplateId));
  }
  getEmailTemplateGetVersionUrl(emailTemplateId, versionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplatesVersioning.getVersion, {
      emailTemplateID: emailTemplateId,
      versionID: versionId
    }));
  }
  getEmailTemplateCreateVersionUrl(emailTemplateId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplatesVersioning.createVersion, emailTemplateId));
  }
  getEmailTemplateSyncUrl(emailTemplateId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplatesVersioning.syncVersion, emailTemplateId));
  }
  // getEmailTemplateGetUrl(emailTemplateId: string): string {
  //     return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplates.get, emailTemplateId));
  // }
  getEmailTemplateUpdateUrl(emailTemplateId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplates.update, emailTemplateId));
  }
  // getEventEmailTemplateCreateUrl(eventId: string): string {
  //     return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.eventEmailTemplates.create, eventId));
  // }
  getEmailTemplateDeleteUrl(emailTemplateId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplates.delete, emailTemplateId));
  }
  getEmailTemplatePublishUrl(emailTemplateId, versionId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplates.publish, {
      emailTemplateID: emailTemplateId,
      versionID: versionId
    }));
  }
  getEmailTemplateUnpublishUrl(emailTemplateId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.emailMarketing.emailTemplates.unpublish, emailTemplateId));
  }
  // Event fields
  getEventFieldsGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.getFields, eventId));
  }
  getEventFieldsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.searchFields, eventId));
  }
  getEventFieldCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.createField, eventId));
  }
  getEventFieldUpdateUrl(eventId, fieldId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.updateField, {
      eventID: eventId,
      fieldID: fieldId
    }));
  }
  getEventFieldGetUrl(eventId, fieldId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.event.getField, {
      eventID: eventId,
      fieldID: fieldId
    }));
  }
  // Event teams
  getAddTeamsToEventUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventTeams.addTeamsToEvent, eventId));
  }
  getRemoveTeamsFromEventUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventTeams.removeTeamsFromEvent, eventId));
  }
  getSendEventTeamsMessageUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventTeams.sendMessage, eventId));
  }
  // Event participant fields
  getEventParticipantFieldsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipantFields.search, eventId));
  }
  getEventParticipantFieldCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipantFields.create, eventId));
  }
  getEventParticipantFieldUpdateUrl(fieldId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipantFields.update, fieldId));
  }
  getEventParticipantFieldDeleteUrl(fieldId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipantFields.delete, fieldId));
  }
  getEventParticipantFieldBulkUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipantFields.bulkUpdate, eventId));
  }
  getEventParticipantFieldGetUrl(fieldId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipantFields.get, fieldId));
  }
  // Global event fields
  getGlobalEventFieldsGetUrl() {
    return this.prefixWithBaseUrl(this.paths.globalEventFields.get);
  }
  getGlobalEventFieldGetUrl(fieldId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalEventFields.getOne, fieldId));
  }
  getGlobalEventFieldsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.globalEventFields.search);
  }
  getGlobalEventFieldUpdateUrl(fieldId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalEventFields.update, fieldId));
  }
  getGlobalEventFieldCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.globalEventFields.create);
  }
  getGlobalEventFieldBulkSetUrl(fieldID, fieldMode) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.globalEventFields.bulkFieldSet, {
      fieldID,
      fieldMode
    }));
  }
  // Event participants
  getEventParticipantsMergeWithDocumentGenerateCertificateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.mergeWithDocumentGenerateCertificate, eventId));
  }
  getEventParticipantsMergeWithDocumentUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.mergeWithDocument, eventId));
  }
  getEventParticipantActivitiesGetUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.getActivities, participantId));
  }
  getEventParticipantAddToEventUrl(sourceEventID, targetEventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.addToEvent, {
      sourceEventID: sourceEventID,
      targetEventID: targetEventID
    }));
  }
  getEventParticipantsTeamsBulkSetUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.bulkSetTeams, eventID));
  }
  getParticipantAuditsSearchUrl(participantID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.searchAudits, participantID));
  }
  getParticipantsSendMessageUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.sendMessage, eventId));
  }
  getEventParticipantGetTokensUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.getTokens, participantId));
  }
  getEventParticipantGetUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.get, participantId));
  }
  getEventParticipantGetSentEmailsUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.getSentEmails, participantId));
  }
  getEventParticipantsSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.search, eventId));
  }
  getEventParticipantCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.create, eventId));
  }
  getEventParticipantDeleteUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.delete, participantId));
  }
  getEventParticipantBulkArchiveUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.bulkArchive, eventId));
  }
  getEventParticipantUpdateUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.update, participantId));
  }
  getEventParticipantBulkFieldSetUrl(eventId, fieldId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.bulkFieldSet, {
      eventID: eventId,
      field: fieldId
    }));
  }
  getEventParticipantBulkStageUpdateUrl(eventId, stageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.bulkStageUpdate, {
      eventID: eventId,
      stageID: stageId
    }));
  }
  getEventParticipantUpdateStageUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.updateStage, participantId));
  }
  getEventParticipantExportUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.exportParticipants, {
      eventId
    }));
  }
  getEventParticipantAddTeamsUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.addTeams, participantId));
  }
  getEventParticipantRemoveTeamsUrl(participantId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventParticipants.removeTeams, participantId));
  }
  // CRM paths
  getContactsSearchUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.contact.search);
  }
  getContactUpdateUrl(contactId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.contact.update, contactId));
  }
  getContactUrl(contactId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.contact.get, contactId));
  }
  getContactGetSentEmailsUrl(contactId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.crm.contact.getSentEmails, contactId));
  }
  getContactsAddToEventUrl(eventId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.contact.addToEvent, eventId));
  }
  getContactsSendMessageUrl() {
    return this.prefixWithBaseUrl(this.paths.crm.contact.sendMessage);
  }
  getContactEmailCampaignSubscriptionsGetUrl(contactId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.crm.contact.getEmailCampaignSubscriptions, contactId));
  }
  getContactEmailCampaignSubscriptionsSetUrl(contactId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.crm.contact.setEmailCampaignSubscriptions, contactId));
  }
  getContactDeleteUrl(contactId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.contact.delete, contactId));
  }
  getContactsBulkDeleteUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.contact.bulkDelete);
  }
  getContactCreateUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.contact.create);
  }
  getContactEventsUrl(contactID) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.contact.eventsForContact, contactID));
  }
  getContactFieldsSearchUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.contact.fieldsSearch);
  }
  getContactFieldCreateUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.contact.fieldCreate);
  }
  getContactFieldUpdateUrl(fieldId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.contact.fieldUpdate, fieldId));
  }
  getContactFieldGetUrl(fieldId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.contact.fieldGet, fieldId));
  }
  getContactBulkFieldSet(fieldID, fieldMode) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.contact.bulkFieldSet, {
      fieldID,
      fieldMode
    }));
  }
  getContactsEmailCampaignCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.crm.contactEmailCampaigns.create);
  }
  getContactsEmailCampaignsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.crm.contactEmailCampaigns.search);
  }
  getContactsEmailTemplateCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.crm.contactEmailTemplates.create);
  }
  getContactsEmailTemplatesSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.crm.contactEmailTemplates.search);
  }
  getContactExportUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.contact.export);
  }
  getOrganizationCreateUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.organization.create);
  }
  getOrganizationDeleteUrl(organizationId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.organization.delete, organizationId));
  }
  getOrganizationUpdateUrl(organizationId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.organization.update, organizationId));
  }
  getOrganizationUrl(organizationId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.organization.get, organizationId));
  }
  getOrganizationsSearchUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.organization.search);
  }
  getOrganizationFieldsSearchUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.organization.fieldsSearch);
  }
  getOrganizationFieldCreateUrl() {
    return this.prefixWithCRMBaseUrl(this.paths.crm.organization.fieldCreate);
  }
  getOrganizationFieldUpdateUrl(fieldId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.organization.fieldUpdate, fieldId));
  }
  getOrganizationFieldDeleteUrl(fieldId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.organization.fieldDelete, fieldId));
  }
  getOrganizationBulkFieldSetUrl(fieldID, fieldMode) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.organization.bulkFieldSet, {
      fieldID,
      fieldMode
    }));
  }
  getOrganizationFieldGetUrl(fieldId) {
    return this.prefixWithCRMBaseUrl(this.replacePlaceholders(this.paths.crm.organization.fieldGet, fieldId));
  }
  // UM paths
  getAuthTokenUrl() {
    return this.prefixWithBaseUrl(this.paths.token);
  }
  getServerStatusUrl() {
    return this.prefixWithBaseUrl(this.paths.serverStatus);
  }
  getConfigureProviderUrl() {
    return this.prefixWithBaseUrl(this.paths.providerSaml);
  }
  getProviderMetadataUrl() {
    return this.prefixWithBaseUrl(this.paths.providerSamlMetadata);
  }
  getDeleteProviderUrl(domain) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.providerDelete, domain));
  }
  getApiClientUrl(clientId) {
    return this.prefixWithBaseUrl(this.getEntityPath(this.paths.apiClient, clientId));
  }
  getApiClientTeamsUrl(clientId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.apiClientTeams, clientId));
  }
  getTeamApiClientsUrl(teamId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.teamApiClients, teamId));
  }
  getTeamRolesUrl(teamId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.teamRoles, teamId));
  }
  getUnassignRolesFromTeamUrl(teamId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.unassignRolesFromTeam, teamId));
  }
  getTeamMembersUrl(teamId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.teamMembers, teamId));
  }
  getUnassignMembersFromTeamUrl(teamId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.unassignMembersFromTeam, teamId));
  }
  getTeamAdminsUrl(teamId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.teamAdmins, teamId));
  }
  getUnassignAdminsFromTeamUrl(teamId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.unassignAdminsFromTeam, teamId));
  }
  getTeamUrl(teamId) {
    return this.prefixWithBaseUrl(this.getEntityPath(this.paths.team, teamId));
  }
  getTeamSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.teamSearch);
  }
  getTeamListUrl() {
    return this.prefixWithBaseUrl(this.paths.teamList);
  }
  getTeamDeleteUrl(teamId, toTeamId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.teamDelete, {
      teamID: teamId,
      toTeamID: toTeamId
    }));
  }
  getUserUrl(userId) {
    return this.prefixWithBaseUrl(this.getEntityPath(this.paths.users.getSingle, userId));
  }
  getUserPasswordUrl() {
    return this.prefixWithBaseUrl(this.paths.users.password);
  }
  getUserResetPasswordUrl() {
    return this.prefixWithBaseUrl(this.paths.users.resetPassword);
  }
  getUserTeamsUrl(userId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.users.teams, userId));
  }
  getUserScopesUrl(userId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.users.scopes, userId));
  }
  getUserSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.users.search);
  }
  getUsersExportUrl() {
    return this.prefixWithBaseUrl(this.paths.users.export);
  }
  getExportUsersPayload(req) {
    const result = {
      user_filter: {},
      team_filter: {},
      export_fields: req.export_fields
    };
    this.setAdvancedQueryProps(result, result.user_filter, req.user_filter, text => this.getFirstLastEmailFilter(text));
    this.setAdvancedQueryProps(result, result.team_filter, req.team_filter, text => this.getNameLikeFilter(text));
    this.setSortField(result, req.sort_field?.field_name, req.sort_field?.direction);
    return result;
  }
  getRecipientTypeSearchMessagesUrl(recipientType, recipientId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.messages.searchMessages, {
      recipientType: recipientType,
      recipientID: recipientId
    }));
  }
  getResetUserPasswordUrl(userId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.users.userResetPassword, userId));
  }
  getRoleUrl(id) {
    return this.prefixWithBaseUrl(this.getEntityPath(this.paths.role, id));
  }
  getRolesSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.searchRoles);
  }
  getSearchRolesPayload(req) {
    const result = {
      role_filter: {}
    };
    this.setAdvancedQueryProps(result, result.role_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getRoleTeamsUrl(roleId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.roleTeams, roleId));
  }
  getCustomerUrl() {
    return this.prefixWithBaseUrl(this.paths.customer.get);
  }
  getCustomerSeatsGetUrl() {
    return this.prefixWithBaseUrl(this.paths.customer.getSeats);
  }
  getCustomerSeatsAddUrl() {
    return this.prefixWithBaseUrl(this.paths.customer.addSeats);
  }
  getScopeUrl() {
    return this.prefixWithBaseUrl(this.paths.scope);
  }
  getEntityPath(entityName, id) {
    if (!id) {
      return entityName;
    }
    return this.replacePlaceholders(`${entityName}/{${entityName}ID}`, id);
  }
  prefixWithThreeDotOneBaseUrl(path) {
    return this.combinePaths(this.config.threeDotOneBaseUrl, path);
  }
  prefixApiUrl(path, configBase = 'baseUrl') {
    return this.combinePaths(this.config[configBase], path);
  }
  prefixWithBaseUrl(path) {
    return this.combinePaths(this.config.baseUrl, path);
  }
  withBasePrefix(path, replacement) {
    if (replacement) {
      return this.prefixWithBaseUrl(this.replacePlaceholders(path, replacement));
    } else {
      return this.prefixWithBaseUrl(path);
    }
  }
  prefixWithCRMBaseUrl(path) {
    return this.combinePaths(this.config.crmBaseUrl, path);
  }
  combinePaths(path1, path2) {
    if (path1.endsWith('/') && path2.startsWith('/')) {
      return path1 + path2.substr(1);
    } else {
      return path1 + path2;
    }
  }
  getUrlEndodedAuthObject(username, password) {
    return this.formUrlEncode({
      username: username,
      password: password,
      grant_type: 'password',
      client_id: this.config.client_id
    });
  }
  getUrlEncodedRefreshTokenObject(refreshTokenValue) {
    return this.formUrlEncode({
      grant_type: 'refresh_token',
      refresh_token: refreshTokenValue,
      client_id: this.config.client_id
    });
  }
  setConfig(config) {
    this.config = config;
  }
  addForwardSlash(value) {
    if (value[value.length - 1] !== '/') {
      return value + '/';
    }
    return value;
  }
  setTeamIdsToTeams(teams) {
    for (const team of teams) {
      team.team_ids = [team.id];
    }
  }
  jobsToJobsInfo(jobs) {
    if (!jobs || jobs.length === 0) {
      return [];
    }
    const jobInfos = [];
    for (const job of jobs) {
      jobInfos.push({
        job: job,
        totals: this.calculateJobStagesTotals(job.stages)
      });
    }
    return jobInfos;
  }
  calculateJobStagesTotals(jobStages) {
    let total = 0;
    let totalCompleted = 0;
    let totalErrors = 0;
    if (jobStages && jobStages.length > 0) {
      for (const stage of jobStages) {
        total += stage.size;
        totalCompleted += stage.completed;
        totalErrors += stage.errors;
      }
    } else {
      return {
        completedPercentage: 0,
        completedCount: 0,
        totalCount: 0,
        errorsCount: 0
      };
    }
    const completedPercentage = Math.floor(totalCompleted / total * 100);
    const result = {
      completedPercentage: completedPercentage,
      completedCount: totalCompleted,
      errorsCount: totalErrors,
      totalCount: total
    };
    return result;
  }
  // Stages paths
  getStagesGetUrl(parentType, parentID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.getMany, {
      parentType: parentType,
      parentID: parentID
    }));
  }
  getStageCreateUrl(parentType, parentID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.create, {
      parentType: parentType,
      parentID: parentID
    }));
  }
  getStageReorderUrl(parentType, parentID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.reorder, {
      parentType: parentType,
      parentID: parentID
    }));
  }
  getStageGetUrl(stageID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.get, stageID));
  }
  getStageUpdateUrl(stageID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.update, stageID));
  }
  getStageDeleteUrl(stageID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.delete, stageID));
  }
  getStageFormsUrl(stageID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.stageForms, stageID));
  }
  getStageProcessUrl(stageID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.stageProcess, stageID));
  }
  getStageActorUrl(stageID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.stageActor, stageID));
  }
  getStageThankYouPageUrl(stageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.stageThankYouPage, stageId));
  }
  getStageCancellationFormUrl(stageId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.stage.stageCancellationForm, stageId));
  }
  getEventsCountersGetUrl() {
    return this.prefixWithBaseUrl(this.paths.stages.stage.getEventCounters);
  }
  getProcessesGetUrl(parentType, parentID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.getMany, {
      parentType: parentType,
      parentID: parentID
    }));
  }
  getEventBookingProcessesGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.getEventBookingMany, eventId));
  }
  getEventBookingProcessCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.createEventBooking, eventId));
  }
  getEventParticipantProcessesGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.getEventParticipantMany, eventId));
  }
  getEventParticipantProcessCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.createEventParticipant, eventId));
  }
  getSearchEventParticipantProcessesUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.searchEventParticipantProcesses, eventId));
  }
  getSearchEventParticipantProcessesPayload(req) {
    const result = {
      process_filter: {}
    };
    this.setAdvancedQueryProps(result, result.process_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getLocalEventProcessesGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.getLocalEventMany, eventId));
  }
  getLocalEventProcessCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.createLocalEvent, eventId));
  }
  getGlobalProcessesGetUrl(globalType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.getGlobalMany, globalType));
  }
  getProcessCreateUrl(parentType, parentID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.create, {
      parentType: parentType,
      parentID: parentID
    }));
  }
  getGlobalProcessCreateUrl(globalType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.createGlobal, globalType));
  }
  getProcessGetUrl(processID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.get, processID));
  }
  getProcessUpdateUrl(processID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.update, processID));
  }
  getProcessDeleteUrl(processID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.delete, processID));
  }
  getProcessStepsUrl(processID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.processSteps, processID));
  }
  getProcessTriggerUrl(processID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.process.processTrigger, processID));
  }
  getProcessInterruptUrl(processID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.processControl.interrupt, processID));
  }
  getProcessPauseUrl(processID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.processControl.pause, processID));
  }
  getProcessResumeUrl(processID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.stages.processControl.resume, processID));
  }
  // Event workflow paths
  getEventWorkflowQRCodeScanUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.qrCodeScan, eventId));
  }
  getEventWorkflowScanStagesUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.scanStages, eventId));
  }
  getEventWaitingListWidgetDataUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.widgets.getEventWaitinglistData, {
      parentType: "event" /* EventWorkflowParentType.event */,
      parentID: eventId
    }));
  }
  getEventWorkflowReorderUrl(parentType, parentID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.reorder, {
      parentType: parentType,
      parentID: parentID
    }));
  }
  getEventWorkflowCreateUrl(parentType, parentID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.create, {
      parentType: parentType,
      parentID: parentID
    }));
  }
  getEventWorkflowGetAllUrl(parentType, parentID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.getAll, {
      parentType: parentType,
      parentID: parentID
    }));
  }
  getEventWorkflowGetUrl(workflowID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.get, workflowID));
  }
  getEventWorkflowUpdateUrl(workflowID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.update, workflowID));
  }
  getEventWorkflowDeleteUrl(workflowID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflows.delete, workflowID));
  }
  getEventWorkflowBuilderPublishUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflowBuilder.draft.publish, eventId));
  }
  getEventWorkflowBuilderRevertPublishedUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventWorkflowBuilder.draft.revert, eventId));
  }
  // Event payments - payment provider
  getEventPaymentProviderGetUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventPaymentProvider, eventID));
  }
  getEventPaymentProviderUpdateUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventPaymentProvider, eventID));
  }
  // Payments - Product group relations
  getGetProductsForEntityUrl(entityType, entityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.getProductsForEntity, {
      entityType: entityType,
      entityId: entityId
    }));
  }
  getProductGroupsByEntityGetUrl(entityType, entityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.getByEntity, {
      entityType: entityType,
      entityId: entityId
    }));
  }
  getProductGroupSettingsByEntityGetUrl(groupId, entityType, entityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.getSettingsByEntity, {
      groupID: groupId,
      entityType: entityType,
      entityId: entityId
    }));
  }
  getProductGroupSettingsByEntitySaveUrl(groupId, entityType, entityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.saveSettingsByEntity, {
      groupID: groupId,
      entityType: entityType,
      entityId: entityId
    }));
  }
  getProductGroupRelationsSearchUr(groupID, entityType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.searchEntities, {
      groupID,
      entityType
    }));
  }
  getProductGroupRelationsSetProductsUrl(groupID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.setProducts, groupID));
  }
  getProductGroupRelationsRemoveProductsUrl(groupID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.removeProducts, groupID));
  }
  getProductGroupRelationsSetEntitiesUrl(groupID, entityType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.setEntities, {
      groupID: groupID,
      entityType: entityType
    }));
  }
  getProductGroupRelationsRemoveEntitiesUrl(groupID, entityType) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_group_relations.removeEntities, {
      groupID: groupID,
      entityType: entityType
    }));
  }
  // Payments - Product groups
  getProductGroupsGetAllUrl() {
    return this.prefixWithBaseUrl(this.paths.product_groups.getAll);
  }
  getProductGroupCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.product_groups.create);
  }
  getProductGroupGetUrl(groupId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_groups.get, groupId));
  }
  getProductGroupDeleteUrl(groupId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_groups.delete, groupId));
  }
  getProductGroupUpdateUrl(groupId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.product_groups.update, groupId));
  }
  getProductGroupsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.product_groups.search);
  }
  getSearchProductGroupsPayload(req) {
    const result = {
      product_group_filter: {}
    };
    this.setAdvancedQueryProps(result, result.product_group_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // Project
  getProjectSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.project.search);
  }
  getProjectSearchPayload(req) {
    const result = {
      project_filter: {}
    };
    this.setAdvancedQueryProps(result, result.project_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getProjectGetUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.get, projectId));
  }
  getProjectUpdateUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.update, projectId));
  }
  getProjectCopyUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.copy, projectId));
  }
  getProjectDeleteUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.delete, projectId));
  }
  getProjectCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.project.create);
  }
  // Project Teams
  getProjectAddTeamUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.team.add, projectId));
  }
  getProjectRemoveTeamUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.team.remove, projectId));
  }
  // Project Events
  getProjectAddEventUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.event.add, projectId));
  }
  getProjectRemoveEventUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.event.remove, projectId));
  }
  // Project Category
  getProjectCategorySearchUrl() {
    return this.prefixWithBaseUrl(this.paths.project.category.search);
  }
  getProjectCategorySearcPayload(req) {
    const result = {
      category_filter: {}
    };
    this.setAdvancedQueryProps(result, result.category_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  getProjectCategoryUpdateUrl(categoryId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.category.update, categoryId));
  }
  getProjectCategoryDeleteUrl(categoryId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.category.delete, categoryId));
  }
  getProjectCategoryCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.project.category.create);
  }
  // Project Task
  getProjectTasksSearchUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.search, projectId));
  }
  getProjectTaskSearchPayload(req) {
    const result = {
      task_filter: {}
    };
    this.setAdvancedQueryProps(result, result.task_filter, req, text => this.getNameLikeFilter(text));
    // Clean up empty task_filter's property, otherwise BE returns error
    Object.entries(result.task_filter).forEach(([key, value]) => {
      if (Array.isArray(value) && !(value?.length > 0)) {
        delete result.task_filter[key];
      }
    });
    return result;
  }
  getProjectTasksListUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.list, projectId));
  }
  getProjectTasksBulkDeleteUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.bulkDelete, projectId));
  }
  getProjectTasksBulkUpdateStatusUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.bulkUpdateStatus, projectId));
  }
  getProjectTaskCreateUrl(projectId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.create, projectId));
  }
  getProjectTaskGetUrl(taskId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.get, taskId));
  }
  getProjectTaskDeleteUrl(taskId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.delete, taskId));
  }
  getProjectTaskUpdateUrl(taskId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.update, taskId));
  }
  getProjectTaskUnassignTeamsUrl(taskId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.unassignTeam, taskId));
  }
  getProjectTaskAssignTeamsUrl(taskId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.assignTeam, taskId));
  }
  getProjectTaskUnassignUsersUrl(taskId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.unassignUser, taskId));
  }
  getProjectTaskAssignUsersUrl(taskId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.project.task.assignUser, taskId));
  }
  // Payments - Products
  sanitizeProduct(product) {
    const sanitized = {
      ...product
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return omit(sanitized, ['module', 'event_id']);
  }
  getProductsGetAllUrl() {
    return this.prefixWithBaseUrl(this.paths.products.getAll);
  }
  getProductCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.products.create);
  }
  getProductGetUrl(productId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.products.get, productId));
  }
  getProductDeleteUrl(productId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.products.delete, productId));
  }
  getProductUpdateUrl(productId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.products.update, productId));
  }
  getProductsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.products.search);
  }
  getSearchProductsPayload(req) {
    const result = {
      product_filter: {}
    };
    this.setAdvancedQueryProps(result, result.product_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // Payments - Cancellation terms
  getCancellationTermsGetAllUrl() {
    return this.prefixWithBaseUrl(this.paths.cancellation_terms.getAll);
  }
  getCancellationTermCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.cancellation_terms.create);
  }
  getCancellationTermGetUrl(cancellationTermId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.cancellation_terms.get, cancellationTermId));
  }
  getCancellationTermDeleteUrl(cancellationTermId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.cancellation_terms.delete, cancellationTermId));
  }
  getCancellationTermUpdateUrl(cancellationTermId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.cancellation_terms.update, cancellationTermId));
  }
  getCancellationTermsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.cancellation_terms.search);
  }
  getSearchCancellationTermsPayload(req) {
    const result = {
      cancellation_terms_filter: {}
    };
    this.setAdvancedQueryProps(result, result.cancellation_terms_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // Payments - Taxes
  getTaxesGetAllUrl() {
    return this.prefixWithBaseUrl(this.paths.taxes.getAll);
  }
  getTaxCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.taxes.create);
  }
  getTaxGetUrl(taxId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.taxes.get, taxId));
  }
  getTaxDeleteUrl(taxId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.taxes.delete, taxId));
  }
  getTaxUpdateUrl(taxId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.taxes.update, taxId));
  }
  getTaxesSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.taxes.search);
  }
  getSearchTaxesPayload(req) {
    const result = {
      tax_filter: {}
    };
    this.setAdvancedQueryProps(result, result.tax_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // URLs - it looks like this one is a replacement for the one below ("this.paths.marketingUrl")
  sanitizeEventMarketingUrlForCreate(eventMarketingUrl) {
    const sanitized = {
      ...eventMarketingUrl
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return sanitized;
  }
  sanitizeEventMarketingUrlForUpdate(eventMarketingUrl) {
    const sanitized = {
      ...eventMarketingUrl
    };
    this.deleteIdCreatedAtUpdatedAt(sanitized);
    return sanitized;
  }
  getIngressesGetUrl() {
    return this.prefixWithThreeDotOneBaseUrl(this.paths.urlIngress.get);
  }
  getEventMarketingUrlGetUrl(eventMarketingUrlId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.url.get, eventMarketingUrlId));
  }
  getEventMarketingUrlCreateUrl(eventId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.url.create, eventId));
  }
  getEventMarketingUrlUpdateUrl(eventMarketingUrlId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.url.update, eventMarketingUrlId));
  }
  getEventMarketingUrlSearchUrl(eventId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.url.search, eventId));
  }
  getSearchEventMarketingUrlsPayload(req) {
    const result = {
      marketing_url_filter: {}
    };
    this.setAdvancedQueryProps(result, result.marketing_url_filter, req, text => [{
      path: this.getLikeObject(text)
    }]);
    return result;
  }
  getEventMarketingUrlDeleteUrl(eventMarketingUrlId) {
    return this.prefixWithThreeDotOneBaseUrl(this.replacePlaceholders(this.paths.url.delete, eventMarketingUrlId));
  }
  // Marketing url paths
  getMarketingUrlCreateUrl(entityType, entityID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.marketingUrl.create, {
      entityType: entityType,
      entityID: entityID
    }));
  }
  getMarketingUrlGetAllUrl(entityType, entityID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.marketingUrl.getAll, {
      entityType: entityType,
      entityID: entityID
    }));
  }
  getMarketingUrlUpdateUrl(marketingUrlId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.marketingUrl.update, marketingUrlId));
  }
  getMarketingUrlDeleteUrl(marketingUrlId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.marketingUrl.update, marketingUrlId));
  }
  // Integrations paths
  getIntegrationCreateUrl() {
    return this.prefixWithBaseUrl(this.paths.integrations.create);
  }
  getIntegrationGetUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.get, integrationId));
  }
  getIntegrationDeleteUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.delete, integrationId));
  }
  getIntegrationUpdateUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.update, integrationId));
  }
  getIntegrationsGetAllUrl() {
    return this.prefixWithBaseUrl(this.paths.integrations.getAll);
  }
  getIntegrationsSearchUrl() {
    return this.prefixWithBaseUrl(this.paths.integrations.search);
  }
  getIntegrationsListUrl() {
    return this.prefixWithBaseUrl(this.paths.integrations.list);
  }
  getIntegrationsGetSettingsUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.getSettings, integrationId));
  }
  getIntegrationsPutSettingsUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.putSettings, integrationId));
  }
  getIntegrationWebhookLogsUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.getWebhookLogs, integrationId));
  }
  getIntegrationWebhookLogEventCallRequestUrl(callId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.getWebhookCallRequests, callId));
  }
  getIntegrationLogGetUrl(integrationId, logId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.getExternalCRMLog, {
      integrationID: integrationId,
      logID: logId
    }));
  }
  getExternalCRMIntegrationLogsSearchUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.searchExternalCRMLogs, integrationId));
  }
  getExternalCRMIntegrationLogsClearUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.clearExternalCRMLogs, integrationId));
  }
  getSearchExternalCRMIntegrationLogsPayload(req) {
    const result = {
      object_mapping_filter: this.createSearchExternalCRMIntegrationLogsPayloadObjectMappingFilter(req.quickSearchText?.trim()),
      log_filter: {}
    };
    this.setAdvancedQueryProps(result, result.log_filter, req, null);
    return result;
  }
  createSearchExternalCRMIntegrationLogsPayloadObjectMappingFilter(quickSearchText) {
    if (!quickSearchText) {
      return {};
    }
    const result = {
      or: []
    };
    const isBSON = /^[a-f0-9]{24}$/.test(quickSearchText);
    if (isBSON) {
      result.or.push({
        'azavista.id': quickSearchText
      });
    }
    result.or.push({
      'external.id': quickSearchText
    });
    return result;
  }
  getAccountingIntegrationLogsSearchUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.searchAccountingLogs, integrationId));
  }
  getAccountingIntegrationResendOrderUrl(integrationID, orderID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.resendAccountingOrder, {
      integrationID,
      orderID
    }));
  }
  getSearchAccountingIntegrationLogsPayload(req) {
    const result = {
      log_filter: {}
    };
    this.setAdvancedQueryProps(result, result.log_filter, req, text => [{
      contact_id: this.getEqObject(text)
    }, {
      participant_id: this.getEqObject(text)
    }, {
      order_id: this.getEqObject(text)
    }, {
      organization_id: this.getEqObject(text)
    }, {
      event_id: this.getEqObject(text)
    }, {
      order_number: this.getEqObject(text)
    }]);
    return result;
  }
  getExternalCrmObjectMappingDeleteUrl(integrationId, objectMappingId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.deleteObjectMapping, {
      integrationID: integrationId,
      objectmappingID: objectMappingId
    }));
  }
  getExternalCrmObjectMappingSearchUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.searchObjectMapping, integrationId));
  }
  getExternalCrmObjectMappingSearchPayload(req) {
    const result = {
      object_mapping_filter: {}
    };
    // Quick search object mapping is special - if it is ObjectId then add 'azavista.id' and 'external.id',
    // otherwise add only 'external.id'
    const objectIdRegExp = new RegExp(/^[a-fA-F0-9]{24}$/);
    const isQuickSearchTextBsonObjectId = objectIdRegExp.test(req.quickSearchText);
    this.setAdvancedQueryProps(result, result.object_mapping_filter, req, text => {
      if (!text) {
        return [];
      }
      const items = [];
      if (isQuickSearchTextBsonObjectId) {
        items.push({
          'azavista.id': text
        });
      }
      items.push({
        'external.id': text
      });
      return items;
    });
    return result;
  }
  getMessagingGatewayIntegrationLogsSearchUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.searchMessagingGatewayLogs, integrationId));
  }
  getAddTeamsToIntegrationUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.addTeams, integrationId));
  }
  getRemoveTeamsFromIntegrationUrl(integrationId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.integrations.removeTeams, integrationId));
  }
  getSearchMessagingGatewayIntegrationLogsPayload(req) {
    const result = {
      message_filter: {}
    };
    this.setAdvancedQueryProps(result, result.message_filter, req, text => [{
      action_id: this.getLikeObject(text)
    }]);
    return result;
  }
  getSearchIntegrationsPayload(req) {
    const result = {
      integration_filter: {}
    };
    this.setAdvancedQueryProps(result, result.integration_filter, req, text => this.getNameLikeFilter(text));
    return result;
  }
  // Activities paths
  getEventActivitiesSearchUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.search, eventId));
  }
  getEventActivityCreateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.create, eventId));
  }
  getEventActivityDeleteUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.delete, eventId));
  }
  getEventActvitiesBulkDeleteUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.bulkDelete, eventId));
  }
  getEventActivityUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.update, eventId));
  }
  getEventActivitiesBulkUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.bulkUpdate, eventId));
  }
  getEventActivityGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.get, eventId));
  }
  getSearchEventActivitiesPayload(req) {
    const result = {
      activity_filter: {}
    };
    this.setAdvancedQueryProps(result, result.activity_filter, req, text => this.getActivitiesSearchTextFilter(text));
    return result;
  }
  getUpdateActivitiesConditionFilterPayload(req) {
    const result = {
      activity_filter: {},
      activity_condition_id: req.activityConditionId
    };
    // TODO: ISortField is not allowed on the server
    const sortField = {};
    this.setAdvancedQueryProps(sortField, result.activity_filter, req.activity_filter, text => this.getActivitiesSearchTextFilter(text));
    return result;
  }
  getUpdateActivitiesGroupFilterPayload(req) {
    const result = {
      activity_filter: {},
      activity_group_id: req.activityGroupId
    };
    // TODO: ISortField is not allowed on the server
    const sortField = {};
    this.setAdvancedQueryProps(sortField, result.activity_filter, req.activity_filter, text => this.getActivitiesSearchTextFilter(text));
    return result;
  }
  getEventActivitiesParticipantsExportUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.exportParticipants, eventId));
  }
  getEventActivityParticipantsExportUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.exportActivityParticipants, activityId));
  }
  getEventActivitiesExportUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.export, eventId));
  }
  getEventActivityCheckinUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.checkin, activityId));
  }
  getEventActivityGlobalSettingsGetUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.globalSettings, eventId));
  }
  getEventActivityGlobalSettingsUpdateUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.globalSettings, eventId));
  }
  getEventActivitySettingsGetUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.getSettings, activityId));
  }
  getEventActivitySettingsUpdateUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.updateSettings, activityId));
  }
  sanitizeEventActivity(activity) {
    const sanitizedActivity = this.removeExternalId({
      ...activity
    });
    this.deleteIdCreatedAtUpdatedAt(sanitizedActivity);
    return sanitizedActivity;
  }
  // Activities - Speakers
  getEventActivitySpeakersCreateUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.speakers.create, activityId));
  }
  getEventActivitySpeakersGetUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.speakers.get, activityId));
  }
  getEventActivitySpeakersDeleteUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.speakers.delete, activityId));
  }
  // Activities - Moderators
  getEventActivityModeratorsCreateUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.moderators.create, activityId));
  }
  getEventActivityModeratorsGetUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.moderators.get, activityId));
  }
  getEventActivityModeratorsDeleteUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.moderators.delete, activityId));
  }
  // Activities - registered participants
  getEventActivityRegisteredParticipantsGetUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.registeredParticipants.get, activityId));
  }
  getEventActivityRegisteredParticipantsSearchUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.registeredParticipants.search, activityId));
  }
  getEventActivityRegisteredParticipantsSendMessageUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.sendMessage, activityId));
  }
  getEventActivityRegisteredParticipantsUpdateActivityParticipantUrl(params) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.registeredParticipants.updateActivityParticipant, params));
  }
  getEventActivityRegisteredParticipantsBulkUpdateStatusUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.registeredParticipants.bulkUpadeStatus, activityId));
  }
  getEventActivitiesParticipantsBulkAddUrl(eventId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.bulkAddParticipantsToActivities, eventId));
  }
  getEventActivityRegisteredParticipantsRemoveUrl(activityId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventActivities.registeredParticipants.remove, activityId));
  }
  getSearchEventActivityRegisteredParticipantsPayload(req) {
    const result = {
      participant_filter: {}
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getAddEventParticipantsToActivitiesInBulkPayload(req, activityIds) {
    const result = {
      activity_ids: activityIds,
      participant_filter: {}
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  getBulkUpdateEventActivityRegisteredParticipantsStatusPayload(req, status) {
    const result = {
      participant_filter: {},
      status: status
    };
    this.setAdvancedQueryProps(result, result.participant_filter, req, text => this.getFirstLastEmailFilter(text));
    return result;
  }
  // Event Onsite
  getEventOnsiteSettingsGetUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSettings.get, eventID));
  }
  getEventOnsiteSettingsUpdateUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventSettings.update, eventID));
  }
  // Event Product
  getEventProductCreateUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventProduct.create, eventID));
  }
  getEventProductSearchUrl(eventID) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.eventProduct.search, eventID));
  }
  getEventProductSearchPayload(req) {
    const result = {
      product_filter: {}
    };
    this.setAdvancedQueryProps(result, result.product_filter, req, text => [{
      name: this.getLikeObject(text)
    }]);
    return result;
  }
  // Copy clusters
  getCopyClustersGetUrl() {
    return this.prefixWithBaseUrl(this.paths.copyCluster.get);
  }
  getCopyClusterEventItemsGetUrl(clusterId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.copyCluster.event.get, clusterId));
  }
  getCopyClusterEventItemCreateUrl(clusterId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.copyCluster.event.post, clusterId));
  }
  getCopyClusterThemeItemsGetUrl(clusterId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.copyCluster.theme.get, clusterId));
  }
  getCopyClusterThemeItemCreateUrl(clusterId) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.copyCluster.theme.post, clusterId));
  }
  // External CRM
  getExternalCrmModulesGetUrl(integrationID, crmSyncObject) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.extenralCrm.getModules, {
      integrationID: integrationID,
      crmSyncObject: crmSyncObject
    }));
  }
  getExternalCrmFieldsGetUrl(integrationID, crmSyncObject) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.extenralCrm.getFields, {
      integrationID: integrationID,
      crmSyncObject: crmSyncObject
    }));
  }
  getExternalCrmFieldMappingsGetUrl(integrationID, crmSyncObject) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.extenralCrm.getFieldMappings, {
      integrationID: integrationID,
      crmSyncObject: crmSyncObject
    }));
  }
  getExternalCrmFieldMappingsUpdateUrl(integrationID, crmSyncObject) {
    return this.prefixWithBaseUrl(this.replacePlaceholders(this.paths.extenralCrm.updateFieldMappings, {
      integrationID: integrationID,
      crmSyncObject: crmSyncObject
    }));
  }
}
function pick$1(data, propsNames) {
  return Object.entries(data).reduce((result, [key, value]) => {
    const keyWithType = key;
    if (propsNames.includes(keyWithType)) {
      result[keyWithType] = value;
    }
    return result;
  }, {});
}
const convertDependencyToV2 = dependency => {
  if (dependency.version === 'v2') {
    return dependency;
  }
  return {
    ...convertDependency(dependency),
    version: 'v2'
  };
};
let AzavistaApiUtilsService = /*#__PURE__*/(() => {
  class AzavistaApiUtilsService extends AzavistaApiUtilsServiceBase {
    replaceAuthorizationHeaderValue(req, newAuthorizationHeaderValue) {
      // const queryParamsObject = req. req.headers.
      const headersObject = {};
      req.headers.keys().forEach(x => headersObject[x] = req.headers.getAll(x));
      const paramsObject = {};
      req.params.keys().forEach(x => paramsObject[x] = req.params.getAll(x));
      const request = this.createRequest(req.method, req.url, newAuthorizationHeaderValue, req.body, paramsObject, headersObject);
      return request;
    }
    createRequest(method,
    // config: IApiServiceConfig,
    url, authorizationHeaderValue, body, queryParams, headers, responseType, requestInit) {
      const params = new HttpParams({
        fromObject: queryParams
      });
      const finalHeaders = this.getHeaders(headers, authorizationHeaderValue);
      const req = new HttpRequest(method, url, body, {
        headers: finalHeaders,
        params: params,
        responseType: responseType,
        ...requestInit
      });
      return req;
    }
    getHeaders(headers, authorizaionHeaderValue) {
      const resultHeaders = {
        ...headers
      };
      if (authorizaionHeaderValue) {
        resultHeaders.Authorization = authorizaionHeaderValue;
      }
      const result = new HttpHeaders(resultHeaders);
      return result;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵAzavistaApiUtilsService_BaseFactory;
        return function AzavistaApiUtilsService_Factory(__ngFactoryType__) {
          return (ɵAzavistaApiUtilsService_BaseFactory || (ɵAzavistaApiUtilsService_BaseFactory = i0.ɵɵgetInheritedFactory(AzavistaApiUtilsService)))(__ngFactoryType__ || AzavistaApiUtilsService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaApiUtilsService,
        factory: AzavistaApiUtilsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaApiUtilsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function pick(data, propsNames) {
  return Object.entries(data).reduce((result, [key, value]) => {
    const keyWithType = key;
    if (propsNames.includes(keyWithType)) {
      result[keyWithType] = value;
    }
    return result;
  }, {});
}
function omit(data, propsNames) {
  return pick(data, Object.keys(data).filter(key => !propsNames.includes(key)));
}
class AzavistaApiServiceBase {
  constructor(utilsSvc) {
    this.utilsSvc = utilsSvc;
    this.authorizationHeaderValue = '';
    this.authTokenUrl = '';
    this.formUrlEncodedHeader = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    this.headerContentTypeJson = {
      'Content-Type': 'application/json'
    };
    this.tokenRetrievedAtMilliseconds = 0;
  }
  async init(config) {
    this.config = config;
    this.addForwardSlashToConfig(this.config);
    this.utilsSvc.setConfig(this.config);
    this.authTokenUrl = this.utilsSvc.getAuthTokenUrl();
    const processInternalAuthResponseResult = this.processInternalAuthenticationResponseFromStorage();
    if (processInternalAuthResponseResult) {
      return this.applyInternalAuthResponseResult(processInternalAuthResponseResult);
    } else {
      return null;
    }
  }
  async applyInternalAuthResponseResult(processInternalAuthResponseResult) {
    this.authorizationHeaderValue = this.utilsSvc.getAuthorizationHeaderFromResponse(processInternalAuthResponseResult.internalAuthResponse);
    const userScopesRes = await this.setUserScopesToToken(processInternalAuthResponseResult.authResponse.token.u);
    this.teamIds = this.utilsSvc.getTeamIdsFromUserScopes(userScopesRes.scopes);
    processInternalAuthResponseResult.authResponse.token.s = this.accessTokenInfo.payload.s;
    return processInternalAuthResponseResult.authResponse;
  }
  addForwardSlashToConfig(config) {
    this.config.baseUrl = this.utilsSvc.addForwardSlash(this.config.baseUrl);
    this.config.crmBaseUrl = this.utilsSvc.addForwardSlash(this.config.crmBaseUrl);
    this.config.threeDotOneBaseUrl = this.utilsSvc.addForwardSlash(this.config.threeDotOneBaseUrl);
  }
  // Authentication
  async authenticate(req) {
    this.clearAuthData();
    const body = this.utilsSvc.getUrlEndodedAuthObject(req.username, req.password);
    const response = await this.postWithHeaders(this.utilsSvc.getAuthTokenUrl(), body, this.formUrlEncodedHeader, null, 'authenticate');
    this.tokenRetrievedAtMilliseconds = this.utilsSvc.getNow();
    const authResult = this.processInternalAuthenticationResponse(response);
    await this.setUserScopesToToken(this.accessTokenInfo.payload.u);
    authResult.token.s = this.accessTokenInfo.payload.s;
    this.teamIds = this.utilsSvc.getTeamIdsFromUserScopes(authResult.token.s);
    return authResult;
  }
  async setUserScopesToToken(userId) {
    const userScopesRes = await this.getUserScopes(this.accessTokenInfo.payload.u);
    this.accessTokenInfo.payload.s = userScopesRes.scopes;
    return userScopesRes;
  }
  async setNewPassword(token, req) {
    this.clearAuthData();
    await this.putWithHeaders(this.utilsSvc.getUserPasswordUrl(), req, {
      authorization: `Bearer ${token}`
    }, null, 'setNewPassword');
  }
  async getPasswordResetToken(req) {
    // TODO: Use dedicated server endpoint instead of simply authenticating
    const body = this.utilsSvc.getUrlEndodedAuthObject(req.username, req.password);
    const response = await this.utilsSvc.createRequest('POST', this.utilsSvc.getAuthTokenUrl(), undefined, body, undefined, this.formUrlEncodedHeader, 'json');
    return response;
  }
  isAuthenticated() {
    return !!this.authorizationHeaderValue;
  }
  setTeamIdsFromToken(entities) {
    if (Array.isArray(entities)) {
      for (const entity of entities) {
        if (!entity.team_ids) {
          entity.team_ids = this.teamIds;
        }
      }
    } else {
      entities.team_ids = this.teamIds;
    }
  }
  delay(ms) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, ms);
    });
  }
  // Event badges
  async createEventBadge(eventId, badge) {
    const url = this.utilsSvc.getCreateEventBadgeUrl(eventId);
    const payload = this.utilsSvc.sanitizeIdCreatedAtUpdatedAt(badge);
    const response = await this.post(url, payload, 'createEventBadge');
    return response;
  }
  async searchEventBadges(eventId, req) {
    const url = this.utilsSvc.getSearchEventBadgesUrl(eventId);
    const payload = this.utilsSvc.getSearchEventBadgesPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(url, payload, queryParams, 'searchEventBadges');
    return response;
  }
  async getAllEventBadges(eventId) {
    return await this.getAllPagedItems(request => this.searchEventBadges(eventId, request), response => response.badges);
  }
  async deleteEventBadge(badgeId) {
    const url = this.utilsSvc.getDeleteEventBadgeUrl(badgeId);
    await this.delete(url, 'deleteEventBadge');
  }
  async getEventBadge(badgeId) {
    const url = this.utilsSvc.getGetEventBadgeUrl(badgeId);
    const response = await this.get(url, 'getEventBadge');
    return response;
  }
  async updateEventBadge(badge) {
    const url = this.utilsSvc.getUpdateEventBadgeUrl(badge.id);
    const sanitized = this.utilsSvc.sanitizeIdCreatedAtUpdatedAt(badge);
    const response = await this.patch(url, sanitized, 'updateEventBadge');
    return response;
  }
  // Badge - fonts
  async createEventBadgeFont(req) {
    const path = this.utilsSvc.getCreateEventBadgeFontUrl(req.eventId);
    const formData = new FormData();
    formData.set('type', req.type);
    formData.set('name', req.name);
    if (req.type === "custom" /* FontType.custom */) {
      formData.set('custom_name', req.custom_name);
      const blob = req.font.slice();
      formData.set('font', blob);
    }
    const res = await this.post(path, formData, 'createEventBadgeFont');
    return res;
  }
  async getEventBadgeFonts(eventId, req) {
    const path = this.utilsSvc.getEventBadgeFontsUrl(eventId);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const res = await this.getWithQuery(path, queryParams, 'getEventBadgeFonts');
    return res;
  }
  async getAllEventBadgeFonts(eventId) {
    const req = {
      limit: 50,
      offset: 0
    };
    const fonts = await this.getAllPagedItems(request => this.getEventBadgeFonts(eventId, request), response => response.fonts, req);
    return fonts;
  }
  async getEventBadgeFontFile(fontId) {
    const url = this.utilsSvc.getEventBadgeFontFileUrl(fontId);
    const response = await this.getFile(url);
    return response;
  }
  async deleteEventBadgeFont(fontId) {
    const url = this.utilsSvc.getDeleteEventBadgeFontUrl(fontId);
    await this.delete(url, 'deleteEventBadgeFont');
  }
  // Event - Project Management
  async getEventProjects(eventId, pagination) {
    const url = this.utilsSvc.getEventProjectsUrl(eventId);
    const queryParams = this.utilsSvc.sanitizePagedRequest(pagination);
    const response = await this.getWithQuery(url, queryParams, 'getEventProjects');
    return response;
  }
  async searchEventTasks(eventId, req) {
    const url = this.utilsSvc.getSearchEventTaskUrl(eventId);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const payload = this.utilsSvc.getProjectTaskSearchPayload(req);
    const response = await this.postWithQuery(url, payload, queryParams, 'searchEventTasks');
    return response;
  }
  // Pages
  async createPage(createPageRequest, pageType, eventId) {
    const url = this.utilsSvc.getCreatePageUrl();
    const payload = createPageRequest;
    const queryParams = {
      page_type: pageType
    };
    if (eventId) {
      queryParams.event_id = eventId;
    }
    const response = await this.postWithQuery(url, payload, queryParams, 'createPage');
    return response;
  }
  async searchPages(req) {
    const path = this.utilsSvc.getSearchPagesUrl();
    const payload = this.utilsSvc.getSearchPagesPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    if (req.eventId) {
      queryParams.event_id = req.eventId;
    }
    queryParams.page_type = req.pageType;
    const res = await this.postWithQuery(path, payload, queryParams, 'searchPages');
    return res;
  }
  // Activity conditions
  async updateActivitiesCondition(eventId, req) {
    const url = this.utilsSvc.getActivitiesConditionUpdateUrl(eventId);
    const payload = this.utilsSvc.getUpdateActivitiesConditionFilterPayload(req);
    const response = await this.post(url, payload, 'updateActivitiesCondition');
    return response;
  }
  async createActivityCondition(eventId, activityCondition) {
    const url = this.utilsSvc.getActivityConditionCreateUrl(eventId);
    const res = await this.post(url, activityCondition, 'createActivityCondition');
    return res;
  }
  async searchActivityConditions(eventId, req) {
    const url = this.utilsSvc.getActivityConditionsSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchActivityConditionsPayload(req);
    const res = await this.post(url, payload, 'searchActivityConditions');
    return res;
  }
  async getAllActivityConditions(eventId) {
    const activityConditions = await this.getAllPagedItems(request => this.searchActivityConditions(eventId, request), response => response.activity_conditions);
    return activityConditions;
  }
  async getActivityCondition(activityConditionId) {
    const url = this.utilsSvc.getActivityConditionGetUrl(activityConditionId);
    const res = await this.get(url, 'getActivityCondition');
    return res;
  }
  async updateActivityCondition(activityCondition) {
    const url = this.utilsSvc.getActivityConditionUpdateUrl(activityCondition.id);
    const sanitized = this.utilsSvc.sanitizeActivityConditionForUpdate(activityCondition);
    const res = await this.patch(url, sanitized, 'updateActivityCondition');
    return res;
  }
  async deleteActivityCondition(activityConditionId) {
    const url = this.utilsSvc.getActivityConditionDeleteUrl(activityConditionId);
    await this.delete(url, 'deleteActivityCondition');
  }
  // Activity groups
  async updateActivitiesGroup(eventId, req) {
    const url = this.utilsSvc.getActivitiesGroupUpdateUrl(eventId);
    const payload = this.utilsSvc.getUpdateActivitiesGroupFilterPayload(req);
    const response = await this.post(url, payload, 'updateActivitiesGroup');
    return response;
  }
  async createActivityGroup(eventId, activityGroup) {
    const url = this.utilsSvc.getActivityGroupCreateUrl(eventId);
    const res = await this.post(url, activityGroup, 'createActivityGroup');
    return res;
  }
  async searchActivityGroups(eventId, req) {
    const url = this.utilsSvc.getActivityGroupsSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchActivityGroupsPayload(req);
    const res = await this.post(url, payload, 'searchActivityGroups');
    return res;
  }
  async getAllActivityGroups(eventId) {
    const activityGroups = await this.getAllPagedItems(request => this.searchActivityGroups(eventId, request), response => response.activity_groups);
    return activityGroups;
  }
  async getActivityGroup(activityGroupId) {
    const url = this.utilsSvc.getActivityGroupGetUrl(activityGroupId);
    const res = await this.get(url, 'getActivityGroup');
    return res;
  }
  async updateActivityGroup(activityGroup) {
    const url = this.utilsSvc.getActivityGroupUpdateUrl(activityGroup.id);
    const sanitized = this.utilsSvc.sanitizeActivityGroupForUpdate(activityGroup);
    const res = await this.patch(url, sanitized, 'updateActivityGroup');
    return res;
  }
  async deleteActivityGroup(activityGroupId) {
    const url = this.utilsSvc.getActivityGroupDeleteUrl(activityGroupId);
    await this.delete(url, 'deleteActivityGroup');
  }
  // Email campaign types
  async createEmailCampaignType(emailCampaignType) {
    const url = this.utilsSvc.getEmailCampaignTypeCreateUrl();
    const res = await this.post(url, emailCampaignType, 'createEmailCampaignType');
    return res;
  }
  async updateEmailCampaignTypeName(emailCampaignTypeID, name) {
    const url = this.utilsSvc.getEmailCampaignTypeUpdateUrl(emailCampaignTypeID);
    const payload = {
      name: name
    };
    const res = await this.patch(url, payload, 'updateEmailCampaignTypeName');
    return res;
  }
  async deleteEmailCampaignType(emailCampaignTypeID) {
    const url = this.utilsSvc.getEmailCampaignTypeDeleteUrl(emailCampaignTypeID);
    await this.delete(url, 'deleteEmailCampaignType');
  }
  async searchEmailCampaignTypes(req) {
    const url = this.utilsSvc.getEmailCampaignTypeSearchUrl();
    const payload = this.utilsSvc.getSearchEmailCampaignTypesPayload(req);
    const res = await this.post(url, payload, 'searchEmailCampaignTypes');
    return res;
  }
  async getAllEmailCampaignTypes() {
    const req = {
      limit: 50,
      offset: 0
    };
    const emailCampaignTypes = await this.getAllPagedItems(request => this.searchEmailCampaignTypes(request), response => response.email_campaign_types, req);
    return emailCampaignTypes;
  }
  async bulkSetEmailCampaignsField(req) {
    const emailCampaignFilter = this.utilsSvc.getSearchEmailCampaignsPayload(req.email_campaign_filter);
    const path = this.utilsSvc.getEmailCampaignsBulkFieldSetUrl();
    const payload = {
      ...emailCampaignFilter,
      update: req.update
    };
    const response = await this.post(path, payload, 'bulkSetEmailCampaignsField');
    return response;
  }
  async bulkSetEmailCampaignsHeader(req, header_page_id, event_id) {
    const emailCampaignFilter = this.utilsSvc.getSearchEmailCampaignsPayload(req);
    const path = this.utilsSvc.getEmailCampaignsBulkHeaderSetUrl();
    const queryParams = {
      event_id
    };
    const payload = {
      ...emailCampaignFilter,
      header_page_id
    };
    const response = await this.postWithQuery(path, payload, queryParams, 'bulkSetEmailCampaignsHeader');
    return response;
  }
  async bulkSetEmailCampaignsFooter(req, footer_page_id, event_id) {
    const emailCampaignFilter = this.utilsSvc.getSearchEmailCampaignsPayload(req);
    const path = this.utilsSvc.getEmailCampaignsBulkFooterSetUrl();
    const queryParams = {
      event_id
    };
    const payload = {
      ...emailCampaignFilter,
      footer_page_id
    };
    const response = await this.postWithQuery(path, payload, queryParams, 'bulkSetEmailCampaignsFooter');
    return response;
  }
  async bulkSetEmailCampaignsTheme(req, theme_id, event_id) {
    const emailCampaignFilter = this.utilsSvc.getSearchEmailCampaignsPayload(req);
    const path = this.utilsSvc.getEmailCampaignsBulkThemeSetUrl();
    const queryParams = {
      event_id
    };
    const payload = {
      ...emailCampaignFilter,
      theme_id
    };
    const response = await this.postWithQuery(path, payload, queryParams, 'bulkSetEmailCampaignsTheme');
    return response;
  }
  // System Email
  async getSystemEmailsList(pagedRequest) {
    const path = this.utilsSvc.getSystemEmailGetListUrl();
    const queryParams = pagedRequest;
    const response = await this.getWithQuery(path, queryParams, 'getSystemEmailsList');
    return response;
  }
  async createSystemEmail(createData) {
    const path = this.utilsSvc.getSystemEmailCreateUrl();
    const payload = createData;
    const response = await this.post(path, payload, 'createSystemEmail');
    return response;
  }
  async getSystemEmail(systemEmailId) {
    const path = this.utilsSvc.getSystemEmailGetUrl(systemEmailId);
    const response = await this.get(path, 'getSystemEmail');
    return response;
  }
  async updateSystemEmail(systemEmailId, updateData) {
    const path = this.utilsSvc.getSystemEmailUpdateUrl(systemEmailId);
    const payload = updateData;
    const response = await this.patch(path, payload, 'updateSystemEmail');
    return response;
  }
  async deleteSystemEmail(systemEmailId) {
    const path = this.utilsSvc.getSystemEmailDeleteUrl(systemEmailId);
    const response = await this.delete(path, 'deleteSystemEmail');
    return response;
  }
  // UTM parameters
  async createUtmParameter(type, utmParameter) {
    const url = this.utilsSvc.getUtmParameterCreateUrl();
    const sanitized = this.utilsSvc.sanitizeUtmParameterForCreate(utmParameter);
    const queryParams = {
      type
    };
    const res = await this.postWithQuery(url, sanitized, queryParams, 'createUtmParameter');
    return res;
  }
  async searchUtmParameters(type, req) {
    const url = this.utilsSvc.getUtmParametersSearchUrl();
    const queryParams = {
      type
    };
    const payload = this.utilsSvc.getSearchUtmParametersPayload(req);
    const res = await this.postWithQuery(url, payload, queryParams, 'searchUtmParameters');
    return res;
  }
  async getAllUtmParameters(type, req) {
    return await this.getAllPagedItems(request => this.searchUtmParameters(type, request), res => res.utm_parameters, req);
  }
  async updateUtmParameter(utmParameter) {
    const url = this.utilsSvc.getUtmParameterUpdateUrl(utmParameter.id);
    const sanitized = this.utilsSvc.sanitizeUtmParameterForUpdate(utmParameter);
    const res = await this.patch(url, sanitized, 'updateUtmParameter');
    return res;
  }
  async deleteUtmParameter(utmParameterId) {
    const url = this.utilsSvc.getUtmParameterDeleteUrl(utmParameterId);
    await this.delete(url, 'deleteUtmParameter');
  }
  // External CRM
  async getExternalCrmModules(integrationId, crmSyncObject) {
    const path = this.utilsSvc.getExternalCrmModulesGetUrl(integrationId, crmSyncObject);
    const response = await this.get(path, 'getExternalCrmModules');
    return response;
  }
  async getExternalCrmFields(integrationId, crmSyncObject) {
    const path = this.utilsSvc.getExternalCrmFieldsGetUrl(integrationId, crmSyncObject);
    const response = await this.get(path, 'getExternalCrmFields');
    return response;
  }
  async getExternalCrmFieldMappings(integrationId, crmSyncObject) {
    const path = this.utilsSvc.getExternalCrmFieldMappingsGetUrl(integrationId, crmSyncObject);
    const response = await this.get(path, 'getExternalCrmFieldMappings');
    return response;
  }
  async updateExternalCrmFieldMappings(integrationId, crmSyncObject, fieldMappings) {
    const path = this.utilsSvc.getExternalCrmFieldMappingsUpdateUrl(integrationId, crmSyncObject);
    const response = await this.put(path, fieldMappings, 'updateExternalCrmFieldMappings');
    return response;
  }
  // Reports
  async updateGlobalReportVersionName(versionId, name) {
    const path = this.utilsSvc.getGlobalReportVersionUpdateNameUrl(versionId);
    const payload = {
      name: name
    };
    await this.patch(path, payload, 'updateGlobalReportVersionName');
  }
  async searchGlobalReports(req, eventId) {
    const path = eventId ? this.utilsSvc.getEventReportsSearchUrl(eventId) : this.utilsSvc.getGlobalReportsSearchUrl();
    const payload = this.utilsSvc.getSearchGlobalReportsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchGlobalReports');
    return response;
  }
  async createGlobalReport(report, eventId) {
    const path = eventId ? this.utilsSvc.getEventReportCreateUrl(eventId) : this.utilsSvc.getGlobalReportCreateUrl();
    const payload = this.utilsSvc.sanitizeGlobalReportForCreate(report);
    const response = await this.post(path, payload, 'createGlobalReport');
    return response;
  }
  async getGlobalReport(reportId) {
    const path = this.utilsSvc.getGlobalReportGetUrl(reportId);
    const response = await this.get(path, 'getGlobalReport');
    return response;
  }
  async deleteGlobalReport(reportId) {
    const path = this.utilsSvc.getGlobalReportDeleteUrl(reportId);
    await this.delete(path, 'deleteGlobalReport');
  }
  async bulkDeleteGlobalReports(req) {
    const path = this.utilsSvc.getGlobalReportBulkDeleteUrl();
    const payload = this.utilsSvc.getBulkDeleteReportsPayload(req);
    await this.post(path, payload, 'bulkDeleteGlobalReports');
  }
  async bulkDeleteEventReports(eventId, req) {
    const path = this.utilsSvc.getEventReportsBulkDeleteUrl(eventId);
    const payload = this.utilsSvc.getBulkDeleteReportsPayload(req);
    await this.post(path, payload, 'bulkDeleteEventReports');
  }
  async updateGlobalReport(report) {
    const path = this.utilsSvc.getGlobalReportUpdateUrl(report.id);
    const sanitized = this.utilsSvc.sanitizeGlobalReportForUpdate(report);
    const response = await this.patch(path, sanitized, 'updateGlobalReport');
    return response;
  }
  async addGlobalReportTeams(reportId, teamIds) {
    const path = this.utilsSvc.getGlobalReportAddTeamsUrl(reportId);
    const payload = {
      ids: teamIds
    };
    await this.post(path, payload, 'addGlobalReportTeams');
  }
  async removeGlobalReportTeams(reportId, teamIds) {
    const path = this.utilsSvc.getGlobalReportRemoveTeamsUrl(reportId);
    const payload = {
      ids: teamIds
    };
    await this.post(path, payload, 'removeGlobalReportTeams');
  }
  async searchGlobalReportVersions(req, reportId) {
    const path = this.utilsSvc.getGlobalReportVersionsSearchUrl(reportId);
    const payload = this.utilsSvc.getSearchGlobalReportVersionsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchGlobalReportVersions');
    return response;
  }
  async getAllGlobalReportVersions(reportId) {
    const result = await this.getAllPagedItems(req => this.searchGlobalReportVersions(req, reportId), x => x.versions);
    return result;
  }
  async createGlobalReportVersion(reportId, startedAt) {
    const path = this.utilsSvc.getGlobalReportVersionCreateUrl(reportId);
    const body = startedAt ? {
      started_at: startedAt
    } : null;
    const response = await this.post(path, body, 'createGlobalReportVersion');
    return response;
  }
  async getGlobalReportVersion(versionId) {
    const path = this.utilsSvc.getGlobalReportVersionGetUrl(versionId);
    const response = await this.get(path, 'getGlobalReportVersion');
    return response;
  }
  async deleteGlobalReportVersion(versionId) {
    const path = this.utilsSvc.getGlobalReportVersionDeleteUrl(versionId);
    await this.delete(path, 'deleteGlobalReportVersion');
  }
  async exportGlobalReportVersionSpreadsheet(versionId, req) {
    const path = this.utilsSvc.getGlobalReportVersionexportSpreadsheetCreateUrl(versionId);
    const response = await this.post(path, req, 'exportGlobalReportVersionSpreadsheet');
    return response;
  }
  // Event rooms bookings
  async getEventRoomsBookings(eventId) {
    const path = this.utilsSvc.getEventRoomsBookingsGetManyUrl(eventId);
    const response = await this.get(path, 'getEventRoomsBookings');
    return response;
  }
  async getEventRoomBooking(bookingId) {
    const path = this.utilsSvc.getEventRoomBookingGetUrl(bookingId);
    const response = await this.get(path, 'getEventRoomBooking');
    return response;
  }
  async createEventRoomBooking(req, eventId) {
    const path = this.utilsSvc.getEventRoomBookingsCreateUrl(eventId);
    const sanitized = {
      ...req
    };
    delete sanitized.event_id;
    const res = await this.post(path, sanitized, 'createEventRoomBooking');
    return res;
  }
  async updateEventRoomBooking(booking) {
    const path = this.utilsSvc.getEventRoomBookingUpdateUrl(booking.id);
    const sanitized = this.utilsSvc.sanitizeEventRoomBooking(booking);
    const response = await this.patch(path, sanitized, 'updateEventRoomBooking');
    return response;
  }
  async deleteEventRoomBooking(bookingId) {
    const path = this.utilsSvc.getEventRoomBookingDeleteUrl(bookingId);
    const response = await this.delete(path, 'deleteEventRoomBooking');
    return response;
  }
  async setEventRoomBookingStatus(status, roomBookingId) {
    const path = this.utilsSvc.getEventRoomBookingSetStatusUrl(roomBookingId);
    const response = await this.put(path, {
      status
    }, 'setEventRoomBookingStatus');
    return response;
  }
  async setEventRoomBookingsStatusInBulk(req, eventId) {
    const path = this.utilsSvc.getEventRoomBookingsBulkSetStatusUrl(eventId);
    const payload = this.utilsSvc.getEventRoomBookingsBulkSetStatusPayload(req);
    const response = await this.post(path, payload, 'setEventRoomBookingsStatusInBulk');
    return response;
  }
  async searchEventRoomsBookings(req, eventId, findType) {
    const path = this.utilsSvc.getEventRoomBookingsSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchEventRoomBookingsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    queryParams.find = findType;
    const response = await this.postWithQuery(path, payload, queryParams, 'searchEventRoomsBookings');
    return response;
  }
  async searchAllEventRoomsBookings(request, eventId, findType) {
    return this.getAllPagedItems(req => this.searchEventRoomsBookings(req, eventId, findType), x => x.bookings, request);
  }
  // Event rooms settings
  async getEventRoomsSettings(eventId) {
    const path = this.utilsSvc.getEventRoomsSettingsGetManyUrl(eventId);
    const response = await this.get(path, 'getEventRoomsSettings');
    return response;
  }
  async getEventRoomSettings(roomId) {
    const path = this.utilsSvc.getEventRoomSettingsGetUrl(roomId);
    const response = await this.get(path, 'getEventRoomSettings');
    return response;
  }
  async createEventRoomSettings(req, eventId) {
    const path = this.utilsSvc.getEventRoomsSettingsCreateUrl(eventId);
    const res = await this.post(path, req, 'createEventRoomSettings');
    return res;
  }
  async updateEventRoomSettings(req, roomSettingId) {
    const path = this.utilsSvc.getEventRoomSettingsUpdateUrl(roomSettingId);
    const response = await this.patch(path, req, 'updateEventRoomSettings');
    return response;
  }
  async deleteEventRoomSettings(roomSettingId) {
    const path = this.utilsSvc.getEventRoomSettingsDeleteUrl(roomSettingId);
    const response = await this.delete(path, 'deleteEventRoomSettings');
    return response;
  }
  async searchEventRoomsSettings(req, eventId) {
    const path = this.utilsSvc.getEventRoomsSettingsSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchEventRoomsSettingsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchEventRoomsSettings');
    return response;
  }
  async getAllEventRoomsSettings(eventId) {
    const allRoomsSettings = await this.getAllPagedItems(x => this.searchEventRoomsSettings(x, eventId), x => x.room_settings);
    return allRoomsSettings;
  }
  // Location Floor Plans
  async getFloorPlan(floorPlanId) {
    const path = this.utilsSvc.getFloorPlanGetUrl(floorPlanId);
    const response = await this.get(path, 'getFloorPlan');
    return response;
  }
  async getFloorPlans(locationId) {
    const path = this.utilsSvc.getFloorPlansGetUrl(locationId);
    const response = await this.get(path, 'getFloorPlans');
    return response;
  }
  async createFloorPlan(req, locationId, file) {
    const path = this.utilsSvc.getFloorPlanCreateUrl(locationId);
    const queryParams = {
      filename: file.name,
      name: req.name
    };
    const res = await this.postWithHeaders(path, file, {
      'Content-Type': file.type
    }, queryParams, 'createFloorPlan');
    return res;
  }
  async updateFloorPlan(req, floorPlanId) {
    const path = this.utilsSvc.getFloorPlanUpdateUrl(floorPlanId);
    const res = this.patch(path, {
      name: req.name
    }, 'updateFloorPlan');
    return res;
  }
  async deleteFloorPlan(floorPlanId) {
    const path = this.utilsSvc.getFloorPlanDeleteUrl(floorPlanId);
    await this.delete(path, 'deleteFloorPlan');
  }
  async getFloorPlanToken(floorPlanId) {
    const path = this.utilsSvc.getFloorPlanGetTokenUrl(floorPlanId);
    const response = await this.get(path, 'getFloorPlanToken');
    return response;
  }
  async getFloorPlanFile(token, floorPlanId) {
    const path = this.utilsSvc.getFloorPlanGetFileUrl(floorPlanId);
    const queryParams = {
      token
    };
    const res = this.getWithQuery(path, queryParams, 'getFloorPlanFile');
    return res;
  }
  getFloorPlanFileDownloadUrl(floorPlanId, token) {
    return this.utilsSvc.getFloorPlanGetFileUrlWithToken(floorPlanId, token);
  }
  async putFloorPlanFile(file, floorPlanId) {
    const path = this.utilsSvc.getFloorPlanPutFileUrl(floorPlanId);
    const queryParams = {
      filename: file.name
    };
    const res = await this.putWithHeaders(path, file, {
      'Content-Type': file.type
    }, queryParams, 'putFloorPlanFile');
    return res;
  }
  // Locations team assignment/unassignment
  async setLocationTeams(req, locationId) {
    const path = this.utilsSvc.getLocationSetTeamsUrl(locationId);
    await this.put(path, {
      ids: req.ids
    }, 'setLocationTeams');
  }
  async assignLocationTeams(req, locationId) {
    const path = this.utilsSvc.getLocationAssignTeamsUrl(locationId);
    await this.post(path, {
      ids: req.ids
    }, 'assignLocationTeams');
  }
  async unassignLocationTeams(req, locationId) {
    const path = this.utilsSvc.getLocationUnassignTeamsUrl(locationId);
    await this.post(path, {
      ids: req.ids
    }, 'unassignLocationTeams');
  }
  // Locations
  async getLocation(locationId) {
    const path = this.utilsSvc.getLocationGetUrl(locationId);
    const response = await this.get(path, 'getLocation');
    return response;
  }
  async getLocations() {
    const path = this.utilsSvc.getLocationsGetManyUrl();
    const response = await this.get(path, 'getLocations');
    return response;
  }
  async createLocation(location) {
    const path = this.utilsSvc.getLocationCreateUrl();
    const sanitized = this.utilsSvc.sanitizeLocation(location);
    const res = this.post(path, sanitized, 'createLocation');
    return res;
  }
  async updateLocation(req, locationId) {
    const path = this.utilsSvc.getLocationUpdateUrl(locationId);
    const sanitized = this.utilsSvc.sanitizeLocationUpdateRequest(req);
    const res = this.patch(path, sanitized, 'updateLocation');
    return res;
  }
  async deleteLocation(locationId) {
    const path = this.utilsSvc.getLocationDeleteUrl(locationId);
    await this.delete(path, 'deleteLocation');
  }
  async searchLocations(req) {
    const path = this.utilsSvc.getLocationsSearchUrl();
    const payload = this.utilsSvc.getSearchLocationsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchLocations');
    return response;
  }
  // Rooms
  async getRoom(roomId) {
    const path = this.utilsSvc.getRoomGetUrl(roomId);
    const response = await this.get(path, 'getRoom');
    return response;
  }
  async getRooms(locationId) {
    const path = this.utilsSvc.getRoomsGetManyUrl(locationId);
    const response = await this.get(path, 'getRooms');
    return response;
  }
  async createRoom(room, locationId) {
    const path = this.utilsSvc.getRoomCreateUrl(locationId);
    const sanitized = this.utilsSvc.sanitizeRoom(room);
    const res = this.post(path, sanitized, 'createRoom');
    return res;
  }
  async updateRoom(req, roomId) {
    const path = this.utilsSvc.getRoomUpdateUrl(roomId);
    const sanitized = this.utilsSvc.sanitizeRoom(req);
    const res = this.patch(path, sanitized, 'updateRoom');
    return res;
  }
  async deleteRoom(roomId) {
    const path = this.utilsSvc.getRoomDeleteUrl(roomId);
    await this.delete(path, 'deleteRoom');
  }
  async searchRooms(req, locationId) {
    const path = this.utilsSvc.getRoomsSearchUrl(locationId);
    const payload = this.utilsSvc.getSearchRoomsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchRooms');
    return response;
  }
  // Amenities
  async getAmenity(amenityId) {
    const path = this.utilsSvc.getAmenityGetUrl(amenityId);
    const response = await this.get(path, 'getAmenity');
    return response;
  }
  async getAmenities(locationId) {
    const path = this.utilsSvc.getAmenitiesGetManyUrl(locationId);
    const response = await this.get(path, 'getAmenities');
    return response;
  }
  async createAmenity(amenity, locationId) {
    const path = this.utilsSvc.getAmenityCreateUrl(locationId);
    const sanitized = this.utilsSvc.sanitizeAmenity(amenity);
    const res = this.post(path, sanitized, 'createAmenity');
    return res;
  }
  async updateAmenity(req, amenityId) {
    const path = this.utilsSvc.getAmenityUpdateUrl(amenityId);
    const sanitized = this.utilsSvc.sanitizeAmenity(req);
    const res = this.patch(path, sanitized, 'updateAmenity');
    return res;
  }
  async deleteAmenity(amenityId) {
    const path = this.utilsSvc.getAmenityDeleteUrl(amenityId);
    await this.delete(path, 'deleteAmenity');
  }
  async searchAmenities(req, locationId) {
    const path = this.utilsSvc.getAmenitiesSearchUrl(locationId);
    const payload = this.utilsSvc.getSearchAmenitiesPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchAmenities');
    return response;
  }
  // Profile pages
  async getProfilePageSettings(profilePageId) {
    const path = this.utilsSvc.getProfilePageSettingsGetUrl(profilePageId);
    const res = await this.get(path, 'getProfilePageSettings');
    return res;
  }
  async updateProfilePageSettings(profilePageId, profilePageSettings) {
    const path = this.utilsSvc.getProfilePageSettingsUpdateUrl(profilePageId);
    await this.patch(path, profilePageSettings, 'updateProfilePageSettings');
  }
  async getProfilePage(profilePageId) {
    const path = this.utilsSvc.getProfilePageGetUrl(profilePageId);
    const response = await this.get(path, 'getProfilePage');
    return response;
  }
  async getProfilePages(req) {
    const path = this.utilsSvc.getProfilePagesGetManyUrl();
    const response = await this.get(path, 'getProfilePages');
    return response;
  }
  async getAllProfilePages() {
    const allProfilePages = await this.getAllPagedItems(request => this.getProfilePages(request), response => response.profile_pages);
    const res = {
      profile_pages: allProfilePages
    };
    return res;
  }
  async createProfilePage(profilePage) {
    const path = this.utilsSvc.getProfilePageCreateUrl();
    const sanitized = this.utilsSvc.sanitizeProfilePage(profilePage);
    const res = this.post(path, sanitized, 'createProfilePage');
    return res;
  }
  async updateProfilePage(profilePage) {
    const path = this.utilsSvc.getProfilePageUpdateUrl(profilePage.id);
    const sanitized = this.utilsSvc.sanitizeProfilePage(profilePage);
    const res = this.patch(path, sanitized, 'updateProfilePage');
    return res;
  }
  async deleteProfilePage(profilePageId) {
    const path = this.utilsSvc.getProfilePageDeleteUrl(profilePageId);
    await this.delete(path, 'deleteProfilePage');
  }
  async setProfilePageAsDefault(profilePageId) {
    const path = this.utilsSvc.getProfilePageUpdateUrl(profilePageId);
    const body = {
      default: true
    };
    const res = await this.patch(path, body, 'setProfilePageAsDefault');
    return res;
  }
  // Discounts
  async searchDiscounts(req) {
    const path = this.utilsSvc.getDiscountsSearchUrl();
    const payload = this.utilsSvc.getSearchDiscountsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchDiscounts');
    return response;
  }
  async createDiscount(discount) {
    const path = this.utilsSvc.getDiscountCreateUrl();
    const created = await this.post(path, discount, 'createDiscount');
    return created;
  }
  async deleteDiscount(discountId) {
    const path = this.utilsSvc.getDiscountDeleteUrl(discountId);
    await this.delete(path, 'deleteDiscount');
  }
  async getDiscount(discountId) {
    const path = this.utilsSvc.getDiscountGetUrl(discountId);
    const discount = await this.get(path, 'discountId');
    return discount;
  }
  async updateDiscount(discount) {
    const path = this.utilsSvc.getDiscountUpdateUrl(discount.id);
    const sanitized = this.utilsSvc.sanitizeDiscountForUpdate(discount);
    const updated = await this.patch(path, sanitized, 'updateDiscount');
    return updated;
  }
  // Orders
  async updateOrder(order) {
    const path = this.utilsSvc.getOrderUpdateUrl(order.id);
    const sanitizedOrder = {
      ...order
    };
    this.utilsSvc.deleteIdCreatedAtUpdatedAt(sanitizedOrder);
    return this.patch(path, sanitizedOrder, 'updateOrder');
  }
  async searchOrders(req) {
    const path = this.utilsSvc.getOrdersSearchUrl();
    const payload = this.utilsSvc.getSearchOrdersPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchOrders');
    return response;
  }
  async searchEventOrders(eventId, req) {
    const path = this.utilsSvc.getEventOrdersSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchOrdersPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchEventOrders');
    return response;
  }
  async getOrder(orderId, includeAllTransactions) {
    let response;
    const path = this.utilsSvc.getOrderGetUrl(orderId);
    if (includeAllTransactions) {
      const queryParams = {
        all_transactions: true
      };
      response = await this.getWithQuery(path, queryParams, 'getOrder');
    } else {
      response = await this.get(path, 'getOrder');
    }
    return response;
  }
  async getEventOrder(eventId, orderId, includeAllTransactions) {
    let response;
    const path = this.utilsSvc.getEventOrderGetUrl(eventId, orderId);
    if (includeAllTransactions) {
      const queryParams = {
        all_transactions: true
      };
      response = await this.getWithQuery(path, queryParams, 'getEventOrder');
    } else {
      response = await this.get(path, 'getEventOrder');
    }
    return response;
  }
  async createOrderFullRefund(req, orderId) {
    const path = this.utilsSvc.getOrderFullRefundUrl(orderId);
    const response = await this.post(path, req, 'createOrderFullRefund');
    return response;
  }
  async createEventOrderFullRefund(req, eventId, orderId) {
    const path = this.utilsSvc.getEventOrderFullRefundUrl(eventId, orderId);
    const response = await this.post(path, req, 'createEventOrderFullRefund');
    return response;
  }
  async bulkUpdateOrder(patchValue, req) {
    const path = this.utilsSvc.getOrderBulkUpdateUrl();
    const payload = this.getOrderBulkUpdatePayload(patchValue, req);
    const response = await this.post(path, payload, 'bulkUpdateOrder');
    return response;
  }
  getOrderBulkUpdatePayload(patchValue, req) {
    const clonedReq = JSON.parse(JSON.stringify(req ?? {}));
    const searchOrdersPayload = this.utilsSvc.getSearchOrdersPayload(clonedReq);
    const payload = {
      order_filter: searchOrdersPayload.order_filter,
      update: patchValue
    };
    return payload;
  }
  async bulkUpdateOrderTag(tagValue, req, eventId, participantId, contactId) {
    const path = this.utilsSvc.getOrderBulkUpdateTagUrl();
    const clonedReq = JSON.parse(JSON.stringify(req));
    const searchOrdersPayload = this.utilsSvc.getSearchOrdersPayload(clonedReq);
    if (eventId) {
      searchOrdersPayload.order_filter.and.push({
        event_id: eventId
      });
    }
    if (participantId) {
      searchOrdersPayload.order_filter.and.push({
        participant_id: participantId
      });
    }
    if (contactId) {
      searchOrdersPayload.order_filter.and.push({
        contact_id: participantId
      });
    }
    const payload = {
      order_filter: searchOrdersPayload.order_filter,
      value: tagValue
    };
    if (searchOrdersPayload.sort_field) {
      payload.sort_field = searchOrdersPayload.sort_field;
    }
    payload.value = tagValue;
    const response = await this.post(path, payload, 'bulkSetOrderTag');
    return response;
  }
  async addParticipantTransaction(participantId, request) {
    const path = this.utilsSvc.getAddParticipantTransactionUrl(participantId);
    await this.post(path, request, 'addParticipantTransaction');
  }
  async exportEventOrders(eventId, req, exportParameters) {
    const path = this.utilsSvc.getEventOrdersExportUrl(eventId);
    const payload = this.utilsSvc.getExportOrdersPayload(req, exportParameters);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'exportEventOrders');
    return response;
  }
  // async createOrderRefund(req: IOrderRefundRequest, orderId: string): Promise<void> {
  //     const path = this.utilsSvc.getOrderRefundUrl(orderId);
  //     const response = await this.post<void>(path, req, 'createOrderRefund');
  //     return response;
  // }
  // async createEventOrderRefund(req: IOrderRefundRequest, eventId: string, orderId: string): Promise<void> {
  //     const path = this.utilsSvc.getEventOrderRefundUrl(eventId, orderId);
  //     const response = await this.post<void>(path, req, 'createEventOrderRefund');
  //     return response;
  // }
  // Event Engagement App
  async getEngagementAppSettings(eventId) {
    const path = this.utilsSvc.getEngagementAppSettingsGetUrl(eventId);
    const res = await this.get(path, 'getEngagementAppSettings');
    return res;
  }
  async saveEngagementAppSettings(eventId, settings) {
    const path = this.utilsSvc.getEngagementAppSettingsSaveUrl(eventId);
    const res = await this.patch(path, settings, 'saveEngagementAppSettings');
    return res;
  }
  async getActivityEngagementAppSettings(eventId) {
    const path = this.utilsSvc.getActivityEngagementAppSettingsGetUrl(eventId);
    const res = await this.get(path, 'getActivityEngagementAppSettings');
    return res;
  }
  async saveActivityEngagementAppSettings(eventId, settings) {
    const path = this.utilsSvc.getActivityEngagementAppSettingsSaveUrl(eventId);
    const res = await this.patch(path, settings, 'saveActivityEngagementAppSettings');
    return res;
  }
  async searchEngagementAppPolls(eventId, req) {
    const path = this.utilsSvc.getEngagementAppPollsSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchEngagementAppPollsPayload(req);
    const res = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEngagementAppPolls');
    return res;
  }
  async getPollResults(pollId, pagedReq) {
    const path = this.utilsSvc.getPollResultsGetUrl(pollId);
    const res = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(pagedReq), 'getPollResults');
    return res;
  }
  async searchEngagementAppQuestions(eventId, req) {
    const path = this.utilsSvc.getEngagementAppQuestionsSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchEngagementAppQuestionsPayload(req);
    const res = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEngagementAppQuestions');
    return res;
  }
  async searchEngagementAppNewsfeeds(eventId, req) {
    const path = this.utilsSvc.getEngagementAppNewsfeedsSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchEngagementAppNewsfeedsPayload(req);
    const res = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEngagementAppNewsfeeds');
    return res;
  }
  async getNewsfeedComments(newsfeedId, pagingReq) {
    const path = this.utilsSvc.getNewsfeedCommentsGetUrl(newsfeedId);
    const res = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(pagingReq), 'getNewsfeedComments');
    return res;
  }
  // Import
  async uploadContactsFile(file) {
    const path = this.utilsSvc.getContactsFileUploadUrl();
    const response = await this.postWithHeaders(path, file, {
      'Content-Type': file.type
    }, {
      filename: file.name
    }, 'uploadContactsFile');
    return response;
  }
  async uploadEventParticipantsFile(eventId, file) {
    const path = this.utilsSvc.getEventParticipantsFileUploadUrl(eventId);
    const response = await this.postWithHeaders(path, file, {
      'Content-Type': file.type
    }, {
      filename: file.name
    }, 'uploadEventParticipants');
    return response;
  }
  async uploadOrganizationsFile(file) {
    const path = this.utilsSvc.getOrganizationsFileUploadUrl();
    const response = await this.postWithHeaders(path, file, {
      'Content-Type': file.type
    }, {
      filename: file.name
    }, 'uploadOrganizationsFile');
    return response;
  }
  async getImport(importId) {
    const path = this.utilsSvc.getImportGetUrl(importId);
    const response = await this.get(path, 'getImport');
    return response;
  }
  async importFieldMappings(importId, mappings, timezone) {
    const path = this.utilsSvc.getFieldsMappingImportUrl(importId);
    const queryParams = {
      timezone
    };
    const response = await this.putWithQuery(path, mappings, queryParams, 'importFieldMappings');
    return response;
  }
  async saveImport(importId) {
    const path = this.utilsSvc.getImportSaveUrl(importId);
    const response = await this.post(path, null, 'saveImport');
    return response;
  }
  async getImportFieldValueMappings(importId) {
    const path = this.utilsSvc.getImportFieldValueMappingsGetUrl(importId);
    const response = await this.get(path, 'getImportFieldValueMappings');
    return response;
  }
  async updateImportFieldValueMappings(importId, resolvedMappings) {
    const path = this.utilsSvc.getImportFieldValueMappingsUpdateUrl(importId);
    const response = await this.put(path, resolvedMappings, 'updateImportFieldValueMappings');
    return response;
  }
  async getImportDuplicates(importId, pagedReq) {
    const path = this.utilsSvc.getImportDuplicatesGetUrl(importId);
    const response = await this.getPaged(path, pagedReq, 'getImportDuplicates');
    return response;
  }
  async resolveImportDuplication(importId, duplicationKey, resolutionRowId, useExisting) {
    const path = this.utilsSvc.getImportDuplicationResolveUrl(importId, duplicationKey);
    let resolveDuplicationPayload;
    if (resolutionRowId) {
      resolveDuplicationPayload = {
        resolution_row_id: resolutionRowId
      };
    } else {
      resolveDuplicationPayload = {
        use_existing: true
      };
    }
    const response = await this.put(path, resolveDuplicationPayload, 'resolveImportDuplication');
    return response;
  }
  async saveImportDuplicates(importId) {
    const path = this.utilsSvc.getImportDuplicatesSaveUrl(importId);
    const response = await this.post(path, null, 'saveImportDuplicates');
    return response;
  }
  async getImportErrorRows(importId, pagedReq) {
    const path = this.utilsSvc.getImportErrorRowsGetUrl(importId);
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(pagedReq), 'getImportErrorRows');
    return response;
  }
  async updateImportRow(importId, rowId, obj) {
    const path = this.utilsSvc.getImportRowUpdateUrl(importId, rowId);
    const response = await this.patch(path, obj, 'updateImportRow');
    return response;
  }
  async applyImportCorrections(importId) {
    const path = this.utilsSvc.getImportCorrectionsApplyUrl(importId);
    const response = await this.post(path, null, 'applyImportCorrections');
    return response;
  }
  async autoMapImportOrganizations(importId) {
    const path = this.utilsSvc.getImportOrganizationsAutoMapUrl(importId);
    const response = await this.post(path, null, 'autoMapImportOrganizaions');
    return response;
  }
  // Job
  async getJobErrors(jobId) {
    const path = this.utilsSvc.getJobGetErrorsUrl(jobId);
    const res = await this.get(path, 'getJobErrors');
    return res;
  }
  async getJob(jobId) {
    const path = this.utilsSvc.getJobGetUrl(jobId);
    const job = await this.get(path, 'getJob');
    const response = {
      job: job,
      totals: this.utilsSvc.calculateJobStagesTotals(job.stages)
    };
    return response;
  }
  async searchJobs(req) {
    const path = this.utilsSvc.getJobsSearchUrl();
    const payload = this.utilsSvc.getSearchJobsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchJobs');
    return response;
  }
  async getJobs(req) {
    const path = this.utilsSvc.getJobsGetUrl();
    const res = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getJobs');
    const response = {
      limit: res.limit,
      object_count: res.object_count,
      offset: res.offset,
      jobs: this.utilsSvc.jobsToJobsInfo(res.jobs)
    };
    return response;
  }
  async downloadJobFile(req) {
    const path = this.utilsSvc.prefixWithBaseUrl(req);
    const file = await this.getAny(path, 'downloadJobFile');
    return new Blob([file]);
  }
  async getAllJobs() {
    const allJobs = await this.getAllPagedItems(request => this.getJobs(request), response => response.jobs);
    const res = {
      jobs: allJobs
    };
    return res;
  }
  async cancelJob(jobId) {
    const path = this.utilsSvc.getJobCancelUrl(jobId);
    await this.post(path, null, 'cancelJob');
  }
  async deleteJob(jobId) {
    const path = this.utilsSvc.getJobDeleteUrl(jobId);
    await this.delete(path, 'deleteJob');
  }
  //
  async getAnyResource(path) {
    const blob = await this.getAny(path, 'getAnyResource');
    return blob;
  }
  async updateDocument(documentId, fileName, contentType, array) {
    const path = this.utilsSvc.getDocumentUpdateUrl(documentId);
    const blob = new Blob([array], {
      type: contentType
    });
    const queryParams = {
      filename: fileName
    };
    const res = await this.putWithQuery(path, blob, queryParams, 'updateDocument');
    return res;
  }
  async deleteDocument(documentId) {
    const path = this.utilsSvc.getDocumentDeleteUrl(documentId);
    const res = await this.delete(path, 'deleteDocument');
    return res;
  }
  async uploadCustomerFavIcon(array) {
    const path = this.utilsSvc.getCustomerFavIconUploadUrl();
    const blob = new Blob([array]);
    const res = await this.put(path, blob, 'uploadCustomerFavIcon');
    return res;
  }
  getDocumentUploadUrl(entityType, entityId) {
    let path;
    if (entityType === "event" /* DocumentEntityType.event */) {
      path = this.utilsSvc.getEventDocumentUploadUrl(entityId);
    } else if (entityType === "eventParticipant" /* DocumentEntityType.eventParticipant */) {
      path = this.utilsSvc.getParticipantDocumentUploadUrl(entityId);
    } else if (entityType === "contact" /* DocumentEntityType.contact */) {
      path = this.utilsSvc.getContactDocumentUploadUrl(entityId);
    } else if (entityType === "organization" /* DocumentEntityType.organization */) {
      path = this.utilsSvc.getOrganizationDocumentUploadUrl(entityId);
    } else if (entityType === "user" /* DocumentEntityType.user */) {
      path = this.utilsSvc.getUserDocumentUploadUrl(entityId);
    }
    return path;
  }
  async uploadEntityDocument(entityType, entityId, fileName, contentType, array, documentEntityOptions) {
    const path = this.getDocumentUploadUrl(entityType, entityId);
    const blob = new Blob([array], {
      type: contentType
    });
    const queryParams = {
      ...documentEntityOptions?.queryParams,
      filename: fileName
    };
    const res = await this.postWithQuery(path, blob, queryParams, 'uploadEntityDocument ' + entityType);
    return res;
  }
  async getDocumentDownloadToken(documentId) {
    const path = this.utilsSvc.getDocumentDownloadTokenGetUrl(documentId);
    const res = await this.get(path, 'getDocumentDownloadToken');
    return res;
  }
  getDocumentFileDownloadUrl(documentId, token) {
    return this.utilsSvc.getDocumentFileGetUrl(documentId, token);
  }
  // async getDocumentFile(documentId: string): Promise<Blob> {
  //     const path = this.utilsSvc.getDocumentFileGetUrl(documentId);
  //     const file = await this.getAny<Blob>(path, 'getDocumentFile');
  //     return new Blob([file]);
  // }
  // Document - File
  async uploadFile(req) {
    const path = this.utilsSvc.getFileUploadUrl();
    const blob = req.file.slice();
    const queryParams = {
      filename: req.fileName
    };
    const res = await this.postWithQuery(path, blob, queryParams, 'uploadFile');
    return res;
  }
  // Document - Assets
  async searchEventAssets(req, eventId) {
    const path = this.utilsSvc.getEventAssetsSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchAssetsPayload(req);
    const query = {
      ...this.utilsSvc.sanitizePagedRequest(req),
      include_documents: true
    };
    const res = await this.postWithQuery(path, payload, query, 'searchEventAssets');
    return res;
  }
  async searchContactAssets(req) {
    const path = this.utilsSvc.getContactAssetsSearchUrl();
    const payload = this.utilsSvc.getSearchAssetsPayload(req);
    const query = this.utilsSvc.sanitizePagedRequest(req);
    const res = await this.postWithQuery(path, payload, query, 'searchContactAssets');
    return res;
  }
  async bulkDownloadContactAssets(req) {
    const path = this.utilsSvc.getContactAssetsDownloadUrl();
    const payload = omit(this.utilsSvc.getSearchAssetsPayload(req), ['sort_field']);
    const res = await this.post(path, payload, 'bulkDownloadContactAssets');
    return res;
  }
  async createEventAsset(req, eventId) {
    const path = this.utilsSvc.getEventAssetCreateUrl(eventId);
    const res = await this.post(path, req, 'createEventAsset');
    return res;
  }
  async createContactsAsset(req) {
    const path = this.utilsSvc.getContactsAssetCreateUrl();
    const res = await this.post(path, req, 'createContactsAsset');
    return res;
  }
  async bulkUploadAssets(files, path, caller) {
    const CHUNK_SIZE = 10;
    const fileChunks = [];
    for (let i = 0; i < files.length; i += CHUNK_SIZE) {
      fileChunks.push(files.slice(i, i + CHUNK_SIZE));
    }
    // Create upload promises for all chunks
    const uploadPromises = fileChunks.map(async chunk => {
      const formData = new FormData();
      chunk.forEach(file => {
        formData.append('files', file, file.name);
      });
      return await this.post(path, formData, caller);
    });
    // Execute all uploads concurrently
    const results = await Promise.all(uploadPromises);
    // Combine all assets from all chunks
    const allUploadedAssets = [];
    results.forEach(res => {
      if (res.assets) {
        allUploadedAssets.push(...res.assets);
      }
    });
    return {
      assets: allUploadedAssets
    };
  }
  async bulkUploadEventAssets(eventId, req) {
    const path = this.utilsSvc.getEventAssetsBulkUploadUrl(eventId);
    const res = await this.bulkUploadAssets(req.files, path, 'bulkUploadEventAssets');
    return res;
  }
  async bulkUploadContactAssets(req) {
    const path = this.utilsSvc.getContactAssetsBulkUploadUrl();
    const res = await this.bulkUploadAssets(req.files, path, 'bulkUploadContactAssets');
    return res;
  }
  async getAssetById(req) {
    const path = this.utilsSvc.getAssetByIdUrl(req.assetId);
    return await this.get(path, 'getAssetById');
  }
  async getEventAssets(req, eventId) {
    const path = this.utilsSvc.getAssetsGetManyUrl(eventId);
    const response = await this.getPaged(path, req, 'getEventAssets');
    return response;
  }
  async bulkDownloadEventAssets(req, eventId) {
    const path = this.utilsSvc.getEventAssetsBulkDownloadUrl(eventId);
    const payload = this.utilsSvc.getSearchAssetsPayload(req);
    const response = await this.post(path, payload, 'bulkDownloadEventAssets');
    return response;
  }
  async getAllEventAssets(eventId) {
    const allAssets = await this.getAllPagedItems(req => this.getEventAssets(req, eventId), res => res.assets);
    return allAssets;
  }
  async bulkDownloadEventListAssets(filter, extra) {
    const path = this.utilsSvc.getEventListAssetsBulkDownloadUrl();
    const payload = omit({
      ...this.utilsSvc.getSearchAssetsPayload(filter.asset_filter),
      ...this.utilsSvc.getSearchEventsPayload(filter.event_filter),
      ...extra
    }, ['sort_field']);
    const response = await this.post(path, payload, 'bulkDownloadEventListAssets');
    return response;
  }
  async getContactsAssets(req) {
    const path = this.utilsSvc.getContactsAssetsUrl();
    const response = await this.getPaged(path, req, 'getContactsAssets');
    return response;
  }
  async getAllContactsAssets() {
    const allAssets = await this.getAllPagedItems(req => this.getContactsAssets(req), res => res.assets);
    return allAssets;
  }
  async patchAssetById(req) {
    const path = this.utilsSvc.getAssetByIdUrl(req.assetId);
    const request = {
      ...req
    };
    delete request.assetId;
    return await this.patch(path, request, 'patchAssetById');
  }
  async deleteAssetById(req) {
    const path = this.utilsSvc.getAssetByIdUrl(req.assetId);
    return await this.delete(path, 'getAssetById');
  }
  async getThemeAsset(req) {
    const path = this.utilsSvc.getThemeAssetUrl(req.themeID);
    const res = await this.getPaged(path, req, 'getThemeAsset');
    return res;
  }
  async createThemeAsset(req) {
    const path = this.utilsSvc.getThemeAssetUrl(req.themeID);
    const request = {
      name: req.name,
      file_id: req.file_id
    };
    return await this.postWithQuery(path, request, {}, 'createThemeAsset');
  }
  // Settings - View
  async createGlobalView(entityType, view) {
    const path = this.utilsSvc.getGlobalViewCreateUrl(entityType);
    const sanitized = this.utilsSvc.sanitizeGroupedFieldsView(view);
    const created = await this.post(path, sanitized, 'createGlobalView');
    return created;
  }
  async getGlobalViews(entityType) {
    const path = this.utilsSvc.getGlobalViewsGetUrl(entityType);
    const res = await this.get(path, 'getGlobalViews');
    return res;
  }
  async updateGlobalView(entityType, view) {
    const path = this.utilsSvc.getGlobalViewUpdateUrl(entityType, view.id);
    const sanitized = this.utilsSvc.sanitizeGroupedFieldsView(view);
    const updated = await this.patch(path, sanitized, 'updateGlobalView');
    return updated;
  }
  async deleteGlobalView(entityType, viewId) {
    const path = this.utilsSvc.getGlobalViewDeleteUrl(entityType, viewId);
    await this.delete(path, 'deleteGlobalView');
  }
  async createParentView(parentType, parentEntityId, entityType, view) {
    const path = this.utilsSvc.getParentViewCreateUrl(parentType, parentEntityId, entityType);
    const sanitized = this.utilsSvc.sanitizeGroupedFieldsView(view);
    const created = await this.post(path, sanitized, 'createParentView');
    return created;
  }
  async getParentViews(parentType, parentEntityId, entityType) {
    const path = this.utilsSvc.getParentViewsGetUrl(parentType, parentEntityId, entityType);
    const res = await this.get(path, 'getParentViews');
    return res;
  }
  async updateParentView(parentType, parentEntityId, entityType, view) {
    const path = this.utilsSvc.getParentViewUpdateUrl(parentType, parentEntityId, entityType, view.id);
    const sanitized = this.utilsSvc.sanitizeGroupedFieldsView(view);
    const updated = await this.patch(path, sanitized, 'updateParentView');
    return updated;
  }
  async deleteParentView(parentType, parentEntityId, entityType, viewId) {
    const path = this.utilsSvc.getParentViewDeleteUrl(parentType, parentEntityId, entityType, viewId);
    await this.delete(path, 'deleteParentView');
  }
  // Settings - engagement app
  async getVirtualMeetingIntegrationForEvent(eventId) {
    const path = this.utilsSvc.getVirtualMeetingIntegrationGetForEventUrl(eventId);
    const res = await this.get(path, 'getVirtualMeetingIntegrationForEvent');
    return res;
  }
  async setVirtualMeetingIntegrationForEvent(eventId, req) {
    const path = this.utilsSvc.getVirtualMeetingIntegrationSetForEventUrl(eventId);
    const res = await this.put(path, req, 'setVirtualMeetingIntegrationForEvent');
    return res;
  }
  async getVirtualMeetingIntegrationForActivity(eventId) {
    const path = this.utilsSvc.getVirtualMeetingIntegrationGetForActivityUrl(eventId);
    const res = await this.get(path, 'getVirtualMeetingIntegrationForActivity');
    return res;
  }
  async setVirtualMeetingIntegrationForActivity(eventId, req) {
    const path = this.utilsSvc.getVirtualMeetingIntegrationSetForActivityUrl(eventId);
    const res = await this.put(path, req, 'setVirtualMeetingIntegrationForActivity');
    return res;
  }
  // Settings - Global
  async getGlobalSetting(req) {
    const path = this.utilsSvc.getGlobalSettingGetUrl(req.entityType, req.settingType);
    const res = await this.get(path, 'getGlobalSetting', [404]);
    return res;
  }
  async saveGlobalSetting(req) {
    const path = this.utilsSvc.getGlobalSettingSaveUrl(req.entityType, req.settingType);
    await this.post(path, {
      setting: req.setting
    }, 'saveGlobalSetting');
  }
  async saveGlobalSettingItem(req) {
    const path = this.utilsSvc.getGlobalSettingItemSaveUrl(req.entityType, req.settingType);
    await this.post(path, req.settingItem, 'saveGlobalSettingItem');
  }
  async deleteGlobalSetting(req) {
    const path = this.utilsSvc.getGlobalSettingGetUrl(req.entityType, req.settingType);
    await this.delete(path, 'deleteGlobalSetting');
  }
  async deleteGlobalSettingItem(req) {
    const path = this.utilsSvc.getGlobalSettingItemDeleteUrl(req.entityType, req.settingType, req.settingItemId);
    await this.delete(path, 'deleteGlobalSettingItem');
  }
  async updateGlobalSettingItem(req) {
    const path = this.utilsSvc.getGlobalSettingItemUpdateUrl(req.entityType, req.settingType, req.settingItemId);
    this.utilsSvc.deleteIdCreatedAtUpdatedAt(req.settingItem);
    await this.patch(path, req.settingItem, 'updateGlobalSettingItem');
  }
  // Setings - Parent
  async getParentSetting(req) {
    const path = this.utilsSvc.getParentSettingGetUrl(req.parentType, req.parentEntityId, req.entityType, req.settingType);
    const res = await this.get(path, 'getParentSetting', [404]);
    return res;
  }
  async saveParentSetting(req) {
    const path = this.utilsSvc.getParentSettingSaveUrl(req.parentType, req.parentEntityId, req.entityType, req.settingType);
    await this.post(path, {
      setting: req.setting
    }, 'saveParentSetting');
  }
  async saveParentSettingItem(req) {
    const path = this.utilsSvc.getParentSettingSaveItemUrl(req.parentType, req.parentEntityId, req.entityType, req.settingType);
    const sanitizedSettingItem = this.utilsSvc.sanitizeIdCreatedAtUpdatedAt(req.settingItem);
    this.utilsSvc.deleteIdCreatedAtUpdatedAt(sanitizedSettingItem);
    await this.post(path, sanitizedSettingItem, 'saveParentSettingItem');
  }
  async deleteParentSetting(req) {
    const path = this.utilsSvc.getParentSettingDeleteUrl(req.parentType, req.parentEntityId, req.entityType, req.settingType);
    await this.delete(path, 'deleteParentSetting');
  }
  async deleteParentSettingItem(req) {
    const path = this.utilsSvc.getParentSettingDeleteItemUrl(req.parentType, req.parentEntityId, req.entityType, req.settingType, req.settingItemId);
    await this.delete(path, 'deleteParentSettingItem');
  }
  async updateParentSettingItem(req) {
    const path = this.utilsSvc.getParentSettingUpdateItemUrl(req.parentType, req.parentEntityId, req.entityType, req.settingType, req.settingItemId);
    this.utilsSvc.deleteIdCreatedAtUpdatedAt(req.settingItem);
    await this.patch(path, req.settingItem, 'updateParentSettingItem');
  }
  // Settings - Event
  async getEventSettings(eventId) {
    const path = this.utilsSvc.getEventSettingsGetUrl(eventId);
    const response = await this.get(path, 'getEventSettings');
    return response;
  }
  async updateEventSettings(eventId, eventSettings) {
    const path = this.utilsSvc.getEventSettingsUpdateUrl(eventId);
    const response = await this.patch(path, eventSettings, 'updateEventSettings');
    return response;
  }
  // Builder
  async getTheme(themeId) {
    const path = this.utilsSvc.getThemeGetUrl(themeId);
    const theme = await this.get(path, 'getTheme');
    return theme;
  }
  async createTheme(query, requestTheme) {
    const path = this.utilsSvc.getThemeCreateUrl();
    const sanitizedRequestTheme = this.utilsSvc.sanitizeRequestTheme(requestTheme);
    const createdTheme = await this.postWithQuery(path, sanitizedRequestTheme, {
      ...query
    }, 'createTheme');
    return createdTheme;
  }
  async updateTheme(requestTheme) {
    const path = this.utilsSvc.getThemeUpdateUrl(requestTheme.id);
    const sanitizedTheme = this.utilsSvc.sanitizeRequestTheme(requestTheme);
    const updatedTheme = await this.patch(path, sanitizedTheme, 'updateTheme');
    return updatedTheme;
  }
  async searchThemes(type, req) {
    const path = this.utilsSvc.getThemesSearchUrl();
    const payload = this.utilsSvc.getSearchThemesPayload(req);
    const query = {
      type: type,
      ...this.utilsSvc.sanitizePagedRequest(req)
    };
    const response = await this.postWithQuery(path, payload, query, 'searchThemes');
    return response;
  }
  async getAllThemes(themeType) {
    const req = {
      limit: 50,
      offset: 0
    };
    const themes = await this.getAllPagedItems(request => this.searchThemes(themeType, request), response => response.themes, req);
    return themes;
  }
  async deleteTheme(themeId) {
    const path = this.utilsSvc.getThemeDeleteUrl(themeId);
    await this.delete(path, 'deleteTheme');
  }
  async addTeamsToTheme(req) {
    const path = this.utilsSvc.getAddTeamsFromThemeUrl(req.themeId);
    const payload = {
      ids: req.teamIds
    };
    await this.post(path, payload, 'addTeamsToTheme');
  }
  async removeTeamsFromTheme(req) {
    const path = this.utilsSvc.getRemoveTeamsFromThemeUrl(req.themeId);
    const payload = {
      ids: req.teamIds
    };
    await this.post(path, payload, 'removeTeamsFromTheme');
  }
  async getDependencies(req) {
    const path = this.utilsSvc.getDependenciesGetUrl(req.eventId);
    const response = await this.getPaged(path, req, 'getDependencies');
    return response;
  }
  async searchDependencies(eventId, req) {
    const path = this.utilsSvc.getDependenciesSearchUrl(eventId);
    const payload = this.utilsSvc.getSearchDependenciesPayload(req);
    const response = await this.postWithQuery(path, payload, req, 'searchDependencies');
    return response;
  }
  async getAllDependencies(eventId) {
    const getDepsReq = {
      eventId: eventId,
      limit: 50,
      offset: 0
    };
    const dependencies = await this.getAllPagedItems(req => this.getDependencies(req), res => res.dependencies, getDepsReq);
    return dependencies;
  }
  async getDependency(dependencyId) {
    const path = this.utilsSvc.getDependencyGetUrl(dependencyId);
    const dependency = await this.get(path, 'getDependency');
    return dependency;
  }
  async createDependency(req) {
    const path = this.utilsSvc.getDependencyCreateUrl(req.eventId);
    const sanitizedDependency = this.utilsSvc.sanitizeDependency(req.dependency);
    const createdDependency = await this.post(path, sanitizedDependency, 'createDependency');
    return createdDependency;
  }
  async deleteDependency(dependencyId) {
    const path = this.utilsSvc.getDependencyDeleteUrl(dependencyId);
    await this.delete(path, 'deleteDependency');
  }
  /**
   * @param dependency Enforce to save dependency in v2 format. Use `servicelib/convertDependencyToV2()` to convert to v2
   */
  async updateDependency(dependency) {
    const path = this.utilsSvc.getDependencyUpdateUrl(dependency.id);
    const sanitizedDependency = this.utilsSvc.sanitizeDependency(dependency);
    const updatedDependency = await this.patch(path, sanitizedDependency, 'updateDependency');
    return updatedDependency;
  }
  async bulkUpdatePagesFooterPage(req, pageType, footerPageId, eventId) {
    const path = this.utilsSvc.getBulkUpdatePagesFooterPageUrl();
    const payload = this.utilsSvc.getBulkUpdatePagesFooterPagePayload(req, footerPageId);
    const queryParams = {
      page_type: pageType
    };
    if (eventId) {
      queryParams.event_id = eventId;
    }
    const response = await this.postWithQuery(path, payload, queryParams, 'bulkUpdatePagesFooterPage');
    return response;
  }
  async bulkUpdatePagesHeaderPage(req, pageType, headerPageId, eventId) {
    const path = this.utilsSvc.getBulkUpdatePagesHeaderPageUrl();
    const payload = this.utilsSvc.getBulkUpdatePagesHeaderPagePayload(req, headerPageId);
    const queryParams = {
      page_type: pageType
    };
    if (eventId) {
      queryParams.event_id = eventId;
    }
    const response = await this.postWithQuery(path, payload, queryParams, 'bulkUpdatePagesHeaderPage');
    return response;
  }
  async bulkUpdatePagesTheme(req, pageType, themeId, eventId) {
    const path = this.utilsSvc.getBulkUpdatePagesThemeUrl();
    const payload = this.utilsSvc.getBulkUpdatePagesThemePayload(req, themeId);
    const queryParams = {
      page_type: pageType
    };
    if (eventId) {
      queryParams.event_id = eventId;
    }
    const response = await this.postWithQuery(path, payload, queryParams, 'bulkUpdatePagesTheme');
    return response;
  }
  // async createEventPage(req: ICreateEventPageRequest): Promise<IPage> {
  //     const path = this.utilsSvc.getEventPageCreateUrl(req.eventId);
  //     const response = await this.post<IPage>(
  //         path, req.page, 'createEventPage'
  //     );
  //     return response;
  // }
  // async searchEventPages(pageType: PageType, req: ISearchEventPagesRequest): Promise<ISearchEventPagesResponse> {
  //     const path = this.utilsSvc.getSearchPagesUrl();
  //     const payload = this.utilsSvc.getSearchEventPagesPayload(req);
  //     const queryParams: any = this.utilsSvc.sanitizePagedRequest(req);
  //     queryParams.event_id = req.eventId;
  //     queryParams.page_type = pageType;
  //     const res = await this.postWithQuery<ISearchEventPagesResponse>(
  //         path, payload, queryParams, 'searchEventPages'
  //     );
  //     return res;
  // }
  // async getAllEventPages(pageType: PageType, eventId: string): Promise<IPage[]> {
  //     const req = { eventId: eventId, limit: 50, offset: 0 } as ISearchEventPagesRequest;
  //     const allPages = await this.getAllPagedItems(
  //         request => this.searchEventPages(pageType, request),
  //         response => response.pages,
  //         req
  //     );
  //     return allPages;
  // }
  async getFile(url) {
    const response = this.getAny(url, 'getFile', [404]);
    return response;
  }
  async getAllEventForms(eventId) {
    const searchRequest = {
      eventId: eventId,
      advancedQuery: {
        and: [{
          is_form: true
        }]
      },
      limit: 50,
      offset: 0,
      pageType: "Page" /* PageType.page */
    };
    const pages = await this.getAllPagedItems(request => this.searchPages(request), response => response.pages, searchRequest);
    return pages;
  }
  async getPage(pageId) {
    const path = this.utilsSvc.getPageGetUrl(pageId);
    const eventPage = await this.get(path, 'getPage');
    return eventPage;
  }
  async getPageRaw(pageId) {
    const path = this.utilsSvc.getPageRawGetUrl(pageId);
    const pageRaw = await this.get(path, 'getPageRaw');
    return pageRaw;
  }
  async updatePage(req, ignoreHttpErrorsList) {
    const path = this.utilsSvc.getPageUpdateUrl(req.pageId);
    const res = await this.patch(path, req.data, 'updatePage', ignoreHttpErrorsList);
    return res;
  }
  async deleteEventPage(pageId) {
    const path = this.utilsSvc.getEventPageDeleteUrl(pageId);
    await this.delete(path, 'deleteEventPage');
  }
  async publishEventPage(req, ignoreHttpErrorsList) {
    const path = this.utilsSvc.getEventPagePublishUrl(req.pageId, req.versionId);
    await this.post(path, this.utilsSvc.sanitizePublishEventPageRequest(req), 'publishEventPage', ignoreHttpErrorsList);
  }
  async unpublishEventPage(pageId) {
    const path = this.utilsSvc.getEventPageUnpublishUrl(pageId);
    await this.post(path, undefined, 'unpublishEventPage');
  }
  async createEventPagesMenu(eventId, pageIds) {
    const path = this.utilsSvc.getEventPagesMenuCreateUrl(eventId);
    const body = {
      page_ids: pageIds
    };
    await this.put(path, body, 'createEventPagesMenu');
  }
  async getPageLinkToken(pageId) {
    const path = this.utilsSvc.getPageLinkTokenGetUrl(pageId);
    const res = await this.get(path, 'getPageLinkToken');
    return res;
  }
  async getEventPagesMenu(eventId) {
    const path = this.utilsSvc.getEventPagesMenuGetUrl(eventId);
    const response = await this.get(path, 'getEventPagesMenu');
    return response;
  }
  async getEventPageRevisions(pageId) {
    const path = this.utilsSvc.getEventPageGetRevisionsUrl(pageId);
    const response = await this.get(path, 'getEventPageRevisions');
    return response;
  }
  async createEventPageVersion(req) {
    const path = this.utilsSvc.getEventPageCreateVersionUrl(req.pageId);
    delete req.pageId;
    const res = await this.post(path, req, 'createEventPageVersion');
    return res;
  }
  async getEventPageAllVersions(pageId) {
    const path = this.utilsSvc.getEventPageGetAllVersionsUrl(pageId);
    const res = await this.get(path, 'getEventPageAllVersions');
    return res;
  }
  async getEventPageVersion(pageId, versionId) {
    const path = this.utilsSvc.getEventPageGetVersionUrl(pageId, versionId);
    const eventPage = await this.get(path, 'getEventPageVersion');
    return eventPage;
  }
  async syncEventPage(pageId, grapesJSON) {
    const path = this.utilsSvc.getEventPageSyncUrl(pageId);
    await this.put(path, grapesJSON, 'syncEventPage');
  }
  // Events
  async bulkDeleteEvents(eventType, req) {
    const path = this.utilsSvc.getEventsBulkDeleteUrl();
    const queryParams = {
      type: eventType
    };
    const payload = this.utilsSvc.getSearchEventsPayload(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'bulkDeleteEvents');
    return response;
  }
  async searchEvents(req) {
    const path = this.utilsSvc.getEventsSearchUrl();
    const payload = this.utilsSvc.getSearchEventsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    this.utilsSvc.addEventTypeToQueryParams(req, queryParams);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchEvents');
    return response;
  }
  async searchArchivedEvents(req) {
    // Searching for archived events is the same as searching for normal events, only the endpoint is different
    const path = this.utilsSvc.getEventsSearchArchivedUrl();
    const payload = this.utilsSvc.getSearchEventsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchArchivedEvents');
    return response;
  }
  async unarchiveEvents(req) {
    const path = this.utilsSvc.getEventsUnarchiveUrl();
    const payload = this.utilsSvc.getSearchEventsPayload(req);
    const response = await this.post(path, payload, 'unarchiveEvents');
    return response;
  }
  async searchEventsWithArchivedParticipants(req) {
    // Searching for archived eventParticipant is the same as searching for normal eventParticipant, only the endpoint is different
    const path = this.utilsSvc.getEventsWithArchivedParticipantsSearchUrl();
    const payload = this.utilsSvc.getSearchEventsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchEventsWithArchivedParticipants');
    return response;
  }
  async searchEventArchivedParticipants(req) {
    const path = this.utilsSvc.getEventArchivedParticipantsSearchUrl(req.eventId);
    const payload = this.utilsSvc.getSearchEventParticipantsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventArchivedParticipants');
    return response;
  }
  async restoreEventArchivedParticipants(req) {
    const path = this.utilsSvc.getEventArchivedParticipantsRestoreUrl(req.eventId);
    const payload = this.utilsSvc.getSearchEventParticipantsPayload(req);
    const response = await this.post(path, payload, 'restoreEventArchivedParticipants');
    return response;
  }
  async searchAllEvents(req) {
    const events = await this.getAllPagedItems(request => this.searchEvents(request), x => x.events, req);
    return events;
  }
  async getEvents(req) {
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    this.utilsSvc.addEventTypeToQueryParams(req, queryParams);
    const response = await this.getWithQuery(this.utilsSvc.getEventsGetUrl(), queryParams, 'getEvents');
    return response;
  }
  async getAllEvents(type) {
    const req = {
      type: type,
      limit: 50,
      offset: 0
    };
    const allPages = await this.getAllPagedItems(request => this.searchEvents(request), response => response.events, req);
    return allPages;
  }
  async getEvent(eventId) {
    const response = await this.get(this.utilsSvc.getEventGetUrl(eventId), 'getEvent');
    return response;
  }
  async createEvent(req) {
    const path = this.utilsSvc.getEventCreateUrl();
    const sanitizedEvent = this.utilsSvc.sanitizeEvent(req.event);
    const eventWithAddedTeamId = {
      ...sanitizedEvent,
      ...{
        team_id: req.teamId
      }
    };
    const queryParams = this.utilsSvc.addEventTypeToQueryParams(req, {});
    const response = await this.postWithQuery(path, eventWithAddedTeamId, queryParams, 'createEvent');
    return response;
  }
  async updateEvent(event) {
    const path = this.utilsSvc.getEventUpdateUrl(event.id);
    const sanitizedEvent = this.utilsSvc.sanitizeEvent(event);
    const updatedEvent = await this.patch(path, sanitizedEvent, 'updateEvent');
    return updatedEvent;
  }
  async copyEvent(req, type) {
    const path = this.utilsSvc.getEventCopyUrl(req.event.id);
    const queryParams = this.utilsSvc.addEventTypeToQueryParams({
      type: type
    }, {});
    const sanitizedRequest = this.utilsSvc.sanitizeCopyEventRequest(req);
    const response = await this.postWithQuery(path, sanitizedRequest, queryParams, 'copyEvent');
    return response;
  }
  async copyEventV4(req, params) {
    const path = this.utilsSvc.getEventCopyUrl(req.event.id, 'baseUrl_4_0');
    const sanitizedRequest = this.utilsSvc.sanitizeCopyEventV4Request(req);
    const response = await this.postWithQuery(path, sanitizedRequest, params, 'copyEventV4');
    return response;
  }
  async cancelEvent(req, eventId) {
    const path = this.utilsSvc.getEventCancelUrl(eventId);
    const response = await this.post(path, req, 'cancelEvent');
    return response;
  }
  async cancelEventForParticipant(req, participantId, eventId) {
    const path = this.utilsSvc.getEventCancelUrl(eventId);
    req.participant_filter = {
      and: [{
        id: {
          in: [participantId]
        }
      }]
    };
    const response = await this.post(path, req, 'cancelEventForParticipant');
    return response;
  }
  async copyEventAsTemplate(eventId, templateName) {
    const path = this.utilsSvc.getEventCopyUrl(eventId);
    const queryParams = this.utilsSvc.addEventTypeToQueryParams({
      type: "template" /* EventType.template */
    }, {});
    const body = {
      event: {
        id: eventId,
        name: templateName
      }
    };
    const response = await this.postWithQuery(path, body, queryParams, 'copyEventAsTemplate');
    return response;
  }
  async deleteEvent(eventId) {
    const path = this.utilsSvc.getEventDeleteUrl(eventId);
    await this.delete(path, 'deleteEvent');
  }
  async exportEvent(eventId) {
    const path = this.utilsSvc.getEventExportUrl(eventId);
    return await this.post(path, {}, 'exportEvent');
  }
  async bulkUpdateEventOrder(eventId, patchValue, req) {
    const path = this.utilsSvc.getEventOrderBulkUpdateUrl(eventId);
    const payload = this.getOrderBulkUpdatePayload(patchValue, req);
    const response = await this.post(path, payload, 'bulkUpdateEventOrder');
    return response;
  }
  getEventIconUrl(eventId) {
    return this.utilsSvc.getEventIconGetUrl(eventId);
  }
  async setEventIcon(eventId, fileName, contentType, array) {
    const path = this.utilsSvc.getEventIconSetUrl(eventId);
    const blob = new Blob([array], {
      type: contentType
    });
    const queryParams = {
      filename: fileName
    };
    return await this.putWithQuery(path, blob, queryParams, 'setEventIcon');
  }
  // Event app
  async createEventApp(eventApp) {
    const path = this.utilsSvc.getEventAppCreateUrl();
    const sanitizedEventApp = this.utilsSvc.sanitizeEventApp(eventApp);
    const createdEventApp = await this.post(path, sanitizedEventApp, 'createEventApp');
    return createdEventApp;
  }
  async updateEventApp(eventApp) {
    const path = this.utilsSvc.getEventAppUpdateUrl(eventApp.id);
    const sanitizedEventApp = this.utilsSvc.sanitizeEventApp(eventApp);
    const updatedEventApp = await this.patch(path, sanitizedEventApp, 'updateEventApp');
    return updatedEventApp;
  }
  async searchEventApps(req) {
    const path = this.utilsSvc.getEventAppsSearchUrl();
    const payload = this.utilsSvc.getSearchEventAppsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventApps');
    return response;
  }
  async getAllEventApps() {
    const result = await this.getAllPagedItems(req => this.searchEventApps(req), res => res.event_apps);
    return result;
  }
  async deleteEventApp(eventAppId) {
    const path = this.utilsSvc.getEventAppDeleteUrl(eventAppId);
    await this.delete(path, 'deleteEventApp');
  }
  async getEventApp(eventAppId) {
    const path = this.utilsSvc.getEventAppGetUrl(eventAppId);
    const res = await this.get(path, 'getEventApp');
    return res;
  }
  async assignEventsToEventApp(eventAppId, eventIds) {
    const path = this.utilsSvc.getAssignEventsToEventAppUrl(eventAppId);
    const body = {
      ids: eventIds
    };
    await this.post(path, body, 'assignEventsToEventApp');
  }
  async unassignEventsFromEventApp(eventAppId, eventIds) {
    const path = this.utilsSvc.getUnassignEventsFromEventAppUrl(eventAppId);
    const body = {
      ids: eventIds
    };
    await this.post(path, body, 'unassignEventsFromEventApp');
  }
  async getEventAppSelectedProfileIds(eventId) {
    const path = this.utilsSvc.getEventAppProfileIdsGetUrl(eventId);
    const res = await this.get(path, 'getEventAppSelectedProfileIds');
    return res;
  }
  async setEventAppSelectedProfileIds(eventId, profileIds, defaultProfileId) {
    const path = this.utilsSvc.getEventAppProfileIdsSetUrl(eventId);
    const body = {
      profile_ids: profileIds,
      default_profile_id: defaultProfileId
    };
    const res = await this.put(path, body, 'setEventAppSelectedProfileIds');
    return res;
  }
  async getEventAppProfile(eventId, profileId) {
    const path = this.utilsSvc.getEventAppProfileGetUrl(eventId, profileId);
    const res = await this.get(path, 'getEventAppProfile');
    return res;
  }
  async saveEventAppProfile(eventId, profileId, eventAppProfile) {
    const path = this.utilsSvc.getEventAppProfileSetUrl(eventId, profileId);
    const payload = eventAppProfile;
    await this.put(path, payload, 'setEventAppProfile');
  }
  async getEventAppEventStandalone(eventId) {
    const path = this.utilsSvc.getEventAppEventStandaloneUrl(eventId);
    const data = await this.get(path, 'getEventAppEventStandalone', [404]).catch(error => {
      if (error.communicationError?.body?.code === 'ObjectNotFound') {
        return null;
      }
      throw error;
    });
    return data ?? null;
  }
  async createEventAppEventStandalone(eventId, data) {
    const path = this.utilsSvc.createEventAppEventStandaloneUrl(eventId);
    const result = await this.post(path, data, 'createEventAppEventStandalone');
    return result;
  }
  async getEventAppStandalone(eventAppID) {
    const path = this.utilsSvc.getEventAppStandaloneUrl(eventAppID);
    const data = await this.get(path, 'getEventAppStandalone');
    return data;
  }
  async updateEventAppStandalone(eventAppID, data) {
    const path = this.utilsSvc.updateEventAppStandaloneUrl(eventAppID);
    const result = await this.patch(path, data, 'updateEventAppStandalone');
    return result;
  }
  async deleteEventAppStandalone(eventAppID) {
    const path = this.utilsSvc.deleteEventAppStandaloneUrl(eventAppID);
    await this.delete(path, 'deleteEventAppStandaloneUrl');
  }
  async addTeamsToEventApp(eventAppId, teamIds) {
    const path = this.utilsSvc.getEventAppAddTeamsUrl(eventAppId);
    const payload = {
      ids: teamIds
    };
    await this.post(path, payload, 'addTeamsToEventApp');
  }
  async removeTeamsFromEventApp(eventAppId, teamIds) {
    const path = this.utilsSvc.getEventAppRemoveTeamsUrl(eventAppId);
    const payload = {
      ids: teamIds
    };
    await this.post(path, payload, 'removeTeamsFromEventApp');
  }
  async searchEventEventApps(eventId, req) {
    const path = this.utilsSvc.getSearchEventEventAppsUrl(eventId);
    const payload = this.utilsSvc.getSearchEventEventAppsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventEventApps');
    return response;
  }
  // Email campaigns
  async sendEmailCampaignToTeams(campagnId, req, teamIds) {
    const url = this.utilsSvc.getEmailCampaignSendToTeamsUrl(campagnId);
    const payload = this.utilsSvc.getSearchTeamsPayload(req);
    const res = await this.post(url, payload, 'sendEmailCampaignToTeams');
    return res;
  }
  async sendTestEmail(campaignId, email) {
    const path = this.utilsSvc.getTestEmailSendUrl(campaignId);
    const payload = {
      to_email: email,
      language: 'en-US'
    };
    await this.post(path, payload, 'sendTestEmail');
  }
  async searchEventEmailCampaigns(req) {
    const path = this.utilsSvc.getEventEmailCampaignsSearchUrl(req.eventId);
    const payload = this.utilsSvc.getSearchEmailCampaignsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventEmailCampaigns');
    return response;
  }
  async getEmailCampaignAudience(emailCampaignId, advancedSearch) {
    const path = this.utilsSvc.getEmailCampaignAudienceGetUrl(emailCampaignId);
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(advancedSearch), 'getEmailCampaignAudience');
    return response;
  }
  async searchEmailCampaignAudience(req) {
    const path = this.utilsSvc.getEmailCampaignAudienceSearchUrl(req.emailCampaignId);
    const payload = this.utilsSvc.getSearchEmailCampaignAudiencePayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEmailCampaignAudience');
    return response;
  }
  async getEmailCampaign(campaignId) {
    const path = this.utilsSvc.getEmailCampaignGetUrl(campaignId);
    return await this.get(path, 'getEmailCampaign');
  }
  async updateEmailCampaign(campaign) {
    const path = this.utilsSvc.getEmailCampaignUpdateUrl(campaign.id);
    const sanitized = this.utilsSvc.sanitizeEmailCampaign(campaign);
    const updated = await this.patch(path, sanitized, 'updateEmailCampaign');
    return updated;
  }
  async deleteEmailCampaign(campaignId) {
    const path = this.utilsSvc.getEmailCampaignDeleteUrl(campaignId);
    await this.delete(path, 'deleteEmailCampaign');
  }
  async createEventEmailCampaign(eventId, emailCampaign) {
    const path = this.utilsSvc.getEventEmailCampaignCreateUrl(eventId);
    const sanitizedEmailCampaign = this.utilsSvc.sanitizeEmailCampaign(emailCampaign);
    const createdEmailCampaign = await this.post(path, sanitizedEmailCampaign, 'createEventEmailCampaign');
    return createdEmailCampaign;
  }
  async bulkSetEventEmailCampaignsField(eventId, req) {
    const emailCampaignFilter = this.utilsSvc.getSearchEmailCampaignsPayload(req.email_campaign_filter);
    const path = this.utilsSvc.getEventEmailCampaignsBulkFieldSetUrl(eventId);
    const payload = {
      ...emailCampaignFilter,
      update: req.update
    };
    const response = await this.post(path, payload, 'bulkSetEventEmailCampaignsField');
    return response;
  }
  async createEmailCampaignSchedule(campaignId, req, fieldMode = 'name') {
    const path = this.utilsSvc.getEmailCampaignScheduleCreateUrl(campaignId);
    const queryParams = {
      field_mode: fieldMode
    };
    const payload = this.utilsSvc.getCreateEmailCampaignSchedulePayload(req);
    const campaignSchedule = await this.postWithQuery(path, payload, queryParams, 'createEmailCampaignSchedule');
    return campaignSchedule;
  }
  async getEmailCampaignSchedules(req) {
    const path = this.utilsSvc.getEmailCampaignSchedulesGetUrl(req.campaignId);
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getEmailCampaignSchedules');
    return response;
  }
  async updateEmailCampaignSchedule(scheduleId, sendTime) {
    const path = this.utilsSvc.getEmailCampaignScheduleUpdateUrl(scheduleId);
    const updated = await this.patch(path, {
      send_time: sendTime
    }, 'updateEmailCampaignSchedule');
    return updated;
  }
  async deleteEmailCampaignSchedule(scheduleId) {
    const path = this.utilsSvc.getEmailCampaignScheduleDeleteUrl(scheduleId);
    await this.delete(path, 'deleteEmailCampaignSchedule');
  }
  // Event email templates
  // async searchEventEmailTemplates(req: ISearchEventEmailTemplatesRequest): Promise<ISearchEmailTemplatesResponse> {
  //     const path = this.utilsSvc.getEventEmailTemplatesSearchUrl(req.eventId);
  //     const payload = this.utilsSvc.getSearchEmailTemplatesPayload(req);
  //     const res = await this.postWithQuery<ISearchEmailTemplatesResponse>(
  //         path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventEmailTemplates'
  //     );
  //     return res;
  // }
  async searchGlobalEventEmailTemplates(req) {
    const path = this.utilsSvc.getGlobalEventEmailTemplatesSearchUrl();
    const payload = this.utilsSvc.getSearchEmailTemplatesPayload(req);
    const res = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchGlobalEventEmailTemplates');
    return res;
  }
  async createGlobalEventEmailTemplate(emailTemplate) {
    const path = this.utilsSvc.getGlobalEventEmailTemplateCreateurl();
    const payload = this.utilsSvc.sanitizeEmailTemplateForCreate(emailTemplate);
    const res = await this.post(path, payload, 'createGlobalEventEmailTemplate');
    return res;
  }
  // async getAllEventEmailTemplates(eventId: string): Promise<IEmailTemplate[]> {
  //     const req: ISearchEventEmailTemplatesRequest = {
  //         eventId: eventId, limit: 50, offset: 0, sortFieldName: 'name', sortDirection: 'asc'
  //     };
  //     const emailTemplates = await this.getAllPagedItems(
  //         request => this.searchEventEmailTemplates(request),
  //         response => response.emailtemplates,
  //         req
  //     );
  //     return emailTemplates;
  // }
  async getAllEventEmailCampaigns(eventId) {
    const req = {
      eventId: eventId,
      limit: 50,
      offset: 0,
      sortFieldName: 'name',
      sortDirection: 'asc'
    };
    const emailCampaigns = await this.getAllPagedItems(request => this.searchEventEmailCampaigns(request), response => response.campaigns, req);
    return emailCampaigns;
  }
  async getEmailTemplateAllVersions(emailTemplateId) {
    const path = this.utilsSvc.getEmailTemplateGetAllVersionsUrl(emailTemplateId);
    const res = await this.get(path, 'getEmailTemplateAllVersions');
    return res;
  }
  // async updateEmailTemplate(req: IUpdateEmailTemplateRequest): Promise<IUpdateEmailTemplateResponse> {
  //     const path = this.utilsSvc.getEmailTemplateUpdateUrl(req.emailTemplateId);
  //     const res = await this.patch<IUpdateEmailTemplateResponse>(
  //         path, req.data, 'updateEmailTemplate'
  //     );
  //     return res;
  // }
  async createEmailTemplateVersion(req) {
    const path = this.utilsSvc.getEmailTemplateCreateVersionUrl(req.emailTemplateId);
    delete req.emailTemplateId;
    const res = await this.post(path, req, 'createEmailTemplateVersion');
    return res;
  }
  async getEmailTemplateVersion(emailTemplateId, versionId) {
    const path = this.utilsSvc.getEmailTemplateGetVersionUrl(emailTemplateId, versionId);
    const res = await this.get(path, 'getEmailTemplateVersion');
    return res;
  }
  // async getEmailTemplate(emailTemplateId: string): Promise<IEmailTemplate> {
  //     const path = this.utilsSvc.getEmailTemplateGetUrl(emailTemplateId);
  //     const eventPage = await this.get<IEmailTemplate>(path, 'getEmailTemplate');
  //     return eventPage;
  // }
  // async createEventEmailTemplate(req: ICreateEventEmailTemplateRequest): Promise<IEmailTemplate> {
  //     const path = this.utilsSvc.getEventEmailTemplateCreateUrl(req.eventId);
  //     const createdEventEmailTemplate = await this.post<IEmailTemplate>(
  //         path, req.emailTemplate, 'createEventEmailTemplate'
  //     );
  //     return createdEventEmailTemplate;
  // }
  async deleteEmailTemplate(emailTemplateId) {
    const path = this.utilsSvc.getEmailTemplateDeleteUrl(emailTemplateId);
    await this.delete(path, 'deleteEmailTemplate');
  }
  async publishEmailTemplate(req, ignoreHttpErrorsList) {
    const path = this.utilsSvc.getEmailTemplatePublishUrl(req.emailTemplateId, req.versionId);
    await this.post(path, this.utilsSvc.sanitizePublishEmailTemplateRequest(req), 'publishEmailTemplate', ignoreHttpErrorsList);
  }
  async unpublishEmailTemplate(emailTemplateId) {
    const path = this.utilsSvc.getEmailTemplateUnpublishUrl(emailTemplateId);
    await this.post(path, undefined, 'unpublishEmailTemplate');
  }
  async syncEmailTemplate(emailTemplateId, grapesJSON) {
    const path = this.utilsSvc.getEmailTemplateSyncUrl(emailTemplateId);
    await this.put(path, grapesJSON, 'syncEmailTemplate');
  }
  // Event fields
  async getEventFields(req) {
    const path = this.utilsSvc.getEventFieldsGetUrl(req.eventId);
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getEventFields');
    return response;
  }
  async getAllEventFields(eventId) {
    const req = {
      eventId: eventId,
      limit: 50,
      offset: 0
    };
    const fields = await this.getAllPagedItems(request => this.getEventFields(request), response => response.fields, req);
    return fields;
  }
  async searchEventFields(req) {
    const path = this.utilsSvc.getEventFieldsSearchUrl(req.eventId);
    const payload = this.utilsSvc.getSearchEventFieldsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventFields');
    return response;
  }
  async createEventField(req) {
    const path = this.utilsSvc.getEventFieldCreateUrl(req.eventId);
    const payload = this.utilsSvc.sanitizeField(req.field);
    const createdField = await this.post(path, payload, 'createEventField');
    return createdField;
  }
  async updateEventField(req) {
    const path = this.utilsSvc.getEventFieldUpdateUrl(req.eventId, req.field.id);
    const payload = this.utilsSvc.sanitizeFieldOnEventUpdate(req.field);
    const updatedField = await this.patch(path, payload, 'updateEventField');
    return updatedField;
  }
  async archiveEventField(eventId, fieldId) {
    const path = this.utilsSvc.getEventFieldUpdateUrl(eventId, fieldId);
    return await this.delete(path, 'archiveEventField');
  }
  async getEventField(eventId, fieldId) {
    const path = this.utilsSvc.getEventFieldGetUrl(eventId, fieldId);
    const eventField = this.get(path, 'getEventField');
    return eventField;
  }
  // Event series
  async searchEventSeries(req) {
    const path = this.utilsSvc.getEventSeriesSearchUrl();
    const payload = this.utilsSvc.getSearchEventSeriesPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchEventSeries');
    return response;
  }
  async createEventSeries(eventSeries, teamId) {
    const path = this.utilsSvc.getEventSeriesCreateUrl();
    const payload = {
      ...eventSeries
    };
    payload.team_id = teamId;
    const response = await this.post(path, payload, 'createEventSerie');
    return response;
  }
  async getEventSeries(eventSeriesId) {
    const path = this.utilsSvc.getEventSeriesGetUrl(eventSeriesId);
    const response = await this.get(path, 'getEventSerie');
    return response;
  }
  async updateEventSeries(eventSeries) {
    const path = this.utilsSvc.getEventSeriesUpdateUrl(eventSeries.id);
    const sanitized = this.utilsSvc.sanitizeEventSerieForUpdate(eventSeries);
    const response = await this.patch(path, sanitized, 'updateEentSerie');
    return response;
  }
  async deleteEventSeries(eventSeriesId) {
    const path = this.utilsSvc.getEventSeriesDeleteUrl(eventSeriesId);
    await this.delete(path, 'deleteEventSerie');
  }
  async searchSeriesEvents(eventSeriesId, fromDate, toDate) {
    const path = this.utilsSvc.getEventSeriesEventsSearchUrl(eventSeriesId);
    const searchObj = this.utilsSvc.getStartEndSearchParams(fromDate, toDate);
    const payload = {
      event_filter: searchObj
    };
    const response = await this.post(path, payload, 'searchSerieEvents');
    return response;
  }
  async searchEventsInEventSeries(eventId, fromDate, toDate) {
    const path = this.utilsSvc.getEventsInEventSeriesSearchUrl(eventId);
    const searchObj = this.utilsSvc.getStartEndSearchParams(fromDate, toDate);
    const payload = {
      event_filter: searchObj
    };
    const response = await this.post(path, payload, 'searchEventsInEventSeries');
    return response;
  }
  async createSeriesSequence(seriesId, req) {
    const path = this.utilsSvc.getEventSeriesSequenceCreateUrl(seriesId);
    await this.post(path, req, 'createSeriesSequence');
  }
  async addTeamsToEventSeries(eventSeriesId, teamIds) {
    const path = this.utilsSvc.getEventSeriesTeamsAddUrl(eventSeriesId);
    const payload = {
      ids: teamIds
    };
    await this.post(path, payload, 'addEventSeriesTeams');
  }
  async removeTeamsFromEventSeries(eventSeriesId, teamIds) {
    const path = this.utilsSvc.getEventSeriesTeamsRemoveUrl(eventSeriesId);
    const payload = {
      ids: teamIds
    };
    await this.post(path, payload, 'removeEventSeriesTeams');
  }
  async publishEventSeries(eventSeriesId) {
    const path = this.utilsSvc.getEventSeriesPublishUrl(eventSeriesId);
    const response = this.post(path, null, 'publishEventSeries');
    return response;
  }
  async resetEventSeries(eventSeriesId) {
    const path = this.utilsSvc.getEventSeriesResetUrl(eventSeriesId);
    await this.post(path, null, 'resetEventSeries');
  }
  async updateSequenceEvent(event, seriesId) {
    const path = this.utilsSvc.getSequenceEventUpdateurl(event.id, seriesId);
    const sanitized = this.utilsSvc.sanitizeEvent(event);
    await this.patch(path, sanitized, 'updateSeriesEvent');
  }
  async updateSeriesSequence(seriesId, sequenceId, req) {
    const path = this.utilsSvc.getSeriesSequenceUpdateurl(sequenceId, seriesId);
    const sanitizedReq = {
      ...req
    };
    sanitizedReq.event_attributes = this.utilsSvc.sanitizeEvent(sanitizedReq.event_attributes);
    await this.patch(path, sanitizedReq, 'updateSeriesSequence');
  }
  // Event participant fields
  async searchEventParticipantFields(req) {
    const path = this.utilsSvc.getEventParticipantFieldsSearchUrl(req.eventId);
    const payload = this.utilsSvc.getSearchEventParticipantFieldsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventParticipantFields');
    return response;
  }
  async getEventParticipantField(fieldId) {
    const path = this.utilsSvc.getEventParticipantFieldGetUrl(fieldId);
    const field = await this.get(path, 'getEventParticipantField');
    return field;
  }
  async getAllEventParticipantFields(eventId) {
    const searchRequest = {
      eventId: eventId,
      limit: 50,
      offset: 0
    };
    const fields = await this.getAllPagedItems(request => this.searchEventParticipantFields(request), response => response.fields, searchRequest);
    return fields;
  }
  async createEventParticipantField(req) {
    const path = this.utilsSvc.getEventParticipantFieldCreateUrl(req.eventId);
    const payload = this.utilsSvc.sanitizeField(req.field);
    const createdField = await this.post(path, payload, 'createEventParticipantField');
    return createdField;
  }
  async updateEventParticipantField(field) {
    const path = this.utilsSvc.getEventParticipantFieldUpdateUrl(field.id);
    const payload = this.utilsSvc.sanitizeField(field);
    const updatedField = await this.patch(path, payload, 'updateEventParticipantField');
    return updatedField;
  }
  async bulkUpdateEventParticipantField(eventId, req, field) {
    const path = this.utilsSvc.getEventParticipantFieldBulkUpdateUrl(eventId);
    const fieldFilter = this.utilsSvc.getBulkUpdateEventPartcipantFieldsFilterPayload(req);
    const payload = {
      ...fieldFilter,
      update_body: field
    };
    return await this.post(path, payload, 'bulkUpdateEventParticipantField');
  }
  async archiveEventParticipantField(fieldId) {
    const path = this.utilsSvc.getEventParticipantFieldDeleteUrl(fieldId);
    return await this.delete(path, 'archiveEventParticipantField');
  }
  // Event teams
  async addTeamsToEvent(req) {
    const path = this.utilsSvc.getAddTeamsToEventUrl(req.eventId);
    const payload = {
      ids: req.teamIds
    };
    await this.post(path, payload, 'addTeamsToEvent');
  }
  async removeTeamsFromEvent(req) {
    const path = this.utilsSvc.getRemoveTeamsFromEventUrl(req.eventId);
    const payload = {
      ids: req.teamIds
    };
    await this.post(path, payload, 'removeTeamsFromEvent');
  }
  async sendEventTeamsMessage(eventId, integrationId, message, req) {
    const path = this.utilsSvc.getSendEventTeamsMessageUrl(eventId);
    const payload = {
      integration_id: integrationId,
      message: message,
      team_filter: {
        ...this.utilsSvc.getSearchTeamsPayload(req).team_filter
      }
    };
    const res = await this.post(path, payload, 'sendEventTeamsMessage');
    return res;
  }
  // Global events fields
  async getGlobalEventFields(req) {
    const response = await this.getWithQuery(this.utilsSvc.getGlobalEventFieldsGetUrl(), this.utilsSvc.sanitizePagedRequest(req), 'getGlobalEventFields');
    this.setTeamIdsFromToken(response.fields);
    return response;
  }
  async getGlobalEventField(fieldId) {
    const path = this.utilsSvc.getGlobalEventFieldGetUrl(fieldId);
    const field = await this.get(path, 'getGlobalEventField');
    this.setTeamIdsFromToken(field);
    return field;
  }
  async getAllGlobalEventFields() {
    const fields = await this.getAllPagedItems(request => this.getGlobalEventFields(request), response => response.fields);
    return fields;
  }
  async searchGlobalEventFields(req) {
    const path = this.utilsSvc.getGlobalEventFieldsSearchUrl();
    const payload = this.utilsSvc.getSearchEventFieldsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchGlobalEventFields');
    this.setTeamIdsFromToken(response.fields);
    return response;
  }
  async updateGlobalEventField(field) {
    const path = this.utilsSvc.getGlobalEventFieldUpdateUrl(field.id);
    const payload = this.utilsSvc.sanitizeField(field);
    const updatedField = await this.patch(path, payload, 'updateGlobalEventField');
    this.setTeamIdsFromToken(updatedField);
    return updatedField;
  }
  async bulkUpdateGlobalEventField(fieldId, fieldMode = 'id', eventType, req) {
    const eventFilter = this.utilsSvc.getSearchEventsPayload(req.event_filter);
    const path = this.utilsSvc.getGlobalEventFieldBulkSetUrl(fieldId, fieldMode);
    const query = {
      type: eventType
    };
    const payload = {
      ...eventFilter,
      value: req.value
    };
    return await this.postWithQuery(path, payload, query, 'bulkUpdateGlobalEventField');
  }
  async createGlobalEventField(field) {
    const path = this.utilsSvc.getGlobalEventFieldCreateUrl();
    const createdField = await this.post(path, field, 'createGlobalEventField');
    this.setTeamIdsFromToken(createdField);
    return createdField;
  }
  async archiveGlobalEventField(fieldId) {
    const path = this.utilsSvc.getGlobalEventFieldUpdateUrl(fieldId);
    return await this.delete(path, 'archiveGlobalEventField');
  }
  // Event participants
  async getEventParticipantActivities(participantId, req) {
    const path = this.utilsSvc.getEventParticipantActivitiesGetUrl(participantId);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.getWithQuery(path, queryParams, 'getEventParticipantActivities');
    return response;
  }
  async mergeEventParticipantsWithDocument(eventId, req) {
    const path = this.utilsSvc.getEventParticipantsMergeWithDocumentUrl(eventId);
    const payload = this.utilsSvc.getMergeEventParticipantsWithDocumentPayload(req);
    const response = await this.post(path, payload, 'mergeEventParticipantsWithDocument');
    return response;
  }
  async mergeEventParticipantsWithDocumentGenerateCertificate(eventId, req) {
    const path = this.utilsSvc.getEventParticipantsMergeWithDocumentGenerateCertificateUrl(eventId);
    const payload = this.utilsSvc.getMergeEventParticipantsWithDocumentGenerateCertificatePayload(req);
    const response = await this.post(path, payload, 'mergeEventParticipantsWithDocumentGenerateCertificate');
    return response;
  }
  async searchEventParticipants(req) {
    const path = this.utilsSvc.getEventParticipantsSearchUrl(req.eventId);
    const payload = this.utilsSvc.getSearchEventParticipantsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventParticipants');
    return response;
  }
  async searchEventParticipantsByFieldNames(req, fieldNames) {
    const path = this.utilsSvc.getEventParticipantsSearchUrl(req.eventId);
    const payload = this.utilsSvc.getSearchEventParticipantsByFieldsPayload(req, fieldNames);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventParticipantsByFieldNames');
    return response;
  }
  async createEventParticipant(req) {
    const path = this.utilsSvc.getEventParticipantCreateUrl(req.eventId);
    const sanitizedParticipant = this.utilsSvc.sanitizeEventParticipant(req.eventParticipant);
    const response = await this.post(path, sanitizedParticipant, 'createEventParticipant');
    return response;
  }
  async deleteEventParticipant(participantId) {
    const path = this.utilsSvc.getEventParticipantDeleteUrl(participantId);
    await this.delete(path, 'deleteEventParticipant');
  }
  async bulkArchiveEventParticipants(eventId, req) {
    const path = this.utilsSvc.getEventParticipantBulkArchiveUrl(eventId);
    const payload = this.utilsSvc.getBulkEventParticipantsArchivePayload(req.participant_filter);
    return await this.post(path, payload, 'bulkArchiveEventParticipants');
  }
  async updateEventParticipant(participant) {
    const path = this.utilsSvc.getEventParticipantUpdateUrl(participant.id);
    const sanitizedParticipant = this.utilsSvc.sanitizeEventParticipant(participant);
    const updatedEventParticipant = this.patch(path, sanitizedParticipant, 'updateEventParticipant');
    return updatedEventParticipant;
  }
  async getEventParticipant(participantId) {
    const path = this.utilsSvc.getEventParticipantGetUrl(participantId);
    const eventParticipant = await this.get(path, 'getEventParticipant');
    return eventParticipant;
  }
  async searchParticipantAudits(participantId, req) {
    const url = this.utilsSvc.getParticipantAuditsSearchUrl(participantId);
    const payload = this.utilsSvc.getSearchParticipantAuditsPayload(req);
    const res = await this.postWithQuery(url, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchParticipantAudits');
    return res;
  }
  async getEventParticipantTokens(participantId) {
    const path = this.utilsSvc.getEventParticipantGetTokensUrl(participantId);
    const eventParticipantTokens = await this.get(path, 'getEventParticipantTokens');
    return eventParticipantTokens;
  }
  async getEventParticipantSentEmails(req) {
    const path = this.utilsSvc.getEventParticipantGetSentEmailsUrl(req.participant_id);
    const eventParticipantSentEmails = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getEventParticipantSentEmails');
    return eventParticipantSentEmails;
  }
  async bulkSetEventParticipantField(eventId, fieldId, req) {
    const participantFilter = this.utilsSvc.getBulkSetEventParticipantFieldFilterPayload(req.participant_filter);
    const path = this.utilsSvc.getEventParticipantBulkFieldSetUrl(eventId, fieldId);
    const payload = {
      ...participantFilter,
      value: req.value
    };
    const response = await this.post(path, payload, 'bulkSetEventParticipantField');
    return response;
  }
  async bulkUpdateEventParticipantsStage(eventId, stageId, req) {
    const path = this.utilsSvc.getEventParticipantBulkStageUpdateUrl(eventId, stageId);
    const payload = this.utilsSvc.getBulkUpdateEventParticipantsStagesFilterPayload(req.participant_filter);
    return await this.post(path, payload, 'bulkUpdateEventParticipantsStage');
  }
  async updateEventParticipantStage(participantId, stageId) {
    const path = this.utilsSvc.getEventParticipantUpdateStageUrl(participantId);
    const payload = {
      stage_id: stageId
    };
    await this.put(path, payload, 'updateEventParticipantStage');
  }
  async exportEventParticipants(eventId, req) {
    const path = this.utilsSvc.getEventParticipantExportUrl(eventId);
    const payload = this.utilsSvc.getBulkSetEventParticipantFieldFilterPayload(req.participant_filter);
    return await this.post(path, {
      ...req,
      ...payload
    }, 'exportEventParticipants');
  }
  async addTeamsToEventParticipant(req) {
    const path = this.utilsSvc.getEventParticipantAddTeamsUrl(req.participantId);
    const payload = {
      ids: req.teamIds
    };
    return await this.post(path, payload, 'addTeamsToEventParticipant');
  }
  async removeTeamsFromEventParticipant(req) {
    const path = this.utilsSvc.getEventParticipantRemoveTeamsUrl(req.participantId);
    const payload = {
      ids: req.teamIds
    };
    return await this.post(path, payload, 'removeTeamsFromEventParticipant');
  }
  async addEventParticipantsToEvent(req, targetEventId, fieldMode) {
    const path = this.utilsSvc.getEventParticipantAddToEventUrl(req.eventId, targetEventId);
    const payload = this.utilsSvc.getSearchEventParticipantsPayload(req);
    const queryParams = {
      field_mode: fieldMode ?? 'name'
    };
    return await this.postWithQuery(path, payload, queryParams, 'addEventParticipantsToEvent');
  }
  async bulkSetEventParticipantsTeams(eventId, req) {
    const payload = this.utilsSvc.getBulkSetEventParticipantsTeamsPayload(req);
    const path = this.utilsSvc.getEventParticipantsTeamsBulkSetUrl(eventId);
    return await this.post(path, payload, 'bulkSetEventParticipantsTeams');
  }
  // Contacts
  async searchContacts(req) {
    const path = this.utilsSvc.getContactsSearchUrl();
    const payload = this.utilsSvc.getSearchContactsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchContacts');
    response.contacts = this.utilsSvc.removeExternalIds(response.contacts);
    this.setTeamIdsFromToken(response.contacts);
    return response;
  }
  async getContact(contactId) {
    const path = this.utilsSvc.getContactUrl(contactId);
    let contact = await this.get(path, 'getContact');
    contact = this.utilsSvc.removeExternalId(contact);
    this.setTeamIdsFromToken([contact]);
    return contact;
  }
  async getContactSentEmails(req) {
    const path = this.utilsSvc.getContactGetSentEmailsUrl(req.contact_id);
    const contactSentEmails = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getContactSentEmails');
    return contactSentEmails;
  }
  async sendContactsMessage(integrationId, contactNumberFieldId, message, req) {
    const path = this.utilsSvc.getContactsSendMessageUrl();
    const payload = {
      integration_id: integrationId,
      contact_number_field_id: contactNumberFieldId,
      message: message,
      contact_filter: {
        ...this.utilsSvc.getSearchContactsPayload(req).contact_filter
      }
    };
    const res = await this.post(path, payload, 'sendContactsSms');
    return res;
  }
  async getContactEmailCampaignSubscriptions(contactId) {
    const path = this.utilsSvc.getContactEmailCampaignSubscriptionsGetUrl(contactId);
    const res = await this.get(path, 'getContactEmailCampaignSubscriptions');
    return res;
  }
  async setContactEmailCampaignSubscriptions(contactId, subscriptions) {
    const path = this.utilsSvc.getContactEmailCampaignSubscriptionsSetUrl(contactId);
    await this.put(path, subscriptions, 'setContactEmailCampaignSubscriptions');
  }
  async sendParticipantsMessage(eventId, integrationId, participantNumberFieldId, message, req, subject, event_app_component) {
    const path = this.utilsSvc.getParticipantsSendMessageUrl(eventId);
    const searchEventParticipantsReq = {
      eventId: eventId,
      ...req
    };
    const payload = {
      integration_id: integrationId,
      participant_number_field_id: participantNumberFieldId,
      subject: subject,
      message: message,
      event_app_component: event_app_component,
      participant_filter: {
        ...this.utilsSvc.getSearchEventParticipantsPayload(searchEventParticipantsReq).participant_filter
      }
    };
    const res = await this.post(path, payload, 'sendParticipantsMessage');
    return res;
  }
  async addContactsToEvent(eventId, req) {
    const path = this.utilsSvc.getContactsAddToEventUrl(eventId);
    const payload = this.utilsSvc.getSearchContactsPayload(req);
    const response = await this.post(path, payload, 'addContactsToEvent');
    return response;
  }
  async updateContact(contact) {
    const path = this.utilsSvc.getContactUpdateUrl(contact.id);
    const sanitizedContact = this.utilsSvc.sanitizeContact(contact);
    let updatedContact = await this.patch(path, sanitizedContact, 'updateContact');
    updatedContact = this.utilsSvc.removeExternalId(updatedContact);
    this.setTeamIdsFromToken(updatedContact);
    return updatedContact;
  }
  async deleteContact(id) {
    const path = this.utilsSvc.getContactDeleteUrl(id);
    await this.delete(path, 'deleteContact');
  }
  async bulkDeleteContacts(req) {
    const url = this.utilsSvc.getContactsBulkDeleteUrl();
    const payload = this.utilsSvc.getSearchContactsPayload(req);
    const res = await this.post(url, payload, 'bulkDeleteContacts');
    return res;
  }
  async createContact(contact) {
    const path = this.utilsSvc.getContactCreateUrl();
    const sanitizedContact = this.utilsSvc.sanitizeContact(contact);
    let createdContact = await this.post(path, sanitizedContact, 'createContact');
    createdContact = this.utilsSvc.removeExternalId(createdContact);
    this.setTeamIdsFromToken(createdContact);
    return createdContact;
  }
  async getContactEvents(contactId, req) {
    const path = this.utilsSvc.getContactEventsUrl(contactId);
    const payload = this.utilsSvc.getSearchEventsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'getContactEvents');
    return response;
  }
  async createContactsEmailTemplate(emailTemplate) {
    const path = this.utilsSvc.getContactsEmailTemplateCreateUrl();
    const sanitized = this.utilsSvc.sanitizeEmailTemplateForCreate(emailTemplate);
    const createdEmailTemplate = await this.post(path, sanitized, 'createContactsEmailTemplate');
    return createdEmailTemplate;
  }
  async searchContactsEmailTemplates(req) {
    const path = this.utilsSvc.getContactsEmailTemplatesSearchUrl();
    const payload = this.utilsSvc.getSearchEmailTemplatesPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchContactsEmailTeplates');
    return response;
  }
  async getAllPages(pageType, eventId, pageSubtype) {
    const req = {
      limit: 50,
      offset: 0,
      pageType: pageType,
      eventId: eventId
    };
    if (pageSubtype) {
      req.advancedQuery = {
        and: [{
          page_subtype: pageSubtype
        }]
      };
    }
    const allPages = await this.getAllPagedItems(request => this.searchPages(request), response => response.pages, req);
    return allPages;
  }
  async getAllContactsEmailTemplates() {
    const emailTemplates = await this.getAllPagedItems(request => this.searchContactsEmailTemplates(request), response => response.emailtemplates);
    return emailTemplates;
  }
  async createContactsEmailCampaign(emailCampaign) {
    const path = this.utilsSvc.getContactsEmailCampaignCreateUrl();
    const sanitizedEmailCampaign = this.utilsSvc.sanitizeEmailCampaign(emailCampaign);
    const createEmailCampaign = await this.post(path, sanitizedEmailCampaign, 'createContactsEmailCampaign');
    return createEmailCampaign;
  }
  async searchContactsEmailCampaigns(req) {
    const path = this.utilsSvc.getContactsEmailCampaignsSearchUrl();
    const payload = this.utilsSvc.getSearchEmailCampaignsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchContactsEmailCampaigns');
    return response;
  }
  async getAllContactsEmailCampaigns() {
    const emailCampaigns = await this.getAllPagedItems(request => this.searchContactsEmailCampaigns(request), response => response.campaigns);
    return emailCampaigns;
  }
  async getAllGlobalEventEmailTemplates() {
    const globalEventEmailCampaigns = await this.getAllPagedItems(request => this.searchGlobalEventEmailTemplates(request), response => response.emailtemplates);
    return globalEventEmailCampaigns;
  }
  // Contact fields
  async searchContactFields(req) {
    const path = this.utilsSvc.getContactFieldsSearchUrl();
    const payload = this.utilsSvc.getSearchFieldsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchContactFields');
    this.setTeamIdsFromToken(response.fields);
    return response;
  }
  async getAllContactFields() {
    const fields = await this.getAllPagedItems(request => this.searchContactFields(request), response => response.fields);
    this.setTeamIdsFromToken(fields);
    return fields;
  }
  // TODO: We need shared library that contains all interfaces used by more than one application component
  //       So we can use here (field: IField): Promise<IField>
  async createContactField(field) {
    const path = this.utilsSvc.getContactFieldCreateUrl();
    const sanitizedField = this.utilsSvc.sanitizeField(field);
    const createdContactField = await this.post(path, sanitizedField, 'createContactField');
    this.setTeamIdsFromToken(createdContactField);
    return createdContactField;
  }
  async updateContactField(field) {
    const path = this.utilsSvc.getContactFieldUpdateUrl(field.id);
    const sanitizedField = this.utilsSvc.sanitizeField(field);
    const updatedContactField = await this.patch(path, sanitizedField, 'updateContactField');
    this.setTeamIdsFromToken(updatedContactField);
    return updatedContactField;
  }
  async bulkUpdateContactFields(fieldId, fieldMode = 'id', req) {
    const contactFilter = this.utilsSvc.getBulkSetContactFieldFilterPayload(req.contact_filter);
    const path = this.utilsSvc.getContactBulkFieldSet(fieldId, fieldMode);
    const payload = {
      ...contactFilter,
      value: req.value
    };
    return await this.post(path, payload, 'bulkUpdateContactFields');
  }
  async getContactField(fieldId) {
    const path = this.utilsSvc.getContactFieldGetUrl(fieldId);
    const contactField = await this.get(path, 'getContactField');
    this.setTeamIdsFromToken(contactField);
    return contactField;
  }
  async archiveContactField(fieldId) {
    const path = this.utilsSvc.getContactFieldUpdateUrl(fieldId);
    return await this.delete(path, 'archiveContactField');
  }
  async exportContacts(req) {
    const contactFilter = this.utilsSvc.getSearchContactsPayload(req.contact_filter);
    const path = this.utilsSvc.getContactExportUrl();
    const payload = {
      ...req,
      ...contactFilter
    };
    return await this.post(path, payload, 'exportContacts');
  }
  // Organizations
  async searchOrganizations(req) {
    const path = this.utilsSvc.getOrganizationsSearchUrl();
    const payload = this.utilsSvc.getSearchOrganizationsPayload(req);
    const organizationsResponse = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchOrganizations');
    organizationsResponse.organizations = this.utilsSvc.removeExternalIds(organizationsResponse.organizations);
    this.setTeamIdsFromToken(organizationsResponse.organizations);
    return organizationsResponse;
  }
  async getOrganization(organizationId) {
    const path = this.utilsSvc.getOrganizationUrl(organizationId);
    let organization = await this.get(path, 'getOtganization');
    organization = this.utilsSvc.removeExternalId(organization);
    this.setTeamIdsFromToken(organization);
    return organization;
  }
  async createOrganization(organization) {
    const path = this.utilsSvc.getOrganizationCreateUrl();
    const sanitizedOrganization = this.utilsSvc.sanitizeOrganization(organization);
    let createdOrganization = await this.post(path, sanitizedOrganization, 'createOrganization');
    createdOrganization = this.utilsSvc.removeExternalId(createdOrganization);
    this.setTeamIdsFromToken(createdOrganization);
    return createdOrganization;
  }
  async deleteOrganization(id) {
    const path = this.utilsSvc.getOrganizationDeleteUrl(id);
    await this.delete(path, 'deleteOrganization');
  }
  async updateOrganization(organization) {
    const path = this.utilsSvc.getOrganizationUpdateUrl(organization.id);
    const sanitizedOrganization = this.utilsSvc.sanitizeOrganization(organization);
    const updatedOrganization = await this.patch(path, sanitizedOrganization, 'updateOrganization');
    this.setTeamIdsFromToken(updatedOrganization);
    return updatedOrganization;
  }
  // Organization fields
  async searchOrganizationFields(req) {
    const path = this.utilsSvc.getOrganizationFieldsSearchUrl();
    const payload = this.utilsSvc.getSearchFieldsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchOrganizationFields');
    this.setTeamIdsFromToken(response.fields);
    return response;
  }
  async getAllOrganizationFields() {
    const fields = await this.getAllPagedItems(request => this.searchOrganizationFields(request), response => response.fields);
    this.setTeamIdsFromToken(fields);
    return fields;
  }
  async createOrganizationField(field) {
    const path = this.utilsSvc.getOrganizationFieldCreateUrl();
    const sanitizedField = this.utilsSvc.sanitizeField(field);
    const createdField = await this.post(path, sanitizedField, 'createOrganizationField');
    this.setTeamIdsFromToken(createdField);
    return createdField;
  }
  async updateOrganizationField(field) {
    const path = this.utilsSvc.getOrganizationFieldUpdateUrl(field.id);
    const sanitizedField = this.utilsSvc.sanitizeField(field);
    const updateField = await this.patch(path, sanitizedField, 'updateOrganizationField');
    this.setTeamIdsFromToken(updateField);
    return updateField;
  }
  async getOrganizationField(fieldId) {
    const path = this.utilsSvc.getOrganizationFieldGetUrl(fieldId);
    const field = await this.get(path, 'getOrganizationField');
    this.setTeamIdsFromToken(field);
    return field;
  }
  async archiveOrganizationField(fieldId) {
    const path = this.utilsSvc.getOrganizationFieldDeleteUrl(fieldId);
    return await this.delete(path, 'archiveOrganizationField');
  }
  async bulkUpdateOrganizationField(fieldId, fieldMode = 'id', req) {
    const contactFilter = this.utilsSvc.getBulkSetOrganizationFieldFilterPayload(req.organization_filter);
    const path = this.utilsSvc.getOrganizationBulkFieldSetUrl(fieldId, fieldMode);
    const payload = {
      ...contactFilter,
      value: req.value
    };
    return await this.post(path, payload, 'bulkUpdateOrganizationField');
  }
  // Server status
  async getServerStatus() {
    const path = this.utilsSvc.getServerStatusUrl();
    return await this.get(path, 'getServerStatus');
  }
  // Provider
  async configureProvider(config) {
    const path = this.utilsSvc.getConfigureProviderUrl();
    return await this.post(path, config, 'configureProvider');
  }
  async getProviderMetadata() {
    const path = this.utilsSvc.getProviderMetadataUrl();
    return await this.getWithResponseType(path, 'text', 'getProviderMetadata');
  }
  async deleteProvider(domain) {
    const path = this.utilsSvc.getDeleteProviderUrl(domain);
    await this.delete(path, 'deleteProvider');
  }
  // API clients
  async getApiClients(req) {
    const path = this.utilsSvc.getApiClientUrl();
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getApiClients');
    return response;
  }
  async getApiClient(id) {
    const path = this.utilsSvc.getApiClientUrl(id);
    return await this.get(path, 'getApiClient');
  }
  async getApiClientTeams(req) {
    const path = this.utilsSvc.getApiClientTeamsUrl(req.clientId);
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getApiClientTeams');
    return response;
  }
  async createApiClient(client) {
    const path = this.utilsSvc.getApiClientUrl();
    return await this.post(path, this.utilsSvc.sanitizeApiClient(client), 'createApiClient');
  }
  async deleteApiClient(id) {
    const path = this.utilsSvc.getApiClientUrl(id);
    await this.delete(path, 'deleteApiClient');
  }
  // Team API clients
  async getTeamApiClients(req) {
    const path = this.utilsSvc.getTeamApiClientsUrl(req.teamId);
    return await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getTeamApiClients');
  }
  async setTeamApiClients(req) {
    const path = this.utilsSvc.getTeamApiClientsUrl(req.teamId);
    await this.put(path, {
      ids: req.clientIds
    }, 'setTeamApiClients');
  }
  async addTeamApiClients(req) {
    const path = this.utilsSvc.getTeamApiClientsUrl(req.teamId);
    await this.post(path, {
      ids: req.clientIds
    }, 'addTeamApiClients');
  }
  // Team roles
  async getTeamRoles(req) {
    const path = this.utilsSvc.getTeamRolesUrl(req.teamId);
    return await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getTeamRoles');
  }
  async setTeamRoles(req) {
    const path = this.utilsSvc.getTeamRolesUrl(req.teamId);
    await this.put(path, {
      ids: req.roleIds
    }, 'setTeamRoles');
  }
  async addTeamRoles(req) {
    const path = this.utilsSvc.getTeamRolesUrl(req.teamId);
    await this.post(path, {
      ids: req.roleIds
    }, 'addTeamRoles');
  }
  async unassignRolesFromTeam(req) {
    const path = this.utilsSvc.getUnassignRolesFromTeamUrl(req.teamId);
    await this.post(path, {
      ids: req.roleIds
    }, 'unassignRolesFromTeam');
  }
  // Team members
  async getTeamMembers(req) {
    const path = this.utilsSvc.getTeamMembersUrl(req.teamId);
    return await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getTeamMembers');
  }
  async setTeamMembers(req) {
    const path = this.utilsSvc.getTeamMembersUrl(req.teamId);
    await this.put(path, {
      ids: req.userIds
    }, 'setTeamMembers');
  }
  async addTeamMembers(req) {
    const path = this.utilsSvc.getTeamMembersUrl(req.teamId);
    await this.post(path, {
      ids: req.userIds
    }, 'addTeamMembers');
  }
  async unassignMembersFromTeam(req) {
    const path = this.utilsSvc.getUnassignMembersFromTeamUrl(req.teamId);
    await this.post(path, {
      ids: req.userIds
    }, 'unassignMembersFromTeam');
  }
  // Team admins
  async getTeamAdmins(req) {
    const path = this.utilsSvc.getTeamAdminsUrl(req.teamId);
    return await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getTeamAdmins');
  }
  async setTeamAdmins(req) {
    const path = this.utilsSvc.getTeamAdminsUrl(req.teamId);
    await this.put(path, {
      ids: req.userIds
    }, 'setTeamAdmins');
  }
  async addTeamAdmins(req) {
    const path = this.utilsSvc.getTeamAdminsUrl(req.teamId);
    await this.post(path, {
      ids: req.userIds
    }, 'addTeamAdmins');
  }
  async unassignAdminsFromTeam(req) {
    const path = this.utilsSvc.getUnassignAdminsFromTeamUrl(req.teamId);
    await this.post(path, {
      ids: req.userIds
    }, 'unassignAdminsFromTeam');
  }
  // Teams
  async getTeams(req) {
    const response = await this.getWithQuery(this.utilsSvc.getTeamUrl(), this.utilsSvc.sanitizePagedRequest(req), 'getTeams');
    this.utilsSvc.setTeamIdsToTeams(response.teams);
    return response;
  }
  async getAllTeams() {
    const teams = (await this.getTeamsList())?.teams ?? [];
    this.utilsSvc.setTeamIdsToTeams(teams);
    return teams;
  }
  async getTeam(id) {
    const team = await this.get(this.utilsSvc.getTeamUrl(id), 'getTeam');
    this.utilsSvc.setTeamIdsToTeams([team]);
    return team;
  }
  async updateTeam(team) {
    const teamToUpdate = this.utilsSvc.sanitizeTeam(team);
    const updatedTeam = await this.patch(this.utilsSvc.getTeamUrl(+team.id), teamToUpdate, 'updateTeam');
    this.utilsSvc.setTeamIdsToTeams([updatedTeam]);
    return updatedTeam;
  }
  async createTeam(team) {
    const teamToCreate = this.utilsSvc.sanitizeTeam(team);
    const createdTeam = await this.post(this.utilsSvc.getTeamUrl(), teamToCreate, 'createTeam');
    this.utilsSvc.setTeamIdsToTeams([createdTeam]);
    return createdTeam;
  }
  /**
   * @deprecated For creating Team list drop-down, or retrieving simple `Team` object of `id` & `name`, please use `getTeamsList()` instead to improve performance. This endpoint is only intended to retrieve the Team list if it requires complete fields
   * */
  async searchTeams(req) {
    const path = this.utilsSvc.getTeamSearchUrl();
    const payload = this.utilsSvc.getSearchTeamsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchTeams');
    this.utilsSvc.setTeamIdsToTeams(response.teams);
    return response;
  }
  /** Return all the matching team without pagination */
  async getTeamsList(req) {
    const path = this.utilsSvc.getTeamListUrl();
    const payload = req ? this.utilsSvc.getSearchTeamsPayload(req) : {};
    const response = await this.post(path, payload, 'getTeamsList');
    return response;
  }
  async deleteTeam(req) {
    const path = this.utilsSvc.getTeamDeleteUrl(req.teamId, req.toTeamId);
    await this.delete(path, 'deleteTeam');
  }
  // Roles
  async getRoles(req) {
    return await this.getWithQuery(this.utilsSvc.getRoleUrl(), this.utilsSvc.sanitizePagedRequest(req), 'getRoles');
  }
  async searchRoles(req) {
    const path = this.utilsSvc.getRolesSearchUrl();
    const payload = this.utilsSvc.getSearchRolesPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const res = await this.postWithQuery(path, payload, queryParams, 'searchRoles');
    return res;
  }
  async getRole(id) {
    const path = this.utilsSvc.getRoleUrl(id);
    return await this.get(path, 'getRole');
  }
  async getRoleTeams(req) {
    const path = this.utilsSvc.getRoleTeamsUrl(req.roleId);
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getRoleTeams');
    this.utilsSvc.setTeamIdsToTeams(response.teams);
    return response;
  }
  async updateRole(role) {
    const path = this.utilsSvc.getRoleUrl(+role.id);
    const roleToUpdate = this.utilsSvc.sanitizeRole(role);
    return await this.patch(path, roleToUpdate, 'updateRole');
  }
  async createRole(role) {
    const roleToCreate = this.utilsSvc.sanitizeRole(role);
    return await this.post(this.utilsSvc.getRoleUrl(), roleToCreate, 'createRole');
  }
  async deleteRole(id) {
    await this.delete(this.utilsSvc.getRoleUrl(id), 'deleteRole');
  }
  // Scopes
  async getScopes(req) {
    return await this.getWithQuery(this.utilsSvc.getScopeUrl(), this.utilsSvc.sanitizePagedRequest(req), 'getScopes');
  }
  // Customer
  async getCustomerSeats() {
    const path = this.utilsSvc.getCustomerSeatsGetUrl();
    const res = await this.get(path, 'getCustomerSeats');
    return res;
  }
  async addCustomerSeats(seats) {
    const path = this.utilsSvc.getCustomerSeatsAddUrl();
    const payload = {
      seats: seats
    };
    const res = await this.post(path, payload, 'addCustomerSeats');
    return res;
  }
  async getCustomer() {
    return await this.get(this.utilsSvc.getCustomerUrl(), 'getCustomer');
  }
  async updateCustomer(customer) {
    const customerToUpdate = this.utilsSvc.sanitizeCustomer(customer);
    return await this.put(this.utilsSvc.getCustomerUrl(), customerToUpdate, 'updateCustomer');
  }
  // User
  async getUsers(req) {
    return await this.getWithQuery(this.utilsSvc.getUserUrl(), this.utilsSvc.sanitizePagedRequest(req), 'getUsers');
  }
  async getUser(id) {
    const path = this.utilsSvc.getUserUrl(id);
    return await this.get(path, 'getUser');
  }
  async createUser(user) {
    const userToCreate = this.utilsSvc.sanitizeUser(user);
    return await this.post(this.utilsSvc.getUserUrl(), userToCreate, 'createUser');
  }
  async updateUser(user) {
    const path = this.utilsSvc.getUserUrl(+user.id);
    const userToUpdate = this.utilsSvc.sanitizeUser(user);
    return await this.patch(path, userToUpdate, 'updateUser');
  }
  async updatePassword(password) {
    const path = this.utilsSvc.getUserPasswordUrl();
    await this.put(path, {
      password: password
    }, 'updatePassword');
  }
  async resetPasswordPublic(email) {
    const path = this.utilsSvc.getUserResetPasswordUrl();
    await this.post(path, {
      email
    }, 'resetPasswordPublic');
  }
  async getUserTeams(req) {
    const path = this.utilsSvc.getUserTeamsUrl(req.userId);
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getUserTeams');
    this.utilsSvc.setTeamIdsToTeams(response.teams);
    return response;
  }
  async getUserScopes(userId) {
    const path = this.utilsSvc.getUserScopesUrl(userId);
    const response = await this.get(path, 'getUserScopes');
    return response;
  }
  async getAllUserTeams(userId) {
    const getUserTeamsReq = {
      userId: userId,
      limit: 50,
      offset: 0
    };
    const teams = await this.getAllPagedItems(request => this.getUserTeams(request), x => x.teams, getUserTeamsReq);
    this.utilsSvc.setTeamIdsToTeams(teams);
    return teams;
  }
  async deleteUser(id) {
    const path = this.utilsSvc.getUserUrl(id);
    await this.delete(path, 'deleteUser');
  }
  async searchUsers(req) {
    const path = this.utilsSvc.getUserSearchUrl();
    const payload = this.utilsSvc.getSearchUsersPayload(req);
    return await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchUsers');
  }
  async exportUsers(req) {
    const path = this.utilsSvc.getUsersExportUrl();
    const payload = this.utilsSvc.getExportUsersPayload(req);
    return await this.post(path, payload, 'exportUsers');
  }
  async getAllUsers() {
    return this.getAllPagedItems(req => this.searchUsers(req), res => res.users);
  }
  async searchRecipientTypeMessages(recipientType, recipientId, req) {
    const path = this.utilsSvc.getRecipientTypeSearchMessagesUrl(recipientType, recipientId);
    const payload = this.utilsSvc.getSearchRecipientTypeMessagesPayload(req);
    return await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchRecipientTypeMessages');
  }
  async unassignTeamsFromUser(req) {
    // We will use unassignMembersFromTeam endpoint - single query for each specified team
    const promises = [];
    for (const teamId of req.teamIds) {
      promises.push(this.unassignMembersFromTeam({
        teamId: teamId,
        userIds: [req.userId]
      }));
    }
    await Promise.all(promises);
  }
  async sendResetUserPasswordLink(userId) {
    const path = this.utilsSvc.getResetUserPasswordUrl(userId);
    return await this.post(path, null, 'sendResetUserPasswordLink');
  }
  // Stages
  async getStages(req) {
    const path = this.utilsSvc.getStagesGetUrl(req.parentType, req.parentID);
    const response = this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getStages');
    return response;
  }
  async getAllStages(parentType, parentID) {
    const req = {
      parentType: parentType,
      parentID: parentID,
      limit: 50,
      offset: 0
    };
    const stages = await this.getAllPagedItems(request => this.getStages(request), response => response.stages, req);
    return stages;
  }
  async createStage(req) {
    const path = this.utilsSvc.getStageCreateUrl(req.parentType, req.parentID);
    const res = await this.post(path, req.data, 'createStage');
    return res;
  }
  async reorderStages(parentType, parentID, data) {
    const path = this.utilsSvc.getStageReorderUrl(parentType, parentID);
    return await this.put(path, data, 'reorderStages');
  }
  async getStage(stageID) {
    const path = this.utilsSvc.getStageGetUrl(stageID);
    return await this.get(path, 'getStage');
  }
  async updateStage(req) {
    const path = this.utilsSvc.getStageUpdateUrl(req.id);
    const sanitizedStage = this.utilsSvc.sanitizeStage(req);
    const updatedStage = await this.patch(path, sanitizedStage, 'updateStage');
    return updatedStage;
  }
  async deleteStage(stageID) {
    const path = this.utilsSvc.getStageDeleteUrl(stageID);
    await this.delete(path, 'deleteStage');
  }
  async setStageForms(stageID, formIDs) {
    const path = this.utilsSvc.getStageFormsUrl(stageID);
    await this.put(path, formIDs, 'setStageForms');
  }
  async setStageProcess(stageID, processID) {
    const path = this.utilsSvc.getStageProcessUrl(stageID);
    const body = processID ? processID : null;
    await this.putWithHeaders(path, JSON.stringify(body), this.headerContentTypeJson, null, 'setStageProcess');
  }
  async setStageActor(stageID, actor) {
    const path = this.utilsSvc.getStageActorUrl(stageID);
    await this.put(path, actor, 'setStageActor');
  }
  async setStageThankYouPage(req) {
    const path = this.utilsSvc.getStageThankYouPageUrl(req.id);
    await this.put(path, {
      page_id: req.pageId
    }, 'setStageThankYouPage');
  }
  async setStageCancellationForm(req) {
    const path = this.utilsSvc.getStageCancellationFormUrl(req.id);
    await this.put(path, {
      page_id: req.pageId
    }, 'setStageCancellationForm');
  }
  async getEventsCounters(eventIds) {
    const path = this.utilsSvc.getEventsCountersGetUrl();
    const payload = {
      event_ids: eventIds
    };
    const response = await this.post(path, payload, 'getEventsCounters');
    return response;
  }
  // TODO: Deprecated in favor of getParticipantProcesses and getLocalEventProcesses
  async getProcesses(req) {
    const path = this.utilsSvc.getProcessesGetUrl(req.parentType, req.parentID);
    const response = this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getProcesses');
    return response;
  }
  async getEventBookingProcesses(eventId, req) {
    const path = this.utilsSvc.getEventBookingProcessesGetUrl(eventId);
    const response = this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getEventBookingProcesses');
    return response;
  }
  async createEventBookingProcess(eventId, process) {
    const path = this.utilsSvc.getEventBookingProcessCreateUrl(eventId);
    const response = this.post(path, process, 'createEventBookingProcess');
    return response;
  }
  async getEventParticipantProcesses(eventId, req) {
    const path = this.utilsSvc.getEventParticipantProcessesGetUrl(eventId);
    const response = this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getParticipantProcesses');
    return response;
  }
  async searchEventParticipantProcesses(eventId, req) {
    const path = this.utilsSvc.getSearchEventParticipantProcessesUrl(eventId);
    const payload = this.utilsSvc.getSearchEventParticipantProcessesPayload(req);
    const response = this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventParticipantProcesses');
    return response;
  }
  async createEventParticipantProcess(eventId, process) {
    const path = this.utilsSvc.getEventParticipantProcessCreateUrl(eventId);
    const response = this.post(path, process, 'createEventParticipantProcess');
    return response;
  }
  async getLocalEventProcesses(eventId, req) {
    const path = this.utilsSvc.getLocalEventProcessesGetUrl(eventId);
    const response = this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getLocalEventProcesses');
    return response;
  }
  async createLocalEventProcess(eventId, process) {
    const path = this.utilsSvc.getLocalEventProcessCreateUrl(eventId);
    const response = this.post(path, process, 'createLocalEventProcess');
    return response;
  }
  async getGlobalProcesses(req) {
    const path = this.utilsSvc.getGlobalProcessesGetUrl(req.globalType);
    const response = this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getGlobalProcesses');
    return response;
  }
  async getAllProcesses(parentType, parentID) {
    const req = {
      parentType: parentType,
      parentID: parentID,
      limit: 50,
      offset: 0
    };
    const processes = await this.getAllPagedItems(request => this.getProcesses(request), response => response.processes, req);
    return processes;
  }
  async createProcess(req) {
    const path = this.utilsSvc.getProcessCreateUrl(req.parentType, req.parentID);
    const res = await this.post(path, req.data, 'createProcess');
    return res;
  }
  async createGlobalProcess(req) {
    const path = this.utilsSvc.getGlobalProcessCreateUrl(req.globalType);
    const res = await this.post(path, req.data, 'createGlobalProcess');
    return res;
  }
  async getProcess(processID) {
    const path = this.utilsSvc.getProcessGetUrl(processID);
    return await this.get(path, 'getProcess');
  }
  async updateProcess(req) {
    const path = this.utilsSvc.getProcessUpdateUrl(req.id);
    const sanitizedProcess = this.utilsSvc.sanitizeProcess(req);
    const updatedProcess = await this.patch(path, sanitizedProcess, 'updateProcess');
    return updatedProcess;
  }
  async deleteProcess(processID) {
    const path = this.utilsSvc.getProcessDeleteUrl(processID);
    await this.delete(path, 'deleteProcess');
  }
  async setProcessSteps(processID, steps) {
    const path = this.utilsSvc.getProcessStepsUrl(processID);
    await this.put(path, steps, 'setProcessSteps');
  }
  async setProcessTrigger(processID, trigger) {
    const path = this.utilsSvc.getProcessTriggerUrl(processID);
    await this.put(path, trigger, 'setProcessTrigger');
  }
  async interruptProcess(processID) {
    const path = this.utilsSvc.getProcessInterruptUrl(processID);
    await this.post(path, null, 'interruptProcess');
  }
  async pauseProcess(processID) {
    const path = this.utilsSvc.getProcessPauseUrl(processID);
    await this.post(path, null, 'pauseProcess');
  }
  async resumeProcess(processID, req) {
    const path = this.utilsSvc.getProcessResumeUrl(processID);
    await this.post(path, req, 'resumeProcess');
  }
  // Event workflows
  /**
   * @param arrived the participant's arrival status will be updated according to `arrived` value
   */
  async scanEventParticipantQRCode(eventId, qrCode, arrived) {
    const path = this.utilsSvc.getEventWorkflowQRCodeScanUrl(eventId);
    const payload = {
      qrcode: qrCode,
      arrival: arrived
    };
    const res = await this.post(path, payload, 'scanEventParticipantQRCode');
    return res;
  }
  async getEventWorkflowScanStages(eventId) {
    const path = this.utilsSvc.getEventWorkflowScanStagesUrl(eventId);
    const res = await this.get(path, 'getEventWorkflowScanStages');
    return res;
  }
  async getEventWaitingListWidgetData(eventId, sessionsFreeIn, workflowId) {
    const path = this.utilsSvc.getEventWaitingListWidgetDataUrl(eventId);
    const payload = {
      workflow_id: workflowId,
      sessions_free_in: sessionsFreeIn
    };
    const res = await this.post(path, payload, 'getEventWaitingListWidgetData');
    return res;
  }
  async reorderWorkflows(parentType, parentID, data) {
    const path = this.utilsSvc.getEventWorkflowReorderUrl(parentType, parentID);
    return await this.put(path, data, 'reorderWorkflows');
  }
  async getAllEventWorkflows(parentType, parentID) {
    const path = this.utilsSvc.getEventWorkflowGetAllUrl(parentType, parentID);
    const response = await this.get(path, 'getAllEventWorkflows');
    return response;
  }
  async createEventWorkflow(workflow, parentType, parentID) {
    const path = this.utilsSvc.getEventWorkflowCreateUrl(parentType, parentID);
    const sanitized = this.utilsSvc.sanitizeEventWorkflowForCreate(workflow);
    const response = await this.post(path, sanitized, 'createEventWorkflow');
    return response;
  }
  async getEventWorkflow(workflowId) {
    const path = this.utilsSvc.getEventWorkflowGetUrl(workflowId);
    const response = await this.get(path, 'getEventWorkflow');
    return response;
  }
  async deleteEventWorkflow(workflowId) {
    const path = this.utilsSvc.getEventWorkflowDeleteUrl(workflowId);
    const response = await this.delete(path, 'deleteEventWorkflow');
    return response;
  }
  async updateEventWorkflow(workflow) {
    const path = this.utilsSvc.getEventWorkflowUpdateUrl(workflow.id);
    const sanitized = this.utilsSvc.sanitizeEventWorkflowForUpdate(workflow);
    const response = await this.patch(path, sanitized, 'updateEventWorkflow');
    return response;
  }
  /**
   *
   * @returns DraftResult [`azavista-workflow-builder-shared\src\builder\index.ts`]
   */
  async publishEventWorkflowBuilder(eventId) {
    const path = this.utilsSvc.getEventWorkflowBuilderPublishUrl(eventId);
    const res = await this.post(path, {}, 'publishEventWorkflowBuilder');
    return res;
  }
  /**
   *
   * @returns DraftResult [`azavista-workflow-builder-shared\src\builder\index.ts`]
   */
  async revertPublishedEventWorkflowBuilder(eventId) {
    const path = this.utilsSvc.getEventWorkflowBuilderRevertPublishedUrl(eventId);
    const res = await this.post(path, {}, 'revertPublishedEventWorkflowBuilder');
    return res;
  }
  // URLs
  async getIngresses(pagedRequest) {
    const path = this.utilsSvc.getIngressesGetUrl();
    const queryParams = this.utilsSvc.sanitizePagedRequest(pagedRequest);
    const res = await this.getWithQuery(path, queryParams, 'getIngresses');
    return res;
  }
  async getAllIngresses() {
    return await this.getAllPagedItems(req => this.getIngresses(req), res => res.ingresses);
  }
  async getEventMarketingUrl(eventMarketingUrlId) {
    const path = this.utilsSvc.getEventMarketingUrlGetUrl(eventMarketingUrlId);
    const res = await this.get(path, 'eventMarketingUrlId');
    return res;
  }
  async createEventMarketingUrl(eventId, eventMarketingUrl) {
    const path = this.utilsSvc.getEventMarketingUrlCreateUrl(eventId);
    const sanitized = this.utilsSvc.sanitizeEventMarketingUrlForCreate(eventMarketingUrl);
    const res = await this.post(path, sanitized, 'createEventMarketingUrl');
    return res;
  }
  async updateEventMarketingUrl(eventMarketingUrl) {
    const path = this.utilsSvc.getEventMarketingUrlUpdateUrl(eventMarketingUrl.id);
    const sanitized = this.utilsSvc.sanitizeEventMarketingUrlForUpdate(eventMarketingUrl);
    const res = await this.patch(path, sanitized, 'updateEventMarketingUrl');
    return res;
  }
  async deleteEventMarketingUrl(eventMarketingUrlId) {
    const path = this.utilsSvc.getEventMarketingUrlDeleteUrl(eventMarketingUrlId);
    await this.delete(path, 'deleteEventMarketingUrl');
  }
  async searchEventMarketingUrls(eventId, req) {
    const url = this.utilsSvc.getEventMarketingUrlSearchUrl(eventId);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const payload = this.utilsSvc.getSearchEventMarketingUrlsPayload(req);
    const res = await this.postWithQuery(url, payload, queryParams, 'searchEventMarketingUrls');
    return res;
  }
  // Marketing url
  async getAllMarketingUrls(entityType, entityId) {
    const path = this.utilsSvc.getMarketingUrlGetAllUrl(entityType, entityId);
    const response = await this.get(path, 'getAllMarketingUrls');
    return response;
  }
  async createMarketingUrl(req, entityType, entityId) {
    const path = this.utilsSvc.getMarketingUrlCreateUrl(entityType, entityId);
    const response = await this.post(path, req, 'createMarketingUrl');
    return response;
  }
  async updateMarketingUrl(req, marketingUrlId) {
    const path = this.utilsSvc.getMarketingUrlUpdateUrl(marketingUrlId);
    const response = await this.patch(path, req, 'updateMarketingUrl');
    return response;
  }
  async deleteMarketingUrl(marketingUrlId) {
    const path = this.utilsSvc.getMarketingUrlDeleteUrl(marketingUrlId);
    const response = await this.delete(path, 'deleteMarketingUrl');
    return response;
  }
  // Event payments - payment provider
  async getEventPaymentProvider(eventId) {
    const path = this.utilsSvc.getEventPaymentProviderGetUrl(eventId);
    const response = await this.get(path, 'getEventPaymentProvider');
    return response;
  }
  async updateEventPaymentProvider(req, eventId) {
    const path = this.utilsSvc.getEventPaymentProviderUpdateUrl(eventId);
    const response = await this.put(path, req, 'updateEventPaymentProvider');
    return response;
  }
  // Payments - Taxes
  async createTax(req) {
    const path = this.utilsSvc.getTaxCreateUrl();
    const response = await this.post(path, req, 'createTax');
    return response;
  }
  async deleteTax(taxId) {
    const path = this.utilsSvc.getTaxDeleteUrl(taxId);
    const response = await this.delete(path, 'deleteTax');
    return response;
  }
  async getAllTaxes() {
    const path = this.utilsSvc.getTaxesGetAllUrl();
    const response = await this.get(path, 'getAllTaxes');
    return response;
  }
  async getTax(taxId) {
    const path = this.utilsSvc.getTaxGetUrl(taxId);
    const response = await this.get(path, 'getTax');
    return response;
  }
  async updateTax(req, taxId) {
    const path = this.utilsSvc.getTaxUpdateUrl(taxId);
    const response = await this.patch(path, req, 'updateTax');
    return response;
  }
  async searchTaxes(req) {
    const path = this.utilsSvc.getTaxesSearchUrl();
    const payload = this.utilsSvc.getSearchTaxesPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchTaxes');
    return response;
  }
  // Payments - Cancellation terms
  async createCancellationTerm(req) {
    const path = this.utilsSvc.getCancellationTermCreateUrl();
    const response = await this.post(path, req, 'createCancellationTerm');
    return response;
  }
  async deleteCancellationTerm(cancellationTermId) {
    const path = this.utilsSvc.getCancellationTermDeleteUrl(cancellationTermId);
    const response = await this.delete(path, 'deleteCancellationTerm');
    return response;
  }
  async getAllCancellationTerms() {
    const path = this.utilsSvc.getCancellationTermsGetAllUrl();
    const response = await this.get(path, 'getAllCancellationTerms');
    return response;
  }
  async getCancellationTerm(cancellationTermId) {
    const path = this.utilsSvc.getCancellationTermGetUrl(cancellationTermId);
    const response = await this.get(path, 'getCancellationTerm');
    return response;
  }
  async updateCancellationTerm(req, cancellationTermId) {
    const path = this.utilsSvc.getCancellationTermUpdateUrl(cancellationTermId);
    const response = await this.patch(path, req, 'updateCancellationTerm');
    return response;
  }
  async searchCancellationTerms(req) {
    const path = this.utilsSvc.getCancellationTermsSearchUrl();
    const payload = this.utilsSvc.getSearchCancellationTermsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchCancellationTerms');
    return response;
  }
  // Payments - Product group relations
  async getProductsForEntity(entityType, entityId, req) {
    const path = this.utilsSvc.getGetProductsForEntityUrl(entityType, entityId);
    const response = await this.getPaged(path, req, 'getProductsForEntityUrl');
    return response;
  }
  async getAllProductsForEntity(entityType, entityId) {
    const result = await this.getAllPagedItems(request => this.getProductsForEntity(entityType, entityId, request), response => response.products);
    return result;
  }
  async getEntityProductGroups(entityType, entityId, req) {
    const path = this.utilsSvc.getProductGroupsByEntityGetUrl(entityType, entityId);
    const response = await this.getPaged(path, req, 'getEntityProductGroups');
    return response;
  }
  async getEntityProductGroupSettings(groupdId, entityType, entityId) {
    const path = this.utilsSvc.getProductGroupSettingsByEntityGetUrl(groupdId, entityType, entityId);
    const response = await this.get(path, 'getEntityProductGroupSettings');
    return response;
  }
  async saveEntityProductGroupSettings(groupId, entityType, entityId, productGroupSettings) {
    const path = this.utilsSvc.getProductGroupSettingsByEntitySaveUrl(groupId, entityType, entityId);
    const response = this.put(path, productGroupSettings, 'updateEntityProductGroupSettings');
    return response;
  }
  async searchProductGroupRelations(req) {
    const path = this.utilsSvc.getProductGroupRelationsSearchUr(req.groupId, req.entityType);
    const response = await this.postWithQuery(path, {}, this.utilsSvc.sanitizePagedRequest(req), 'searchProductGroupRelations');
    return response;
  }
  async setProductGroupRelations(req, groupId) {
    const path = this.utilsSvc.getProductGroupRelationsSetProductsUrl(groupId);
    const response = await this.post(path, req, 'setProductGroupRelations');
    return response;
  }
  async removeProductGroupRelations(req, groupId) {
    const path = this.utilsSvc.getProductGroupRelationsRemoveProductsUrl(groupId);
    const response = await this.post(path, req, 'removeProductGroupRelations');
    return response;
  }
  async setProductGroupRelationsEntityTypes(req, groupId, entityType) {
    const path = this.utilsSvc.getProductGroupRelationsSetEntitiesUrl(groupId, entityType);
    const response = await this.post(path, req, 'setProductGroupRelationsEntityTypes');
    return response;
  }
  async removeProductGroupRelationsEntityTypes(req, groupId, entityType) {
    const path = this.utilsSvc.getProductGroupRelationsRemoveEntitiesUrl(groupId, entityType);
    const response = await this.post(path, req, 'removeProductGroupRelationsEntityTypes');
    return response;
  }
  // Payments - Products
  async createProduct(product) {
    const path = this.utilsSvc.getProductCreateUrl();
    const sanitized = this.utilsSvc.sanitizeProduct(product);
    const response = await this.post(path, sanitized, 'createProduct');
    return response;
  }
  async deleteProduct(productId) {
    const path = this.utilsSvc.getProductDeleteUrl(productId);
    const response = await this.delete(path, 'deleteProduct');
    return response;
  }
  async getAllProducts() {
    const path = this.utilsSvc.getProductsGetAllUrl();
    const response = await this.get(path, 'getAllProducts');
    return response;
  }
  async getProduct(productId) {
    const path = this.utilsSvc.getProductGetUrl(productId);
    const response = await this.get(path, 'getProduct');
    return response;
  }
  async updateProduct(product) {
    const path = this.utilsSvc.getProductUpdateUrl(product.id);
    const sanitized = this.utilsSvc.sanitizeProduct(product);
    const response = await this.patch(path, sanitized, 'updateProduct');
    return response;
  }
  async searchProducts(req) {
    const path = this.utilsSvc.getProductsSearchUrl();
    const payload = this.utilsSvc.getSearchProductsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchProducts');
    return response;
  }
  // Payments - product groups
  async createProductGroup(req) {
    const path = this.utilsSvc.getProductGroupCreateUrl();
    const response = await this.post(path, req, 'createProductGroup');
    return response;
  }
  async deleteProductGroup(groupId) {
    const path = this.utilsSvc.getProductGroupDeleteUrl(groupId);
    const response = await this.delete(path, 'deleteProductGroup');
    return response;
  }
  async getAllProductGroups() {
    const path = this.utilsSvc.getProductGroupsGetAllUrl();
    const response = await this.get(path, 'getAllProductGroups');
    return response;
  }
  async getProductGroup(groupId) {
    const path = this.utilsSvc.getProductGroupGetUrl(groupId);
    const response = await this.get(path, 'getProductGroup');
    return response;
  }
  async updateProductGroup(req, groupId) {
    const path = this.utilsSvc.getProductGroupUpdateUrl(groupId);
    const response = await this.patch(path, req, 'updateProductGroup');
    return response;
  }
  async searchProductGroups(req) {
    const path = this.utilsSvc.getProductGroupsSearchUrl();
    const payload = this.utilsSvc.getSearchProductGroupsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchProductGroups');
    return response;
  }
  // Integrations
  async createIntegration(req) {
    const path = this.utilsSvc.getIntegrationCreateUrl();
    const response = await this.post(path, req, 'createIntegration');
    return response;
  }
  async deleteIntegration(integrationId) {
    const path = this.utilsSvc.getIntegrationDeleteUrl(integrationId);
    const response = await this.delete(path, 'deleteIntegration');
    return response;
  }
  async getAllIntegrations() {
    const path = this.utilsSvc.getIntegrationsGetAllUrl();
    const response = await this.get(path, 'getAllIntegrations');
    return response;
  }
  async getIntegration(integrationId) {
    const path = this.utilsSvc.getIntegrationGetUrl(integrationId);
    const response = await this.get(path, 'getIntegration');
    return response;
  }
  async updateIntegration(req, integrationId) {
    const path = this.utilsSvc.getIntegrationUpdateUrl(integrationId);
    const response = await this.patch(path, req, 'updateIntegration');
    return response;
  }
  async searchIntegrations(req) {
    const path = this.utilsSvc.getIntegrationsSearchUrl();
    const payload = this.utilsSvc.getSearchIntegrationsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchIntegrations');
    return response;
  }
  async getIntegrationsList(req, /** @default true */
  isActiveIntegration = true) {
    const path = this.utilsSvc.getIntegrationsListUrl();
    req.advancedQuery = {
      ...(req.advancedQuery || {}),
      status: isActiveIntegration ? 'active' : 'inactive '
    };
    const payload = this.utilsSvc.getSearchIntegrationsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'getIntegrationsList');
    return response;
  }
  async updateIntegrationSettings(req, integrationId) {
    const path = this.utilsSvc.getIntegrationsPutSettingsUrl(integrationId);
    if (req.settings) {
      delete req.settings.use_azavista_mapping;
    }
    const response = await this.put(path, req, 'putIntegrationSettings');
    return response;
  }
  async getIntegrationSettings(integrationId) {
    const path = this.utilsSvc.getIntegrationsGetSettingsUrl(integrationId);
    const response = await this.get(path, 'getIntegrationSettings');
    return response;
  }
  async getIntegrationWebhookLogs(integrationId, pagedReq) {
    const path = this.utilsSvc.getIntegrationWebhookLogsUrl(integrationId);
    const response = await this.getPaged(path, pagedReq, 'getIntegrationWebhookLogs');
    return response;
  }
  async getIntegrationWebhookLogEventCallRequests(callId, pagedReq) {
    const path = this.utilsSvc.getIntegrationWebhookLogEventCallRequestUrl(callId);
    const response = await this.getPaged(path, pagedReq, 'getIntegrationWebhookLogEventCallRequests');
    return response;
  }
  async getIntegrationLog(integrationId, logId) {
    const path = this.utilsSvc.getIntegrationLogGetUrl(integrationId, logId);
    const response = await this.get(path, 'getIntegrationLog');
    return response;
  }
  async searchExternalCRMIntegrationLogs(integrationId, req) {
    const path = this.utilsSvc.getExternalCRMIntegrationLogsSearchUrl(integrationId);
    const payload = this.utilsSvc.getSearchExternalCRMIntegrationLogsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchExternalCRMIntegrationLogs');
    return response;
  }
  async clearExternalCRMIntegrationLogs(integrationId) {
    const path = this.utilsSvc.getExternalCRMIntegrationLogsClearUrl(integrationId);
    const response = await this.post(path, undefined, 'clearExternalCRMIntegrationLogs');
    return response;
  }
  async searchAccountingIntegrationLogs(integrationId, req) {
    const path = this.utilsSvc.getAccountingIntegrationLogsSearchUrl(integrationId);
    const payload = this.utilsSvc.getSearchAccountingIntegrationLogsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchAccountingIntegrationLogs');
    return response;
  }
  async resendAccountingIntegrationOrder(integrationId, orderId) {
    const path = this.utilsSvc.getAccountingIntegrationResendOrderUrl(integrationId, orderId);
    await this.post(path, null, 'resendAccountingIntegrationOrder');
  }
  async deleteExternalCrmObjectMapping(integrationId, objectMappingId) {
    const path = this.utilsSvc.getExternalCrmObjectMappingDeleteUrl(integrationId, objectMappingId);
    await this.delete(path, 'deleteExternalCrmObjectMapping');
  }
  async searchExternalCrmObjectMapping(integrationId, req) {
    const path = this.utilsSvc.getExternalCrmObjectMappingSearchUrl(integrationId);
    const payload = this.utilsSvc.getExternalCrmObjectMappingSearchPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchExternalCrmObjectMapping');
    return response;
  }
  async addTeamsToIntegration(integrationId, teamIds) {
    const path = this.utilsSvc.getAddTeamsToIntegrationUrl(integrationId);
    const payload = {
      ids: teamIds
    };
    await this.post(path, payload, 'addTeamsToIntegration');
  }
  async removeTeamsFromIntegration(integrationId, teamIds) {
    const path = this.utilsSvc.getRemoveTeamsFromIntegrationUrl(integrationId);
    const payload = {
      ids: teamIds
    };
    await this.post(path, payload, 'removeTeamsFromIntegration');
  }
  async searchMessagingGatewayIntegrationLogs(integrationId, req) {
    const path = this.utilsSvc.getMessagingGatewayIntegrationLogsSearchUrl(integrationId);
    const payload = this.utilsSvc.getSearchMessagingGatewayIntegrationLogsPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const response = await this.postWithQuery(path, payload, queryParams, 'searchMessagingGatewayIntegrationLogs');
    return response;
  }
  // Activities
  async getEventActivitySettings(activityId) {
    const path = this.utilsSvc.getEventActivitySettingsGetUrl(activityId);
    const response = await this.get(path, 'getEventActivitySettings');
    return response;
  }
  async updateEventActivitySettings(activityId, eventActivitySettings) {
    const path = this.utilsSvc.getEventActivitySettingsUpdateUrl(activityId);
    const response = await this.put(path, eventActivitySettings, 'updateEventActivitySettings');
    return response;
  }
  async getEventActivityGlobalSettings(eventId) {
    const path = this.utilsSvc.getEventActivityGlobalSettingsGetUrl(eventId);
    const response = await this.get(path, 'getEventActivityGlobalSettings');
    return response;
  }
  async updateEventActivityGlobalSettings(eventId, eventActivityGlobalSettings) {
    const path = this.utilsSvc.getEventActivityGlobalSettingsUpdateUrl(eventId);
    const payload = {
      settings: eventActivityGlobalSettings
    };
    await this.put(path, payload, 'updateEventActivityGlobalSettings');
  }
  async activityCheckin(activityId, req) {
    const path = this.utilsSvc.getEventActivityCheckinUrl(activityId);
    const response = await this.put(path, req, 'activityCheckin');
    return response;
  }
  async exportEventActivitiesParticipants(eventId, req) {
    const path = this.utilsSvc.getEventActivitiesParticipantsExportUrl(eventId);
    const payload = this.utilsSvc.getExportEventActivitiesParticipantsPayload(req);
    return await this.post(path, payload, 'exportEventActivitiesParticipants');
  }
  async exportEventActivityParticipants(activityId, req) {
    const path = this.utilsSvc.getEventActivityParticipantsExportUrl(activityId);
    const payload = this.utilsSvc.getExportEventActivityParticipantsPayload(req);
    return await this.post(path, payload, 'exportEventActivityParticipants');
  }
  async exportEventActivities(eventId, req) {
    const path = this.utilsSvc.getEventActivitiesExportUrl(eventId);
    const payload = this.utilsSvc.getExportEventActivitiesPayload(req.activity_filter);
    return await this.post(path, payload, 'exportEventActivities');
  }
  async createEventActivity(req) {
    const path = this.utilsSvc.getEventActivityCreateUrl(req.eventId);
    const sanitizedActivity = this.utilsSvc.sanitizeEventActivity(req.eventActivity);
    const response = await this.post(path, sanitizedActivity, 'createEventActivity');
    return response;
  }
  async deleteEventActivity(activityId) {
    const path = this.utilsSvc.getEventActivityDeleteUrl(activityId);
    await this.delete(path, 'deleteEventActivity');
  }
  async bulkDeleteEventActivities(eventId, req) {
    const path = this.utilsSvc.getEventActvitiesBulkDeleteUrl(eventId);
    const payload = this.utilsSvc.getBulkEventActivitiesArchivePayload(req.activity_filter);
    return await this.post(path, payload, 'bulkDeleteEventActivities');
  }
  async updateEventActivity(activity) {
    const path = this.utilsSvc.getEventActivityUpdateUrl(activity.id);
    const sanitizedActivity = this.utilsSvc.sanitizeEventActivity(activity);
    const updatedEventActivity = this.patch(path, sanitizedActivity, 'updateEventActivity');
    return updatedEventActivity;
  }
  async bulkUpdateEventActivities(req, update) {
    const path = this.utilsSvc.getEventActivitiesBulkUpdateUrl(req.eventId);
    const payload = this.utilsSvc.getBulkEventActivitiesUpdatePayload(req, update);
    return await this.post(path, payload, 'bulkUpdateEventActivities');
  }
  async getEventActivity(activityId) {
    const path = this.utilsSvc.getEventActivityGetUrl(activityId);
    const eventActivity = await this.get(path, 'getEventActivity');
    return eventActivity;
  }
  async searchEventActivities(req) {
    const path = this.utilsSvc.getEventActivitiesSearchUrl(req.eventId);
    const payload = this.utilsSvc.getSearchEventActivitiesPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchEventActivities');
    return response;
  }
  async getAllEventActivities(eventId) {
    const req = {
      eventId: eventId,
      limit: 50,
      offset: 0
    };
    const allActivities = await this.getAllPagedItems(request => this.searchEventActivities(request), response => response.activities, req);
    return allActivities;
  }
  // Activity - Speakers
  async createEventActivitySpeakers(req, activityId) {
    const path = this.utilsSvc.getEventActivitySpeakersCreateUrl(activityId);
    await this.post(path, req, 'createEventActivitySpeaker');
  }
  async getEventActivitySpeakers(activityId) {
    const path = this.utilsSvc.getEventActivitySpeakersGetUrl(activityId);
    const eventActivitySpeakers = await this.get(path, 'getEventActivitySpeakers');
    return eventActivitySpeakers;
  }
  async deleteEventActivitySpeakers(req, activityId) {
    const path = this.utilsSvc.getEventActivitySpeakersDeleteUrl(activityId);
    await this.post(path, req, 'removeEventActivitySpeakers');
  }
  // Activities - Mderators
  async createEventActivityModerators(req, activityId) {
    const path = this.utilsSvc.getEventActivityModeratorsCreateUrl(activityId);
    await this.post(path, req, 'createEventActivityModerator');
  }
  async getEventActivityModerators(activityId) {
    const path = this.utilsSvc.getEventActivityModeratorsGetUrl(activityId);
    const eventActivityModerators = await this.get(path, 'getEventActivityModerators');
    return eventActivityModerators;
  }
  async getEventOnsiteSettings(eventId) {
    const path = this.utilsSvc.getEventOnsiteSettingsGetUrl(eventId);
    const response = await this.get(path, 'getEventOnsiteSettings');
    return response;
  }
  async updateEventOnsiteSettings(eventId, payload) {
    const path = this.utilsSvc.getEventOnsiteSettingsUpdateUrl(eventId);
    await this.put(path, payload, 'updateEventOnsiteSettings');
  }
  async createEventProduct(eventId, product) {
    const path = this.utilsSvc.getEventProductCreateUrl(eventId);
    const response = await this.post(path, this.utilsSvc.sanitizeProduct(product), 'createEventProducts');
    return response;
  }
  async searchEventProducts(eventId, req) {
    const path = this.utilsSvc.getEventProductSearchUrl(eventId);
    const payload = this.utilsSvc.getEventProductSearchPayload(req);
    const response = await this.post(path, payload, 'searchEventProducts');
    return response;
  }
  async deleteEventActivityModerators(req, activityId) {
    const path = this.utilsSvc.getEventActivityModeratorsDeleteUrl(activityId);
    await this.post(path, req, 'removeEventActivityModerators');
  }
  // Activity - registered participants
  async getActivityRegisteredParticipants(activityId) {
    const path = this.utilsSvc.getEventActivityRegisteredParticipantsGetUrl(activityId);
    const response = await this.get(path, 'getActivityRegisteredParticipants');
    return response;
  }
  async addEventParticipantsToActivitiesInBulk(req, activityIds, eventId) {
    const path = this.utilsSvc.getEventActivitiesParticipantsBulkAddUrl(eventId);
    const payload = this.utilsSvc.getAddEventParticipantsToActivitiesInBulkPayload(req, activityIds);
    const response = await this.post(path, payload, 'addEventParticipantsToActivitiesInBulk');
    return response;
  }
  async removeEventParticipantsFromActivityInBulk(req, activityId) {
    const path = this.utilsSvc.getEventActivityRegisteredParticipantsRemoveUrl(activityId);
    const payload = this.utilsSvc.getSearchEventActivityRegisteredParticipantsPayload(req);
    const response = await this.post(path, payload, 'removeEventParticipantsFromActivityInBulk');
    return response;
  }
  // async eventActivitySendMessage(
  //     req: IAdvancedSearchRequest,
  //     activityId: string,
  // ): Promise<IJobId> {
  //     const path = this.utilsSvc.getEventActivitySendMessageUrl(activityId);
  //     const payload = this.utilsSvc.getEventActivitySendMessagePayload();
  //     const res = await this.post<IJobId>(path, payload, 'eventActivitySendMessage');
  //     return res;
  // }
  // async sendActivityParticipantsMessage(
  //     activityId: string,
  //     integrationId: string,
  //     participantNumberFieldId: string,
  //     message: string,
  //     req: IAdvancedSearchRequest,
  //     subject?: string,
  //     event_app_component?: ISendParticipantMessageEventAppComponent,
  // ): Promise<IJobId> {
  //     const path = this.utilsSvc.getEventActivityRegisteredParticipantsSendMessageUrl(activityId);
  //     const searchEventParticipantsReq: ISearchactivityparticipants = {
  //         ...req,
  //     };
  //     const payload: ISendParticipantsMessagePayload = {
  //         integration_id: integrationId,
  //         participant_number_field_id: participantNumberFieldId,
  //         subject: subject,
  //         message: message,
  //         event_app_component: event_app_component,
  //         participant_filter: {
  //             ...this.utilsSvc.getSearchEventParticipantsPayload(
  //                 searchEventParticipantsReq
  //             ).participant_filter,
  //         },
  //     };
  //     const res = await this.post<IJobId>(
  //         path,
  //         payload,
  //         'sendParticipantsMessage'
  //     );
  //     return res;
  // }
  async sendActivityParticipantsMessage(activityId, integrationId, participantNumberFieldId, message, req, subject, eventAppComponent) {
    const path = this.utilsSvc.getEventActivityRegisteredParticipantsSendMessageUrl(activityId);
    const searchActivityParticipantsPayload = this.utilsSvc.getSearchEventActivityRegisteredParticipantsPayload(req);
    const payload = {
      activity_participant_filter: searchActivityParticipantsPayload.participant_filter,
      integration_id: integrationId,
      message: message,
      participant_number_field_id: participantNumberFieldId,
      event_app_component: eventAppComponent,
      subject: subject
    };
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'sendActivityParticipantsMessage');
    return response;
  }
  async searchActivityRegisteredParticipants(req, activityId) {
    const path = this.utilsSvc.getEventActivityRegisteredParticipantsSearchUrl(activityId);
    const payload = this.utilsSvc.getSearchEventActivityRegisteredParticipantsPayload(req);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'searchActivityRegisteredParticipants');
    return response;
  }
  async updateEventActivityRegisteredActivityParticipant(req, payload) {
    const path = this.utilsSvc.getEventActivityRegisteredParticipantsUpdateActivityParticipantUrl(req);
    const response = await this.patch(path, payload, 'updateEventActivityRegisteredActivityParticipant');
    return response;
  }
  async bulkUpdateEventActivityRegisteredParticipantsStatus(req, activityId, status) {
    const path = this.utilsSvc.getEventActivityRegisteredParticipantsBulkUpdateStatusUrl(activityId);
    const payload = this.utilsSvc.getBulkUpdateEventActivityRegisteredParticipantsStatusPayload(req, status);
    const response = await this.postWithQuery(path, payload, this.utilsSvc.sanitizePagedRequest(req), 'bulkUpdateEventActivityRegisteredParticipantsStatus');
    return response;
  }
  // Assets
  // Copy cluster
  async getCopyClusters(req) {
    const path = this.utilsSvc.getCopyClustersGetUrl();
    const copyClustersResponse = await this.getWithQuery(path, {
      type: req.type
    }, 'getCopyClusters');
    return copyClustersResponse;
  }
  async getCopyClusterEventItems(req) {
    const path = this.utilsSvc.getCopyClusterEventItemsGetUrl(req.copyClusterId);
    const copyClusterEventItemsResponse = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(req), 'getCopyClusterEventItems');
    return copyClusterEventItemsResponse;
  }
  async createCopyClusterEventItem(req, copyClusterId) {
    const path = this.utilsSvc.getCopyClusterEventItemCreateUrl(copyClusterId);
    const copyClusterCreateEventItemresponse = await this.post(path, req, 'createCopyClusterEventItem');
    return copyClusterCreateEventItemresponse;
  }
  async getCopyClusterThemeItems(req) {
    const path = this.utilsSvc.getCopyClusterThemeItemsGetUrl(req.copyClusterId);
    const copyClusterThemeItemsResponse = await this.getWithQuery(path, {
      type: req.type
    }, 'getCopyClusterThemeItems');
    return copyClusterThemeItemsResponse;
  }
  async createCopyClusterThemeItem(req, copyClusterId) {
    const path = this.utilsSvc.getCopyClusterThemeItemCreateUrl(copyClusterId);
    const copyClusterCreateThemeItemresponse = await this.post(path, req, 'createCopyClusterThemeItem');
    return copyClusterCreateThemeItemresponse;
  }
  // Common
  async getAllPagedItems(loadFunc, responseArrayKeySelector, requestForTheLoadFunc) {
    const result = [];
    const request = requestForTheLoadFunc || {
      limit: 50,
      offset: 0
    };
    let itemsCount = 0;
    let hasMoreItems;
    do {
      const response = await loadFunc(request);
      const responseArray = responseArrayKeySelector(response);
      itemsCount = responseArray ? responseArray.length : 0;
      if (itemsCount > 0) {
        result.push(...responseArray);
        request.offset += itemsCount;
      }
      hasMoreItems = itemsCount > 0 && request.offset < response.object_count;
    } while (hasMoreItems);
    return result;
  }
  logout() {
    this.clearAuthData();
  }
  async refreshToken(token) {
    const body = this.utilsSvc.getUrlEncodedRefreshTokenObject(token || this.refreshTokenInfo?.value);
    try {
      const response = await this.postWithHeaders(this.utilsSvc.getAuthTokenUrl(), body, this.formUrlEncodedHeader, null, 'refreshToken');
      this.tokenRetrievedAtMilliseconds = this.utilsSvc.getNow();
      const authResult = this.processInternalAuthenticationResponse(response);
      await this.setUserScopesToToken(authResult.token.u);
      return authResult;
    } catch (error) {
      // err is most likely instanceof AzavistaApiError (if this.post failed)
      // Probably network error or something else happened during token refresh (refresh token expired too ?)
      // The current token will be still used until it expires and the server starts returning Unauthorized
      // The user must log in again
      const isNetworkError = error.communicationError?.status === 0;
      if (!isNetworkError) {
        this.utilsSvc.removeInternalAuthenticationResponseFromStorage();
      }
      return null;
    }
  }
  clearAuthData() {
    this.authenticateResponse = null;
    this.tokenRetrievedAtMilliseconds = 0;
    this.utilsSvc.removeInternalAuthenticationResponseFromStorage();
    this.accessTokenInfo = null;
    this.refreshTokenInfo = null;
    this.authorizationHeaderValue = '';
  }
  async getAny(path, caller, ignoreHttpErrorsList, queryParams) {
    const req = this.createRequest('GET', path, null, queryParams, null, 'blob');
    const blob = await this.request(req, caller, ignoreHttpErrorsList);
    return blob;
  }
  async get(path, caller, ignoreHttpErrorsList) {
    const req = this.createRequest('GET', path);
    return this.request(req, caller, ignoreHttpErrorsList);
  }
  async getPaged(path, pagedRequest, caller) {
    const response = await this.getWithQuery(path, this.utilsSvc.sanitizePagedRequest(pagedRequest), caller);
    return response;
  }
  async getWithQuery(path, queryParams, caller) {
    const req = this.createRequest('GET', path, null, queryParams);
    return this.request(req, caller);
  }
  async getWithResponseType(path, responseType, caller) {
    const req = this.createRequest('GET', path, null, null, null, responseType);
    return this.request(req, caller);
  }
  async put(path, body, caller) {
    const req = this.createRequest('PUT', path, body);
    return this.request(req, caller);
  }
  async putWithHeaders(path, body, headers, queryParams, caller) {
    const req = this.createRequest('PUT', path, body, queryParams, headers);
    return this.request(req, caller);
  }
  async putWithQuery(path, body, queryParams, caller) {
    const req = this.createRequest('PUT', path, body, queryParams);
    return this.request(req, caller);
  }
  async patch(path, body, caller, ignoreHttpErrorsList) {
    const req = this.createRequest('PATCH', path, body);
    return this.request(req, caller, ignoreHttpErrorsList);
  }
  async delete(path, caller) {
    const req = this.createRequest('DELETE', path);
    return this.request(req, caller);
  }
  async post(path, body, caller, ignoreHttpErrorsList) {
    const req = this.createRequest('POST', path, body);
    return this.request(req, caller, ignoreHttpErrorsList);
  }
  async postWithQuery(path, body, queryParams, caller) {
    const req = this.createRequest('POST', path, body, queryParams);
    return this.request(req, caller);
  }
  async postPagedRequest(path, body, pagedRequest, caller) {
    const response = await this.postWithQuery(path, body, this.utilsSvc.sanitizePagedRequest(pagedRequest), caller);
    return response;
  }
  async postWithHeaders(path, body, headers, queryParams, caller) {
    const req = this.createRequest('POST', path, body, queryParams, headers);
    return this.request(req, caller);
  }
  processInternalAuthenticationResponseFromStorage() {
    // Get auth response from local storage and use it if not yet expired
    const internalAuthResponse = this.utilsSvc.getInternalAuthenticationResponseFromStorage();
    this.authenticateResponse = internalAuthResponse;
    if (internalAuthResponse) {
      const accessTokenInfo = this.utilsSvc.getTokenInfo(internalAuthResponse.access_token);
      // accessTokenInfo.payload.exp is in seconds
      // const usableNotAfter = this.utilsSvc.getTokenUsableNotAfter(this.tokenRetrievedAtMilliseconds, this.authenticateResponse.expires_in);
      // if (this.utilsSvc.getNow() < usableNotAfter) {
      //     // The access token is not too old
      //     const authenticateResponse = this.processInternalAuthenticationResponse(internalAuthResponse);
      //     return { authResponse: authenticateResponse, internalAuthResponse: internalAuthResponse };
      // } else {
      //     // The access token is too old - remove it from storage
      //     this.utilsSvc.removeInternalAuthenticationResponseFromStorage();
      //     return undefined;
      // }
      const authenticateResponse = this.processInternalAuthenticationResponse(internalAuthResponse);
      return {
        authResponse: authenticateResponse,
        internalAuthResponse: internalAuthResponse
      };
    } else {
      return undefined;
    }
  }
  processInternalAuthenticationResponse(internalAuthResponse) {
    this.authenticateResponse = internalAuthResponse;
    this.utilsSvc.storeInternalAuthenticationResponse(internalAuthResponse);
    this.authorizationHeaderValue = this.utilsSvc.getAuthorizationHeaderFromResponse(internalAuthResponse);
    this.accessTokenInfo = this.utilsSvc.getTokenInfo(internalAuthResponse.access_token);
    delete this.accessTokenInfo.payload.s;
    this.refreshTokenInfo = this.utilsSvc.getTokenInfo(internalAuthResponse.refresh_token);
    // const remainingTimeUntilTokenRefresh =
    //     this.utilsSvc.getTokenUsableNotAfter(this.accessTokenInfo.payload.exp) - this.utilsSvc.getNow();
    const authRes = {
      token: this.accessTokenInfo.payload
    };
    return authRes;
  }
  isCurrentUser(userId) {
    const currentUserId = this.accessTokenInfo.payload.u;
    return userId === currentUserId;
  }
  async setCurrentUserFromTokenInfo() {
    const currentUserId = this.accessTokenInfo.payload.u;
    const user = await this.getUser(currentUserId);
    this.setCurrentUser(user);
  }
  // Project / Task Management
  async createProject(createprojectRequest, project_type) {
    const url = this.utilsSvc.getProjectCreateUrl();
    const payload = createprojectRequest;
    const queryParams = {
      project_type
    };
    const response = await this.postWithQuery(url, payload, queryParams, 'createProject');
    return response;
  }
  async copyProject(projectId, project_type, copyProjectRequest) {
    const url = this.utilsSvc.getProjectCopyUrl(projectId);
    const payload = copyProjectRequest;
    const queryParams = {
      project_type
    };
    const response = await this.postWithQuery(url, payload, queryParams, 'copyProject');
    return response;
  }
  async getProject(projectId) {
    const url = this.utilsSvc.getProjectGetUrl(projectId);
    const response = await this.get(url, 'getProject');
    return response;
  }
  async updateProject(projectId, updateProjectRequest) {
    const url = this.utilsSvc.getProjectUpdateUrl(projectId);
    const payload = updateProjectRequest;
    const response = await this.patch(url, payload, 'updateProject');
    return response;
  }
  async deleteProject(projectId) {
    const url = this.utilsSvc.getProjectDeleteUrl(projectId);
    await this.delete(url, 'deleteProject');
  }
  /**
   * @param projectType default = `ProjectType.project`
   * @returns
   */
  async searchProject(req, project_type = ProjectType.project) {
    const path = this.utilsSvc.getProjectSearchUrl();
    const payload = this.utilsSvc.getProjectSearchPayload(req);
    const queryParams = {
      ...this.utilsSvc.sanitizePagedRequest(req),
      project_type
    };
    const res = await this.postWithQuery(path, payload, queryParams, 'searchProject');
    return res;
  }
  // Project Category
  async createProjectCategory(createCategoryRequest) {
    const url = this.utilsSvc.getProjectCategoryCreateUrl();
    const payload = createCategoryRequest;
    const response = await this.postWithQuery(url, payload, {}, 'createProjectCategory');
    return response;
  }
  async updateProjectCategory(categoryId, updateCategoryRequest) {
    const url = this.utilsSvc.getProjectCategoryUpdateUrl(categoryId);
    const payload = updateCategoryRequest;
    const response = await this.patch(url, payload, 'updateProjectCategory');
    return response;
  }
  async deleteProjectCategory(categoryId) {
    const url = this.utilsSvc.getProjectCategoryDeleteUrl(categoryId);
    await this.delete(url, 'deleteProjectCategory');
  }
  async searchProjectCategory(req) {
    const path = this.utilsSvc.getProjectCategorySearchUrl();
    const payload = this.utilsSvc.getProjectCategorySearcPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const res = await this.postWithQuery(path, payload, queryParams, 'searchProjectCategory');
    return res;
  }
  async getAllProjectCategory() {
    return this.getAllPagedItems(req => this.searchProjectCategory(req), res => res.categories);
  }
  // Project Teams
  async addProjectTeams(projectId, teamIds) {
    const path = this.utilsSvc.getProjectAddTeamUrl(projectId);
    const payload = {
      team_ids: teamIds
    };
    await this.postWithQuery(path, payload, {}, 'addProjectTeams');
  }
  async removeProjectTeams(projectId, teamIds) {
    const path = this.utilsSvc.getProjectRemoveTeamUrl(projectId);
    const payload = {
      team_ids: teamIds
    };
    await this.postWithQuery(path, payload, {}, 'removeProjectTeams');
  }
  // Project Teams
  async addProjectEvents(projectId, eventIds) {
    const path = this.utilsSvc.getProjectAddEventUrl(projectId);
    const payload = {
      event_ids: eventIds
    };
    await this.postWithQuery(path, payload, {}, 'addProjectEvents');
  }
  async removeProjectEvents(projectId, eventIds) {
    const path = this.utilsSvc.getProjectRemoveEventUrl(projectId);
    const payload = {
      event_ids: eventIds
    };
    await this.postWithQuery(path, payload, {}, 'removeProjectEvents');
  }
  // Project - Tasks
  async createProjectTask(projectId, createtaskRequest) {
    const url = this.utilsSvc.getProjectTaskCreateUrl(projectId);
    const payload = createtaskRequest;
    await this.post(url, payload, 'createProjectTask');
  }
  async getProjectTask(taskId) {
    const url = this.utilsSvc.getProjectTaskGetUrl(taskId);
    const response = await this.get(url, 'getProjectTask');
    return response;
  }
  async updateProjectTask(taskId, updateTaskRequest) {
    const url = this.utilsSvc.getProjectTaskUpdateUrl(taskId);
    const payload = updateTaskRequest;
    const response = await this.patch(url, payload, 'updateProjectTask');
    return response;
  }
  async deleteProjectTask(taskId) {
    const url = this.utilsSvc.getProjectTaskDeleteUrl(taskId);
    await this.delete(url, 'deleteProjectTask');
  }
  async searchProjectTask(projectId, req) {
    const path = this.utilsSvc.getProjectTasksSearchUrl(projectId);
    const payload = this.utilsSvc.getProjectTaskSearchPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const res = await this.postWithQuery(path, payload, queryParams, 'searchProjectTask');
    return res;
  }
  async bulkDeleteProjectTask(projectId, req) {
    const path = this.utilsSvc.getProjectTasksBulkDeleteUrl(projectId);
    const payload = this.utilsSvc.getProjectTaskSearchPayload(req);
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const res = await this.postWithQuery(path, payload, queryParams, 'bulkDeleteProjectTask');
    return res;
  }
  async bulkUpdateStatusProjectTask(projectId, status, req) {
    const path = this.utilsSvc.getProjectTasksBulkUpdateStatusUrl(projectId);
    const payload = {
      ...this.utilsSvc.getProjectTaskSearchPayload(req),
      value: status
    };
    const queryParams = this.utilsSvc.sanitizePagedRequest(req);
    const res = await this.postWithQuery(path, payload, queryParams, 'bulkUpdateStatusProjectTask');
    return res;
  }
  async addProjectTaskTeams(taskId, teamIds) {
    const url = this.utilsSvc.getProjectTaskAssignTeamsUrl(taskId);
    const payload = {
      team_ids: teamIds
    };
    await this.post(url, payload, 'addProjectTaskTeams');
  }
  async removeProjectTaskTeams(taskId, teamIds) {
    const url = this.utilsSvc.getProjectTaskUnassignTeamsUrl(taskId);
    const payload = {
      team_ids: teamIds
    };
    await this.post(url, payload, 'removeProjectTaskTeams');
  }
  async addProjectTaskUsers(taskId, userIds) {
    const url = this.utilsSvc.getProjectTaskAssignUsersUrl(taskId);
    const payload = {
      user_ids: userIds
    };
    await this.post(url, payload, 'addProjectTaskUsers');
  }
  async removeProjectTaskUsers(taskId, userIds) {
    const url = this.utilsSvc.getProjectTaskUnassignUsersUrl(taskId);
    const payload = {
      user_ids: userIds
    };
    await this.post(url, payload, 'removeProjectTaskUsers');
  }
  createRequest(method, url, body, queryParams, headers, responseType) {
    const req = this.utilsSvc.createRequest(method, url, this.authorizationHeaderValue, body, queryParams, headers, responseType);
    return req;
  }
}
let AzavistaApiService = /*#__PURE__*/(() => {
  class AzavistaApiService extends AzavistaApiServiceBase {
    constructor(http, utilsSvc) {
      super(utilsSvc);
      this.http = http;
      this.utilsSvc = utilsSvc;
      this.errorSubject = new Subject();
      this.ignoredErrorSubject = new Subject();
      this.successSubject = new Subject();
      this.authenticationSubject = new Subject();
      this.currentUserBehaviorSubject = new BehaviorSubject(null);
    }
    // Report
    getReport(request) {
      const subject = new Subject();
      const retriesCount = request.retriesCount || 10;
      const maxDelayBetweenRetries = request.maxDelayBetweenRetries || 3000;
      // Start polling on the next loop so we can return the subject and still have polling later
      setTimeout(async () => {
        let response;
        const path = this.utilsSvc.getReportUrl(request.reportType, request.widgetId);
        let lastErr;
        for (let i = 0; i < retriesCount; i++) {
          try {
            if (subject.observers.length === 0) {
              // Every subscriber unsubscribed - stop polling
              break;
            }
            response = await this.post(path, request.payload, 'getReport');
            if (response.data) {
              subject.next(response);
            }
            if (response.status === 'cached' || response.status === 'error') {
              // Report is available or in error state - return the response
              break;
            }
          } catch (err) {
            lastErr = err;
          }
          if (subject.observers.length === 0) {
            // Every subscriber unsubscribed - stop polling
            break;
          }
          const isLastIteration = i === retriesCount - 1;
          if (!isLastIteration) {
            const currentDelay = Math.min((i + 1) * 1000, maxDelayBetweenRetries);
            await this.delay(currentDelay);
          }
        }
        if (response) {
          subject.next(response);
        } else if (lastErr) {
          subject.error(lastErr);
        }
        subject.complete();
      }, 0);
      return subject;
    }
    // Document
    updateDocumentFile(documentId, file) {
      const path = this.utilsSvc.getDocumentUpdateUrl(documentId);
      const queryParams = {
        filename: file.name
      };
      const headers = new HttpHeaders({
        Authorization: this.authorizationHeaderValue
      });
      const req = new HttpRequest('PUT', path, file, {
        headers: headers,
        reportProgress: true,
        params: new HttpParams({
          fromObject: queryParams
        })
      });
      return this.http.request(req);
    }
    uploadEntityDocumentFile(entityType, entityId, file, entityOptions) {
      const path = this.getDocumentUploadUrl(entityType, entityId);
      const queryParams = {
        ...entityOptions?.queryParams,
        filename: file.name
      };
      const headers = new HttpHeaders({
        Authorization: this.authorizationHeaderValue
      });
      const req = new HttpRequest('POST', path, file, {
        headers: headers,
        reportProgress: true,
        params: new HttpParams({
          fromObject: queryParams
        })
      });
      return this.http.request(req);
    }
    importEvent(eventDetail, teamIds, /** File of *.zip, or full-path URL */
    zipFile, globalEntity, options) {
      const path = this.utilsSvc.getEventImportUrl();
      const queryParams = {
        ...options
      };
      const sanitizedEvent = this.utilsSvc.sanitizeEvent(eventDetail);
      const headers = new HttpHeaders({
        Authorization: this.authorizationHeaderValue
      });
      const formData = new FormData();
      if (zipFile instanceof File) {
        formData.set('import', zipFile);
      }
      if (typeof zipFile === 'string') {
        formData.set('import_file_url', zipFile);
      }
      formData.set('event', JSON.stringify(sanitizedEvent));
      formData.set('team_ids', JSON.stringify(teamIds));
      Object.values(globalEntity).forEach(globalEntityItem => {
        Object.entries(globalEntityItem).forEach(([key, value]) => {
          if (value != null) {
            formData.set(key, typeof value === 'object' ? JSON.stringify(value) : value);
          }
        });
      });
      const req = new HttpRequest('POST', path, formData, {
        headers: headers,
        reportProgress: true,
        params: new HttpParams({
          fromObject: queryParams
        })
      });
      return this.http.request(req);
    }
    getCurrentUser() {
      return this.currentUserBehaviorSubject.value;
    }
    setCurrentUser(user) {
      this.currentUserBehaviorSubject.next(user);
    }
    async request(req, caller, ignoreHttpErrorsList) {
      let result;
      try {
        if (this.accessTokenInfo) {
          const isAuthRequest = req.url === this.authTokenUrl;
          if (!isAuthRequest) {
            // If the token is expired, first refresh it
            const accessTokenExpirationDate = this.utilsSvc.getTokenUsableNotAfter(this.tokenRetrievedAtMilliseconds, this.authenticateResponse.expires_in * 1000);
            const now = this.utilsSvc.getNow();
            if (now > accessTokenExpirationDate) {
              // This will set new authorization header value etc.
              this.authorizationHeaderValue = '';
              const authenticateResponse = await this.refreshToken();
              if (authenticateResponse) {
                req = this.utilsSvc.replaceAuthorizationHeaderValue(req, this.authorizationHeaderValue);
              } else {
                // TODO: Refresh failed - this will cause using expired auth token and error notfications to the user
                //       Should we have specific notification for this case so the UI can show a button
                //       for navigating to sign-in ?
              }
            }
          }
        }
        this.lastRequestTime = this.utilsSvc.getNow();
        const promise = this.http.request(req).toPromise();
        const httpEvent = await promise;
        const httpResponse = httpEvent;
        result = httpResponse.body;
        this.successSubject.next({
          url: req.urlWithParams,
          method: req.method,
          body: req.body,
          result: result,
          caller: caller
        });
      } catch (err) {
        const errObj = this.utilsSvc.createError(err);
        let shouldIgnoreError = false;
        if (errObj.communicationError && ignoreHttpErrorsList && ignoreHttpErrorsList.indexOf(errObj.communicationError.status) >= 0) {
          shouldIgnoreError = true;
        }
        const errorSubjectItem = {
          error: errObj,
          url: req.urlWithParams,
          method: req.method,
          body: req.body,
          caller: caller
        };
        if (!shouldIgnoreError) {
          this.errorSubject.next(errorSubjectItem);
          throw errObj;
        } else if (shouldIgnoreError) {
          this.ignoredErrorSubject.next(errorSubjectItem);
        }
      }
      return result;
    }
    subscribeToCurrentUser(observer) {
      return this.currentUserBehaviorSubject.subscribe(observer);
    }
    subscribeToErrorNotifications(observer) {
      return this.errorSubject.subscribe(observer);
    }
    subscribeToIgnoredErrorNotifications(observer) {
      return this.ignoredErrorSubject.subscribe(observer);
    }
    getIgnoredErrorNotificationsObserver() {
      return this.ignoredErrorSubject.asObservable();
    }
    subscribeToSuccessNotifications(observer) {
      return this.successSubject.subscribe(observer);
    }
    subscribeToAuthenticationNotifications(observer) {
      return this.authenticationSubject.subscribe(observer);
    }
    authenticationSubjectPublish(tokenPayload) {
      this.authenticationSubject.next(tokenPayload);
    }
    async applyInternalAuthResponseResult(processInternalAuthResponseResult) {
      const result = await super.applyInternalAuthResponseResult(processInternalAuthResponseResult);
      this.authenticationSubject.next(processInternalAuthResponseResult.authResponse.token);
      return result;
    }
    clearAuthData() {
      super.clearAuthData();
      this.authenticationSubject.next(null);
      this.currentUserBehaviorSubject.next(null);
    }
    async authenticate(req) {
      const authResult = await super.authenticate(req);
      this.authenticationSubject.next(authResult.token);
      return authResult;
    }
    static {
      this.ɵfac = function AzavistaApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AzavistaApiUtilsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaApiService,
        factory: AzavistaApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaServicelibModule = /*#__PURE__*/(() => {
  class AzavistaServicelibModule {
    static {
      this.ɵfac = function AzavistaServicelibModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaServicelibModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaServicelibModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideHttpClient(withInterceptorsFromDi())]
      });
    }
  }
  return AzavistaServicelibModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of servicelib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActivityParticipantStatus, AzavistaApiError, AzavistaApiService, AzavistaApiUtilsService, AzavistaServicelibModule, EmailCampaignAudienceModuleType, EmailCampaignDeliveryStatus, EmailTemplatePageSubtypes, EntityIdType, FieldOperator, IAccountingIntegrationLogStatus, IExternalFieldMappingAzavistaEntity, IExternalFieldMappingFieldType, IProjectStatus, IProjectTaskPriority, IProjectTaskStatus, ISap001IntegrationMappingExternalEntityType, IngenicoIntegrationAuthorizationMode, IntegrationExternalCrmVersion, MessageBirdApiType, PagePageTypeSubtypes, PageSubtype, PageTypesWithSubtypes, ParticipantAuditUserType, PayOneIntegrationAuthorizationMode, ProductModuleType, ProfilePageTypeSubtypes, ProjectType, SocialPlatform, SystemPageSubtypes, ThemePageTypeSubtypes, WaitUntilFieldStepFieldType, WebhookAuthType, convertDependencyToV2, omit, pick };
